export function getTrack(): {
	latitude: number
	longitude: number
	course?: null | number | undefined
	heading?: null | number
	speed?: null | number
	timestamp?: string
}[] {
	return [
		{
			latitude: 42.81,
			longitude: 31.31166667,
			timestamp: "2026-01-01",
		},
		{
			latitude: 42.81,
			longitude: 31.31166667,
		},
		{
			latitude: 42.81,
			longitude: 31.31166667,
		},
		{
			latitude: 42.81,
			longitude: 31.31333333,
		},
		{
			latitude: 42.81,
			longitude: 31.31166667,
		},
		{
			latitude: 42.81,
			longitude: 31.31166667,
		},
		{
			latitude: 42.81,
			longitude: 31.31166667,
		},
		{
			latitude: 42.81,
			longitude: 31.31166667,
		},
		{
			latitude: 42.80833333,
			longitude: 31.31166667,
		},
		{
			latitude: 42.80833333,
			longitude: 31.31166667,
		},
		{
			latitude: 42.80833333,
			longitude: 31.31166667,
		},
		{
			latitude: 42.80916833,
			longitude: 31.31212,
		},
		{
			latitude: 42.80917333,
			longitude: 31.31214167,
		},
		{
			latitude: 42.80917667,
			longitude: 31.31213167,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31213667,
		},
		{
			latitude: 42.80917667,
			longitude: 31.31213667,
		},
		{
			latitude: 42.80917667,
			longitude: 31.31213167,
		},
		{
			latitude: 42.80917333,
			longitude: 31.31213,
		},
		{
			latitude: 42.80917667,
			longitude: 31.31214333,
		},
		{
			latitude: 42.80917333,
			longitude: 31.31213667,
		},
		{
			latitude: 42.809175,
			longitude: 31.31213667,
		},
		{
			latitude: 42.80917333,
			longitude: 31.31213333,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31212667,
		},
		{
			latitude: 42.80916833,
			longitude: 31.312245,
		},
		{
			latitude: 42.80915667,
			longitude: 31.31247333,
		},
		{
			latitude: 42.80915833,
			longitude: 31.31246,
		},
		{
			latitude: 42.80915833,
			longitude: 31.31245833,
		},
		{
			latitude: 42.80915667,
			longitude: 31.312465,
		},
		{
			latitude: 42.80915833,
			longitude: 31.31246167,
		},
		{
			latitude: 42.80915667,
			longitude: 31.31245167,
		},
		{
			latitude: 42.80918,
			longitude: 31.31248,
		},
		{
			latitude: 42.80955333,
			longitude: 31.31190833,
		},
		{
			latitude: 42.80988167,
			longitude: 31.31138333,
		},
		{
			latitude: 42.81011667,
			longitude: 31.31101,
		},
		{
			latitude: 42.81011667,
			longitude: 31.311015,
		},
		{
			latitude: 42.810115,
			longitude: 31.31103,
		},
		{
			latitude: 42.81011667,
			longitude: 31.31102333,
		},
		{
			latitude: 42.81011833,
			longitude: 31.31102667,
		},
		{
			latitude: 42.810115,
			longitude: 31.31102167,
		},
		{
			latitude: 42.81011667,
			longitude: 31.31103,
		},
		{
			latitude: 42.81011667,
			longitude: 31.31101667,
		},
		{
			latitude: 42.810115,
			longitude: 31.31101667,
		},
		{
			latitude: 42.81011667,
			longitude: 31.311015,
		},
		{
			latitude: 42.81012,
			longitude: 31.311015,
		},
		{
			latitude: 42.81011667,
			longitude: 31.31102167,
		},
		{
			latitude: 42.81011333,
			longitude: 31.31102667,
		},
		{
			latitude: 42.810115,
			longitude: 31.311025,
		},
		{
			latitude: 42.810115,
			longitude: 31.31102,
		},
		{
			latitude: 42.810115,
			longitude: 31.311005,
		},
		{
			latitude: 42.810115,
			longitude: 31.31101333,
		},
		{
			latitude: 42.81011333,
			longitude: 31.311015,
		},
		{
			latitude: 42.81011333,
			longitude: 31.31101667,
		},
		{
			latitude: 42.81011333,
			longitude: 31.31101,
		},
		{
			latitude: 42.81011333,
			longitude: 31.31102667,
		},
		{
			latitude: 42.810115,
			longitude: 31.31102333,
		},
		{
			latitude: 42.810855,
			longitude: 31.312165,
		},
		{
			latitude: 42.81318667,
			longitude: 31.320325,
		},
		{
			latitude: 42.81031667,
			longitude: 31.33063167,
		},
		{
			latitude: 42.80396667,
			longitude: 31.33778333,
		},
		{
			latitude: 42.79657667,
			longitude: 31.33960167,
		},
		{
			latitude: 42.79197,
			longitude: 31.34124833,
		},
		{
			latitude: 42.791625,
			longitude: 31.34074667,
		},
		{
			latitude: 42.79161833,
			longitude: 31.34073167,
		},
		{
			latitude: 42.79161667,
			longitude: 31.34073833,
		},
		{
			latitude: 42.791625,
			longitude: 31.34073667,
		},
		{
			latitude: 42.791635,
			longitude: 31.34138333,
		},
		{
			latitude: 42.791635,
			longitude: 31.34152,
		},
		{
			latitude: 42.791645,
			longitude: 31.34153,
		},
		{
			latitude: 42.79164667,
			longitude: 31.341535,
		},
		{
			latitude: 42.79164333,
			longitude: 31.34153167,
		},
		{
			latitude: 42.79163833,
			longitude: 31.341525,
		},
		{
			latitude: 42.79163833,
			longitude: 31.341525,
		},
		{
			latitude: 42.79164333,
			longitude: 31.34154,
		},
		{
			latitude: 42.79163667,
			longitude: 31.34152833,
		},
		{
			latitude: 42.79164,
			longitude: 31.34152833,
		},
		{
			latitude: 42.79163833,
			longitude: 31.341525,
		},
		{
			latitude: 42.79164167,
			longitude: 31.34153167,
		},
		{
			latitude: 42.79164167,
			longitude: 31.341535,
		},
		{
			latitude: 42.79163833,
			longitude: 31.341525,
		},
		{
			latitude: 42.79164167,
			longitude: 31.34152833,
		},
		{
			latitude: 42.791645,
			longitude: 31.341535,
		},
		{
			latitude: 42.79163833,
			longitude: 31.341525,
		},
		{
			latitude: 42.79163833,
			longitude: 31.341525,
		},
		{
			latitude: 42.79163667,
			longitude: 31.34152167,
		},
		{
			latitude: 42.791635,
			longitude: 31.34152333,
		},
		{
			latitude: 42.79164167,
			longitude: 31.341535,
		},
		{
			latitude: 42.79164,
			longitude: 31.34152667,
		},
		{
			latitude: 42.79164167,
			longitude: 31.34153,
		},
		{
			latitude: 42.79164167,
			longitude: 31.34152667,
		},
		{
			latitude: 42.791645,
			longitude: 31.34153833,
		},
		{
			latitude: 42.79163667,
			longitude: 31.34152333,
		},
		{
			latitude: 42.791635,
			longitude: 31.341525,
		},
		{
			latitude: 42.79163833,
			longitude: 31.34152667,
		},
		{
			latitude: 42.79164,
			longitude: 31.34152667,
		},
		{
			latitude: 42.791635,
			longitude: 31.34152833,
		},
		{
			latitude: 42.79163833,
			longitude: 31.34153167,
		},
		{
			latitude: 42.79164333,
			longitude: 31.34153333,
		},
		{
			latitude: 42.79164,
			longitude: 31.34152833,
		},
		{
			latitude: 42.791645,
			longitude: 31.34153167,
		},
		{
			latitude: 42.79164,
			longitude: 31.34153,
		},
		{
			latitude: 42.79163667,
			longitude: 31.34152333,
		},
		{
			latitude: 42.79163833,
			longitude: 31.341525,
		},
		{
			latitude: 42.79157667,
			longitude: 31.34145167,
		},
		{
			latitude: 42.79125833,
			longitude: 31.341305,
		},
		{
			latitude: 42.79159833,
			longitude: 31.341185,
		},
		{
			latitude: 42.79160333,
			longitude: 31.34118667,
		},
		{
			latitude: 42.79160667,
			longitude: 31.34118833,
		},
		{
			latitude: 42.79160667,
			longitude: 31.34118667,
		},
		{
			latitude: 42.79161333,
			longitude: 31.34119,
		},
		{
			latitude: 42.791745,
			longitude: 31.34093,
		},
		{
			latitude: 42.79189667,
			longitude: 31.34070167,
		},
		{
			latitude: 42.791885,
			longitude: 31.340705,
		},
		{
			latitude: 42.79189167,
			longitude: 31.34070667,
		},
		{
			latitude: 42.79212333,
			longitude: 31.34027833,
		},
		{
			latitude: 42.792235,
			longitude: 31.3401,
		},
		{
			latitude: 42.79230833,
			longitude: 31.33996333,
		},
		{
			latitude: 42.79239667,
			longitude: 31.33983833,
		},
		{
			latitude: 42.79238,
			longitude: 31.33984,
		},
		{
			latitude: 42.79237167,
			longitude: 31.33983667,
		},
		{
			latitude: 42.79238833,
			longitude: 31.339835,
		},
		{
			latitude: 42.79239,
			longitude: 31.339835,
		},
		{
			latitude: 42.79238833,
			longitude: 31.339835,
		},
		{
			latitude: 42.79237833,
			longitude: 31.33983667,
		},
		{
			latitude: 42.79238333,
			longitude: 31.33983667,
		},
		{
			latitude: 42.79237833,
			longitude: 31.33983833,
		},
		{
			latitude: 42.79237833,
			longitude: 31.33984,
		},
		{
			latitude: 42.79242333,
			longitude: 31.33975667,
		},
		{
			latitude: 42.79243667,
			longitude: 31.33972833,
		},
		{
			latitude: 42.792515,
			longitude: 31.33961,
		},
		{
			latitude: 42.79259667,
			longitude: 31.33946333,
		},
		{
			latitude: 42.79267833,
			longitude: 31.33932,
		},
		{
			latitude: 42.79271667,
			longitude: 31.33926,
		},
		{
			latitude: 42.79271333,
			longitude: 31.33925833,
		},
		{
			latitude: 42.79271,
			longitude: 31.33926,
		},
		{
			latitude: 42.79271333,
			longitude: 31.33926167,
		},
		{
			latitude: 42.79271833,
			longitude: 31.33926,
		},
		{
			latitude: 42.79271333,
			longitude: 31.33926,
		},
		{
			latitude: 42.79271667,
			longitude: 31.33925833,
		},
		{
			latitude: 42.79271167,
			longitude: 31.33925833,
		},
		{
			latitude: 42.792715,
			longitude: 31.33925833,
		},
		{
			latitude: 42.79268,
			longitude: 31.33931833,
		},
		{
			latitude: 42.7926,
			longitude: 31.33945833,
		},
		{
			latitude: 42.79251833,
			longitude: 31.339605,
		},
		{
			latitude: 42.792435,
			longitude: 31.339745,
		},
		{
			latitude: 42.79235,
			longitude: 31.33989,
		},
		{
			latitude: 42.79227,
			longitude: 31.34003333,
		},
		{
			latitude: 42.79218833,
			longitude: 31.34018667,
		},
		{
			latitude: 42.79215833,
			longitude: 31.340225,
		},
		{
			latitude: 42.79215667,
			longitude: 31.34022333,
		},
		{
			latitude: 42.79216333,
			longitude: 31.34022167,
		},
		{
			latitude: 42.79215833,
			longitude: 31.34022167,
		},
		{
			latitude: 42.79215833,
			longitude: 31.34022167,
		},
		{
			latitude: 42.79217,
			longitude: 31.34022167,
		},
		{
			latitude: 42.79216,
			longitude: 31.34022333,
		},
		{
			latitude: 42.79215833,
			longitude: 31.34022333,
		},
		{
			latitude: 42.792165,
			longitude: 31.340225,
		},
		{
			latitude: 42.79216333,
			longitude: 31.34022167,
		},
		{
			latitude: 42.79215833,
			longitude: 31.340225,
		},
		{
			latitude: 42.792165,
			longitude: 31.34022333,
		},
		{
			latitude: 42.79216167,
			longitude: 31.34022167,
		},
		{
			latitude: 42.792245,
			longitude: 31.340085,
		},
		{
			latitude: 42.792325,
			longitude: 31.33993667,
		},
		{
			latitude: 42.79240833,
			longitude: 31.33980167,
		},
		{
			latitude: 42.79248167,
			longitude: 31.33965833,
		},
		{
			latitude: 42.79257167,
			longitude: 31.33951333,
		},
		{
			latitude: 42.79266333,
			longitude: 31.33937167,
		},
		{
			latitude: 42.792665,
			longitude: 31.339355,
		},
		{
			latitude: 42.792665,
			longitude: 31.339355,
		},
		{
			latitude: 42.79266167,
			longitude: 31.33935333,
		},
		{
			latitude: 42.792665,
			longitude: 31.339355,
		},
		{
			latitude: 42.79266333,
			longitude: 31.33935333,
		},
		{
			latitude: 42.79266667,
			longitude: 31.33935333,
		},
		{
			latitude: 42.79266,
			longitude: 31.339355,
		},
		{
			latitude: 42.79266833,
			longitude: 31.33935333,
		},
		{
			latitude: 42.79258,
			longitude: 31.33940833,
		},
		{
			latitude: 42.79246167,
			longitude: 31.33957333,
		},
		{
			latitude: 42.792445,
			longitude: 31.33960167,
		},
		{
			latitude: 42.79245167,
			longitude: 31.33959333,
		},
		{
			latitude: 42.79245333,
			longitude: 31.33959,
		},
		{
			latitude: 42.79244833,
			longitude: 31.3396,
		},
		{
			latitude: 42.79245333,
			longitude: 31.33959167,
		},
		{
			latitude: 42.79246,
			longitude: 31.33958,
		},
		{
			latitude: 42.79240333,
			longitude: 31.33950833,
		},
		{
			latitude: 42.79221167,
			longitude: 31.33923667,
		},
		{
			latitude: 42.79220667,
			longitude: 31.33923667,
		},
		{
			latitude: 42.79220333,
			longitude: 31.33924,
		},
		{
			latitude: 42.7922,
			longitude: 31.339245,
		},
		{
			latitude: 42.792325,
			longitude: 31.33894,
		},
		{
			latitude: 42.79260833,
			longitude: 31.33827667,
		},
		{
			latitude: 42.79286667,
			longitude: 31.337675,
		},
		{
			latitude: 42.79318667,
			longitude: 31.33705833,
		},
		{
			latitude: 42.79354167,
			longitude: 31.33650833,
		},
		{
			latitude: 42.79389333,
			longitude: 31.33589333,
		},
		{
			latitude: 42.79399833,
			longitude: 31.335715,
		},
		{
			latitude: 42.79401167,
			longitude: 31.335685,
		},
		{
			latitude: 42.793995,
			longitude: 31.33571333,
		},
		{
			latitude: 42.79411167,
			longitude: 31.33546167,
		},
		{
			latitude: 42.79439167,
			longitude: 31.33479667,
		},
		{
			latitude: 42.79466333,
			longitude: 31.33415167,
		},
		{
			latitude: 42.79492167,
			longitude: 31.33355,
		},
		{
			latitude: 42.79521333,
			longitude: 31.33296833,
		},
		{
			latitude: 42.79551667,
			longitude: 31.332355,
		},
		{
			latitude: 42.79582167,
			longitude: 31.33173667,
		},
		{
			latitude: 42.79590833,
			longitude: 31.33155167,
		},
		{
			latitude: 42.79593,
			longitude: 31.33152667,
		},
		{
			latitude: 42.79592333,
			longitude: 31.33153833,
		},
		{
			latitude: 42.795925,
			longitude: 31.33153167,
		},
		{
			latitude: 42.79591333,
			longitude: 31.33155,
		},
		{
			latitude: 42.79593,
			longitude: 31.33152,
		},
		{
			latitude: 42.79591833,
			longitude: 31.33154167,
		},
		{
			latitude: 42.79591167,
			longitude: 31.33155,
		},
		{
			latitude: 42.79592833,
			longitude: 31.33152667,
		},
		{
			latitude: 42.79592833,
			longitude: 31.33152167,
		},
		{
			latitude: 42.79592667,
			longitude: 31.331525,
		},
		{
			latitude: 42.79591667,
			longitude: 31.331435,
		},
		{
			latitude: 42.79681,
			longitude: 31.32338667,
		},
		{
			latitude: 42.79967833,
			longitude: 31.307595,
		},
		{
			latitude: 42.806385,
			longitude: 31.29211333,
		},
		{
			latitude: 42.81388,
			longitude: 31.275805,
		},
		{
			latitude: 42.82129333,
			longitude: 31.26007667,
		},
		{
			latitude: 42.82745667,
			longitude: 31.24618,
		},
		{
			latitude: 42.83429667,
			longitude: 31.23078667,
		},
		{
			latitude: 42.841115,
			longitude: 31.21566,
		},
		{
			latitude: 42.84651667,
			longitude: 31.206265,
		},
		{
			latitude: 42.84745833,
			longitude: 31.20589167,
		},
		{
			latitude: 42.84725167,
			longitude: 31.20622667,
		},
		{
			latitude: 42.84725333,
			longitude: 31.206225,
		},
		{
			latitude: 42.84728833,
			longitude: 31.20616167,
		},
		{
			latitude: 42.84728333,
			longitude: 31.20618333,
		},
		{
			latitude: 42.847375,
			longitude: 31.20627667,
		},
		{
			latitude: 42.84758667,
			longitude: 31.206425,
		},
		{
			latitude: 42.84759,
			longitude: 31.20642167,
		},
		{
			latitude: 42.8476,
			longitude: 31.20642667,
		},
		{
			latitude: 42.84758833,
			longitude: 31.20645,
		},
		{
			latitude: 42.84758333,
			longitude: 31.20644833,
		},
		{
			latitude: 42.84759333,
			longitude: 31.20641667,
		},
		{
			latitude: 42.84760333,
			longitude: 31.20640667,
		},
		{
			latitude: 42.84757333,
			longitude: 31.20646,
		},
		{
			latitude: 42.84760333,
			longitude: 31.20641167,
		},
		{
			latitude: 42.84757667,
			longitude: 31.20646833,
		},
		{
			latitude: 42.84760333,
			longitude: 31.20640167,
		},
		{
			latitude: 42.847605,
			longitude: 31.206405,
		},
		{
			latitude: 42.84759667,
			longitude: 31.20641667,
		},
		{
			latitude: 42.84760833,
			longitude: 31.20641167,
		},
		{
			latitude: 42.84759833,
			longitude: 31.20641333,
		},
		{
			latitude: 42.84760333,
			longitude: 31.20642333,
		},
		{
			latitude: 42.84758833,
			longitude: 31.20643833,
		},
		{
			latitude: 42.84759333,
			longitude: 31.20641667,
		},
		{
			latitude: 42.84759,
			longitude: 31.20641333,
		},
		{
			latitude: 42.847575,
			longitude: 31.20642667,
		},
		{
			latitude: 42.84760167,
			longitude: 31.20642,
		},
		{
			latitude: 42.84761,
			longitude: 31.20638833,
		},
		{
			latitude: 42.84759333,
			longitude: 31.20642833,
		},
		{
			latitude: 42.84758333,
			longitude: 31.20642667,
		},
		{
			latitude: 42.8476,
			longitude: 31.206415,
		},
		{
			latitude: 42.8476,
			longitude: 31.20642,
		},
		{
			latitude: 42.847605,
			longitude: 31.20641167,
		},
		{
			latitude: 42.84761333,
			longitude: 31.2064,
		},
		{
			latitude: 42.84758833,
			longitude: 31.20643333,
		},
		{
			latitude: 42.84764667,
			longitude: 31.20631,
		},
		{
			latitude: 42.84780333,
			longitude: 31.20598,
		},
		{
			latitude: 42.847935,
			longitude: 31.20573333,
		},
		{
			latitude: 42.84807333,
			longitude: 31.20538167,
		},
		{
			latitude: 42.84808,
			longitude: 31.20537333,
		},
		{
			latitude: 42.84805667,
			longitude: 31.20537333,
		},
		{
			latitude: 42.84819167,
			longitude: 31.20545667,
		},
		{
			latitude: 42.84840167,
			longitude: 31.20565833,
		},
		{
			latitude: 42.84864167,
			longitude: 31.20584833,
		},
		{
			latitude: 42.84887167,
			longitude: 31.206045,
		},
		{
			latitude: 42.84909,
			longitude: 31.20623833,
		},
		{
			latitude: 42.84932833,
			longitude: 31.20643,
		},
		{
			latitude: 42.84955667,
			longitude: 31.20663167,
		},
		{
			latitude: 42.84978,
			longitude: 31.20683333,
		},
		{
			latitude: 42.85003667,
			longitude: 31.207095,
		},
		{
			latitude: 42.85026167,
			longitude: 31.2072,
		},
		{
			latitude: 42.85046833,
			longitude: 31.20741833,
		},
		{
			latitude: 42.850555,
			longitude: 31.207465,
		},
		{
			latitude: 42.85045333,
			longitude: 31.20763833,
		},
		{
			latitude: 42.85218833,
			longitude: 31.209705,
		},
		{
			latitude: 42.85602,
			longitude: 31.21359333,
		},
		{
			latitude: 42.85975667,
			longitude: 31.21687833,
		},
		{
			latitude: 42.86207333,
			longitude: 31.2176,
		},
		{
			latitude: 42.862645,
			longitude: 31.21728833,
		},
		{
			latitude: 42.86261333,
			longitude: 31.21731667,
		},
		{
			latitude: 42.86259833,
			longitude: 31.217325,
		},
		{
			latitude: 42.86261,
			longitude: 31.21731333,
		},
		{
			latitude: 42.86264,
			longitude: 31.21759167,
		},
		{
			latitude: 42.862685,
			longitude: 31.21795833,
		},
		{
			latitude: 42.86271333,
			longitude: 31.21831,
		},
		{
			latitude: 42.86272333,
			longitude: 31.21827333,
		},
		{
			latitude: 42.86272167,
			longitude: 31.218295,
		},
		{
			latitude: 42.86270167,
			longitude: 31.21832333,
		},
		{
			latitude: 42.86270833,
			longitude: 31.21832833,
		},
		{
			latitude: 42.86270833,
			longitude: 31.21830667,
		},
		{
			latitude: 42.86273167,
			longitude: 31.21827833,
		},
		{
			latitude: 42.86271333,
			longitude: 31.21831333,
		},
		{
			latitude: 42.86270833,
			longitude: 31.21832833,
		},
		{
			latitude: 42.86270667,
			longitude: 31.218315,
		},
		{
			latitude: 42.86271833,
			longitude: 31.21829167,
		},
		{
			latitude: 42.86272,
			longitude: 31.21831667,
		},
		{
			latitude: 42.86271667,
			longitude: 31.218315,
		},
		{
			latitude: 42.86273167,
			longitude: 31.21827333,
		},
		{
			latitude: 42.86272,
			longitude: 31.21830167,
		},
		{
			latitude: 42.86272333,
			longitude: 31.218315,
		},
		{
			latitude: 42.86271167,
			longitude: 31.21831667,
		},
		{
			latitude: 42.86272333,
			longitude: 31.21830833,
		},
		{
			latitude: 42.862735,
			longitude: 31.218285,
		},
		{
			latitude: 42.86271167,
			longitude: 31.21831,
		},
		{
			latitude: 42.862715,
			longitude: 31.2183,
		},
		{
			latitude: 42.86272,
			longitude: 31.21830167,
		},
		{
			latitude: 42.862705,
			longitude: 31.21831667,
		},
		{
			latitude: 42.86272333,
			longitude: 31.21829833,
		},
		{
			latitude: 42.86272667,
			longitude: 31.21829833,
		},
		{
			latitude: 42.86273,
			longitude: 31.21828833,
		},
		{
			latitude: 42.86274167,
			longitude: 31.21831667,
		},
		{
			latitude: 42.862745,
			longitude: 31.21825167,
		},
		{
			latitude: 42.86273333,
			longitude: 31.21828333,
		},
		{
			latitude: 42.86269667,
			longitude: 31.21834167,
		},
		{
			latitude: 42.862715,
			longitude: 31.21832167,
		},
		{
			latitude: 42.86273,
			longitude: 31.21830167,
		},
		{
			latitude: 42.86258667,
			longitude: 31.219,
		},
		{
			latitude: 42.862445,
			longitude: 31.21971667,
		},
		{
			latitude: 42.86232667,
			longitude: 31.22042,
		},
		{
			latitude: 42.86217833,
			longitude: 31.22114667,
		},
		{
			latitude: 42.86206333,
			longitude: 31.22182833,
		},
		{
			latitude: 42.86193667,
			longitude: 31.222535,
		},
		{
			latitude: 42.86180333,
			longitude: 31.22324,
		},
		{
			latitude: 42.86172167,
			longitude: 31.22371667,
		},
		{
			latitude: 42.86173,
			longitude: 31.22368667,
		},
		{
			latitude: 42.86171667,
			longitude: 31.223715,
		},
		{
			latitude: 42.86087667,
			longitude: 31.22484833,
		},
		{
			latitude: 42.86018333,
			longitude: 31.228345,
		},
		{
			latitude: 42.85913167,
			longitude: 31.23162833,
		},
		{
			latitude: 42.85832167,
			longitude: 31.235295,
		},
		{
			latitude: 42.85728167,
			longitude: 31.23815667,
		},
		{
			latitude: 42.85736833,
			longitude: 31.24113167,
		},
		{
			latitude: 42.85718667,
			longitude: 31.24160833,
		},
		{
			latitude: 42.85718167,
			longitude: 31.24159833,
		},
		{
			latitude: 42.85723667,
			longitude: 31.241525,
		},
		{
			latitude: 42.85695167,
			longitude: 31.24168,
		},
		{
			latitude: 42.85551833,
			longitude: 31.243145,
		},
		{
			latitude: 42.85337667,
			longitude: 31.24265,
		},
		{
			latitude: 42.85147333,
			longitude: 31.25201667,
		},
		{
			latitude: 42.85503833,
			longitude: 31.261715,
		},
		{
			latitude: 42.85809333,
			longitude: 31.26982,
		},
		{
			latitude: 42.85747667,
			longitude: 31.27160167,
		},
		{
			latitude: 42.85759167,
			longitude: 31.27160333,
		},
		{
			latitude: 42.85808333,
			longitude: 31.27165833,
		},
		{
			latitude: 42.85897,
			longitude: 31.271605,
		},
		{
			latitude: 42.859065,
			longitude: 31.27163667,
		},
		{
			latitude: 42.85908167,
			longitude: 31.27161833,
		},
		{
			latitude: 42.85907667,
			longitude: 31.27163167,
		},
		{
			latitude: 42.85907667,
			longitude: 31.271625,
		},
		{
			latitude: 42.85908167,
			longitude: 31.27163167,
		},
		{
			latitude: 42.85907,
			longitude: 31.27162333,
		},
		{
			latitude: 42.85908667,
			longitude: 31.27162,
		},
		{
			latitude: 42.85906333,
			longitude: 31.271625,
		},
		{
			latitude: 42.85906333,
			longitude: 31.27164333,
		},
		{
			latitude: 42.85907,
			longitude: 31.2716,
		},
		{
			latitude: 42.85907,
			longitude: 31.27162667,
		},
		{
			latitude: 42.85909333,
			longitude: 31.27161,
		},
		{
			latitude: 42.8591,
			longitude: 31.27160833,
		},
		{
			latitude: 42.85908667,
			longitude: 31.2716,
		},
		{
			latitude: 42.85909,
			longitude: 31.27162667,
		},
		{
			latitude: 42.85909833,
			longitude: 31.271635,
		},
		{
			latitude: 42.85906833,
			longitude: 31.27162833,
		},
		{
			latitude: 42.85908167,
			longitude: 31.271605,
		},
		{
			latitude: 42.85908,
			longitude: 31.271615,
		},
		{
			latitude: 42.85907667,
			longitude: 31.27159833,
		},
		{
			latitude: 42.85908833,
			longitude: 31.27163,
		},
		{
			latitude: 42.85908333,
			longitude: 31.27160333,
		},
		{
			latitude: 42.85902,
			longitude: 31.27171,
		},
		{
			latitude: 42.859075,
			longitude: 31.27168667,
		},
		{
			latitude: 42.85903667,
			longitude: 31.27165833,
		},
		{
			latitude: 42.85903667,
			longitude: 31.27166667,
		},
		{
			latitude: 42.85904,
			longitude: 31.271675,
		},
		{
			latitude: 42.85905,
			longitude: 31.271665,
		},
		{
			latitude: 42.85904333,
			longitude: 31.271685,
		},
		{
			latitude: 42.85908,
			longitude: 31.27163,
		},
		{
			latitude: 42.859075,
			longitude: 31.271645,
		},
		{
			latitude: 42.85903167,
			longitude: 31.271655,
		},
		{
			latitude: 42.85908,
			longitude: 31.27169667,
		},
		{
			latitude: 42.85905333,
			longitude: 31.27167167,
		},
		{
			latitude: 42.85904833,
			longitude: 31.27166833,
		},
		{
			latitude: 42.85904667,
			longitude: 31.27168,
		},
		{
			latitude: 42.85905,
			longitude: 31.27172333,
		},
		{
			latitude: 42.85903833,
			longitude: 31.27168667,
		},
		{
			latitude: 42.85903833,
			longitude: 31.27169167,
		},
		{
			latitude: 42.859035,
			longitude: 31.27166333,
		},
		{
			latitude: 42.85904833,
			longitude: 31.27166,
		},
		{
			latitude: 42.85881667,
			longitude: 31.27156,
		},
		{
			latitude: 42.85830333,
			longitude: 31.27141,
		},
		{
			latitude: 42.85785167,
			longitude: 31.27123333,
		},
		{
			latitude: 42.85787,
			longitude: 31.27065333,
		},
		{
			latitude: 42.85792167,
			longitude: 31.26987833,
		},
		{
			latitude: 42.85791667,
			longitude: 31.26921167,
		},
		{
			latitude: 42.85793833,
			longitude: 31.26843667,
		},
		{
			latitude: 42.857945,
			longitude: 31.26826667,
		},
		{
			latitude: 42.85796833,
			longitude: 31.26798167,
		},
		{
			latitude: 42.85796333,
			longitude: 31.26799833,
		},
		{
			latitude: 42.85817167,
			longitude: 31.26718167,
		},
		{
			latitude: 42.85799,
			longitude: 31.26305167,
		},
		{
			latitude: 42.85711667,
			longitude: 31.257675,
		},
		{
			latitude: 42.85654833,
			longitude: 31.252725,
		},
		{
			latitude: 42.85666333,
			longitude: 31.248055,
		},
		{
			latitude: 42.85685833,
			longitude: 31.24717,
		},
		{
			latitude: 42.857065,
			longitude: 31.24671333,
		},
		{
			latitude: 42.857485,
			longitude: 31.24573333,
		},
		{
			latitude: 42.85757833,
			longitude: 31.24555167,
		},
		{
			latitude: 42.85782833,
			longitude: 31.24497833,
		},
		{
			latitude: 42.85780167,
			longitude: 31.244985,
		},
		{
			latitude: 42.85776833,
			longitude: 31.24501167,
		},
		{
			latitude: 42.85780333,
			longitude: 31.24497833,
		},
		{
			latitude: 42.85780833,
			longitude: 31.24504833,
		},
		{
			latitude: 42.85778833,
			longitude: 31.24500333,
		},
		{
			latitude: 42.857805,
			longitude: 31.24503,
		},
		{
			latitude: 42.857815,
			longitude: 31.24488,
		},
		{
			latitude: 42.857965,
			longitude: 31.244525,
		},
		{
			latitude: 42.85798667,
			longitude: 31.24453,
		},
		{
			latitude: 42.85797,
			longitude: 31.24458333,
		},
		{
			latitude: 42.85796167,
			longitude: 31.24452167,
		},
		{
			latitude: 42.85797667,
			longitude: 31.24454667,
		},
		{
			latitude: 42.85796333,
			longitude: 31.24452667,
		},
		{
			latitude: 42.85795167,
			longitude: 31.24456667,
		},
		{
			latitude: 42.85798167,
			longitude: 31.24450333,
		},
		{
			latitude: 42.85797,
			longitude: 31.24452,
		},
		{
			latitude: 42.857995,
			longitude: 31.24457833,
		},
		{
			latitude: 42.85798833,
			longitude: 31.24457833,
		},
		{
			latitude: 42.85797,
			longitude: 31.24454,
		},
		{
			latitude: 42.85797667,
			longitude: 31.24451833,
		},
		{
			latitude: 42.85796333,
			longitude: 31.244565,
		},
		{
			latitude: 42.85796833,
			longitude: 31.24456667,
		},
		{
			latitude: 42.85797167,
			longitude: 31.24452167,
		},
		{
			latitude: 42.85796333,
			longitude: 31.24452667,
		},
		{
			latitude: 42.85798667,
			longitude: 31.24452,
		},
		{
			latitude: 42.85794833,
			longitude: 31.244555,
		},
		{
			latitude: 42.85797667,
			longitude: 31.24453,
		},
		{
			latitude: 42.85796833,
			longitude: 31.24450667,
		},
		{
			latitude: 42.85799333,
			longitude: 31.244575,
		},
		{
			latitude: 42.85799167,
			longitude: 31.244585,
		},
		{
			latitude: 42.85794,
			longitude: 31.244595,
		},
		{
			latitude: 42.85798333,
			longitude: 31.24451167,
		},
		{
			latitude: 42.85795667,
			longitude: 31.24455833,
		},
		{
			latitude: 42.857985,
			longitude: 31.24452667,
		},
		{
			latitude: 42.85797167,
			longitude: 31.24453167,
		},
		{
			latitude: 42.85798667,
			longitude: 31.24457333,
		},
		{
			latitude: 42.857975,
			longitude: 31.24454167,
		},
		{
			latitude: 42.85798667,
			longitude: 31.24455,
		},
		{
			latitude: 42.85799,
			longitude: 31.24451167,
		},
		{
			latitude: 42.85797167,
			longitude: 31.24453833,
		},
		{
			latitude: 42.85796833,
			longitude: 31.24453,
		},
		{
			latitude: 42.85797667,
			longitude: 31.24454833,
		},
		{
			latitude: 42.85799,
			longitude: 31.24453833,
		},
		{
			latitude: 42.85779833,
			longitude: 31.24445833,
		},
		{
			latitude: 42.85228,
			longitude: 31.24783,
		},
		{
			latitude: 42.84376833,
			longitude: 31.25835,
		},
		{
			latitude: 42.83603167,
			longitude: 31.26878333,
		},
		{
			latitude: 42.827395,
			longitude: 31.279,
		},
		{
			latitude: 42.81829167,
			longitude: 31.288335,
		},
		{
			latitude: 42.810065,
			longitude: 31.30030667,
		},
		{
			latitude: 42.80202833,
			longitude: 31.31292833,
		},
		{
			latitude: 42.79431667,
			longitude: 31.32564333,
		},
		{
			latitude: 42.79287333,
			longitude: 31.32806833,
		},
		{
			latitude: 42.78661833,
			longitude: 31.33873,
		},
		{
			latitude: 42.779075,
			longitude: 31.35210167,
		},
		{
			latitude: 42.772975,
			longitude: 31.36230833,
		},
		{
			latitude: 42.77282167,
			longitude: 31.36292167,
		},
		{
			latitude: 42.77343,
			longitude: 31.36249,
		},
		{
			latitude: 42.77346333,
			longitude: 31.36248667,
		},
		{
			latitude: 42.77343667,
			longitude: 31.36252167,
		},
		{
			latitude: 42.773465,
			longitude: 31.362495,
		},
		{
			latitude: 42.77329833,
			longitude: 31.36264167,
		},
		{
			latitude: 42.77332333,
			longitude: 31.362595,
		},
		{
			latitude: 42.77328833,
			longitude: 31.36264333,
		},
		{
			latitude: 42.77330333,
			longitude: 31.36260167,
		},
		{
			latitude: 42.77330833,
			longitude: 31.362595,
		},
		{
			latitude: 42.7733,
			longitude: 31.36263333,
		},
		{
			latitude: 42.773305,
			longitude: 31.3626,
		},
		{
			latitude: 42.77328167,
			longitude: 31.36262667,
		},
		{
			latitude: 42.77329667,
			longitude: 31.36259667,
		},
		{
			latitude: 42.77329667,
			longitude: 31.36266333,
		},
		{
			latitude: 42.77328167,
			longitude: 31.36261833,
		},
		{
			latitude: 42.77329167,
			longitude: 31.36261667,
		},
		{
			latitude: 42.77333167,
			longitude: 31.36258333,
		},
		{
			latitude: 42.77331833,
			longitude: 31.362585,
		},
		{
			latitude: 42.77331667,
			longitude: 31.36258,
		},
		{
			latitude: 42.77334833,
			longitude: 31.36260833,
		},
		{
			latitude: 42.77332,
			longitude: 31.36257167,
		},
		{
			latitude: 42.77330833,
			longitude: 31.362605,
		},
		{
			latitude: 42.77331833,
			longitude: 31.36256833,
		},
		{
			latitude: 42.77330333,
			longitude: 31.362615,
		},
		{
			latitude: 42.773305,
			longitude: 31.36260667,
		},
		{
			latitude: 42.77338,
			longitude: 31.36272167,
		},
		{
			latitude: 42.77349,
			longitude: 31.36286167,
		},
		{
			latitude: 42.77360667,
			longitude: 31.36297667,
		},
		{
			latitude: 42.77361833,
			longitude: 31.363015,
		},
		{
			latitude: 42.773605,
			longitude: 31.36303667,
		},
		{
			latitude: 42.77361833,
			longitude: 31.363005,
		},
		{
			latitude: 42.77361667,
			longitude: 31.36300333,
		},
		{
			latitude: 42.77360833,
			longitude: 31.36303333,
		},
		{
			latitude: 42.77362333,
			longitude: 31.36300833,
		},
		{
			latitude: 42.77365667,
			longitude: 31.362945,
		},
		{
			latitude: 42.773775,
			longitude: 31.36284833,
		},
		{
			latitude: 42.77387,
			longitude: 31.36265833,
		},
		{
			latitude: 42.773955,
			longitude: 31.36253167,
		},
		{
			latitude: 42.77398833,
			longitude: 31.362505,
		},
		{
			latitude: 42.774005,
			longitude: 31.36245167,
		},
		{
			latitude: 42.77397167,
			longitude: 31.362495,
		},
		{
			latitude: 42.77401333,
			longitude: 31.36248667,
		},
		{
			latitude: 42.77399167,
			longitude: 31.36249833,
		},
		{
			latitude: 42.77397667,
			longitude: 31.36252667,
		},
		{
			latitude: 42.774015,
			longitude: 31.36245167,
		},
		{
			latitude: 42.773995,
			longitude: 31.36248667,
		},
		{
			latitude: 42.77433333,
			longitude: 31.36252167,
		},
		{
			latitude: 42.77485833,
			longitude: 31.36248833,
		},
		{
			latitude: 42.775435,
			longitude: 31.36248333,
		},
		{
			latitude: 42.77597667,
			longitude: 31.36249333,
		},
		{
			latitude: 42.77648667,
			longitude: 31.36250333,
		},
		{
			latitude: 42.77702167,
			longitude: 31.362565,
		},
		{
			latitude: 42.77755667,
			longitude: 31.36251,
		},
		{
			latitude: 42.77812333,
			longitude: 31.3625,
		},
		{
			latitude: 42.77850333,
			longitude: 31.362485,
		},
		{
			latitude: 42.778495,
			longitude: 31.36248,
		},
		{
			latitude: 42.77825167,
			longitude: 31.36198167,
		},
		{
			latitude: 42.77792333,
			longitude: 31.361365,
		},
		{
			latitude: 42.77759167,
			longitude: 31.36070833,
		},
		{
			latitude: 42.77722833,
			longitude: 31.35993333,
		},
		{
			latitude: 42.77684167,
			longitude: 31.35918,
		},
		{
			latitude: 42.77645333,
			longitude: 31.35842667,
		},
		{
			latitude: 42.77607333,
			longitude: 31.35765667,
		},
		{
			latitude: 42.77598667,
			longitude: 31.357445,
		},
		{
			latitude: 42.77598833,
			longitude: 31.35745167,
		},
		{
			latitude: 42.77597,
			longitude: 31.35742,
		},
		{
			latitude: 42.77596667,
			longitude: 31.35742167,
		},
		{
			latitude: 42.775975,
			longitude: 31.35744333,
		},
		{
			latitude: 42.77596833,
			longitude: 31.35744833,
		},
		{
			latitude: 42.77598,
			longitude: 31.35741333,
		},
		{
			latitude: 42.775975,
			longitude: 31.35743,
		},
		{
			latitude: 42.77596333,
			longitude: 31.357495,
		},
		{
			latitude: 42.77599667,
			longitude: 31.35746167,
		},
		{
			latitude: 42.77597833,
			longitude: 31.35742833,
		},
		{
			latitude: 42.77598667,
			longitude: 31.35743,
		},
		{
			latitude: 42.77596667,
			longitude: 31.35748,
		},
		{
			latitude: 42.775995,
			longitude: 31.35748167,
		},
		{
			latitude: 42.77597333,
			longitude: 31.35743,
		},
		{
			latitude: 42.77598,
			longitude: 31.35741333,
		},
		{
			latitude: 42.77596667,
			longitude: 31.35742167,
		},
		{
			latitude: 42.77597167,
			longitude: 31.357435,
		},
		{
			latitude: 42.77598667,
			longitude: 31.357455,
		},
		{
			latitude: 42.77596833,
			longitude: 31.35743333,
		},
		{
			latitude: 42.77598167,
			longitude: 31.357415,
		},
		{
			latitude: 42.77594,
			longitude: 31.357465,
		},
		{
			latitude: 42.77596667,
			longitude: 31.35744333,
		},
		{
			latitude: 42.77592833,
			longitude: 31.35753333,
		},
		{
			latitude: 42.77592833,
			longitude: 31.35756167,
		},
		{
			latitude: 42.77595667,
			longitude: 31.35751167,
		},
		{
			latitude: 42.77595,
			longitude: 31.35749667,
		},
		{
			latitude: 42.77596333,
			longitude: 31.35748667,
		},
		{
			latitude: 42.77595333,
			longitude: 31.357455,
		},
		{
			latitude: 42.77593833,
			longitude: 31.35747167,
		},
		{
			latitude: 42.77595,
			longitude: 31.35747,
		},
		{
			latitude: 42.77594833,
			longitude: 31.35749167,
		},
		{
			latitude: 42.775955,
			longitude: 31.35746,
		},
		{
			latitude: 42.77594167,
			longitude: 31.35750667,
		},
		{
			latitude: 42.77595,
			longitude: 31.35751333,
		},
		{
			latitude: 42.77593833,
			longitude: 31.35750667,
		},
		{
			latitude: 42.77592833,
			longitude: 31.35749833,
		},
		{
			latitude: 42.77595333,
			longitude: 31.357495,
		},
		{
			latitude: 42.77593167,
			longitude: 31.35749333,
		},
		{
			latitude: 42.77594333,
			longitude: 31.35749,
		},
		{
			latitude: 42.77593667,
			longitude: 31.35752167,
		},
		{
			latitude: 42.77598833,
			longitude: 31.357445,
		},
		{
			latitude: 42.77596833,
			longitude: 31.35744833,
		},
		{
			latitude: 42.77598167,
			longitude: 31.357415,
		},
		{
			latitude: 42.77597333,
			longitude: 31.35746,
		},
		{
			latitude: 42.77598167,
			longitude: 31.35738667,
		},
		{
			latitude: 42.77596667,
			longitude: 31.35742667,
		},
		{
			latitude: 42.77599167,
			longitude: 31.35740667,
		},
		{
			latitude: 42.77598,
			longitude: 31.35742167,
		},
		{
			latitude: 42.77598,
			longitude: 31.35743333,
		},
		{
			latitude: 42.77599,
			longitude: 31.35740833,
		},
		{
			latitude: 42.77598667,
			longitude: 31.35744833,
		},
		{
			latitude: 42.775965,
			longitude: 31.357445,
		},
		{
			latitude: 42.77595833,
			longitude: 31.35743833,
		},
		{
			latitude: 42.775965,
			longitude: 31.35745667,
		},
		{
			latitude: 42.77596667,
			longitude: 31.35742,
		},
		{
			latitude: 42.77611,
			longitude: 31.35759667,
		},
		{
			latitude: 42.77608333,
			longitude: 31.35758833,
		},
		{
			latitude: 42.77607333,
			longitude: 31.35758167,
		},
		{
			latitude: 42.77616,
			longitude: 31.35764667,
		},
		{
			latitude: 42.77611333,
			longitude: 31.35757667,
		},
		{
			latitude: 42.77612167,
			longitude: 31.35760167,
		},
		{
			latitude: 42.77620833,
			longitude: 31.35767667,
		},
		{
			latitude: 42.77607833,
			longitude: 31.35764167,
		},
		{
			latitude: 42.77611667,
			longitude: 31.35758167,
		},
		{
			latitude: 42.77614333,
			longitude: 31.35763833,
		},
		{
			latitude: 42.77614167,
			longitude: 31.35766333,
		},
		{
			latitude: 42.77615167,
			longitude: 31.35763667,
		},
		{
			latitude: 42.77617,
			longitude: 31.357705,
		},
		{
			latitude: 42.77619333,
			longitude: 31.35772167,
		},
		{
			latitude: 42.77615667,
			longitude: 31.35768833,
		},
		{
			latitude: 42.77605667,
			longitude: 31.357665,
		},
		{
			latitude: 42.77608333,
			longitude: 31.357625,
		},
		{
			latitude: 42.77613,
			longitude: 31.357575,
		},
		{
			latitude: 42.77588333,
			longitude: 31.35740833,
		},
		{
			latitude: 42.77595333,
			longitude: 31.35744167,
		},
		{
			latitude: 42.77612833,
			longitude: 31.35760667,
		},
		{
			latitude: 42.77598333,
			longitude: 31.35746833,
		},
		{
			latitude: 42.77597167,
			longitude: 31.35743,
		},
		{
			latitude: 42.77591167,
			longitude: 31.35738667,
		},
		{
			latitude: 42.77598167,
			longitude: 31.35750167,
		},
		{
			latitude: 42.77598167,
			longitude: 31.35751833,
		},
		{
			latitude: 42.776025,
			longitude: 31.35749667,
		},
		{
			latitude: 42.775985,
			longitude: 31.35747333,
		},
		{
			latitude: 42.77594167,
			longitude: 31.357355,
		},
		{
			latitude: 42.77590333,
			longitude: 31.35736167,
		},
		{
			latitude: 42.77595,
			longitude: 31.35740167,
		},
		{
			latitude: 42.77589667,
			longitude: 31.35737,
		},
		{
			latitude: 42.77598,
			longitude: 31.35736833,
		},
		{
			latitude: 42.77593333,
			longitude: 31.357395,
		},
		{
			latitude: 42.77590167,
			longitude: 31.357245,
		},
		{
			latitude: 42.77608833,
			longitude: 31.35706833,
		},
		{
			latitude: 42.77605167,
			longitude: 31.35705667,
		},
		{
			latitude: 42.77604167,
			longitude: 31.356965,
		},
		{
			latitude: 42.77588667,
			longitude: 31.357455,
		},
		{
			latitude: 42.77587,
			longitude: 31.35750667,
		},
		{
			latitude: 42.77609,
			longitude: 31.35706,
		},
		{
			latitude: 42.77625,
			longitude: 31.35674833,
		},
		{
			latitude: 42.77631,
			longitude: 31.35683333,
		},
		{
			latitude: 42.77625,
			longitude: 31.356795,
		},
		{
			latitude: 42.77614167,
			longitude: 31.356695,
		},
		{
			latitude: 42.77605667,
			longitude: 31.35689833,
		},
		{
			latitude: 42.77591167,
			longitude: 31.35702833,
		},
		{
			latitude: 42.77576667,
			longitude: 31.35724,
		},
		{
			latitude: 42.77571667,
			longitude: 31.35751667,
		},
		{
			latitude: 42.77587167,
			longitude: 31.35699833,
		},
		{
			latitude: 42.77608,
			longitude: 31.35665333,
		},
		{
			latitude: 42.77625167,
			longitude: 31.35620333,
		},
		{
			latitude: 42.77639333,
			longitude: 31.355985,
		},
		{
			latitude: 42.77649167,
			longitude: 31.35587,
		},
		{
			latitude: 42.776325,
			longitude: 31.35595,
		},
		{
			latitude: 42.77641667,
			longitude: 31.35603333,
		},
		{
			latitude: 42.77619,
			longitude: 31.35621833,
		},
		{
			latitude: 42.77617833,
			longitude: 31.356155,
		},
		{
			latitude: 42.77614833,
			longitude: 31.356225,
		},
		{
			latitude: 42.77607833,
			longitude: 31.35629833,
		},
		{
			latitude: 42.77591333,
			longitude: 31.35645167,
		},
		{
			latitude: 42.77589,
			longitude: 31.356555,
		},
		{
			latitude: 42.77593333,
			longitude: 31.35647667,
		},
		{
			latitude: 42.775925,
			longitude: 31.35642833,
		},
		{
			latitude: 42.77615833,
			longitude: 31.35632333,
		},
		{
			latitude: 42.77624667,
			longitude: 31.35631333,
		},
		{
			latitude: 42.77622833,
			longitude: 31.35630833,
		},
		{
			latitude: 42.77618167,
			longitude: 31.35644,
		},
		{
			latitude: 42.77602167,
			longitude: 31.35679333,
		},
		{
			latitude: 42.77589,
			longitude: 31.35705,
		},
		{
			latitude: 42.77578667,
			longitude: 31.35733833,
		},
		{
			latitude: 42.775785,
			longitude: 31.357325,
		},
		{
			latitude: 42.77579667,
			longitude: 31.357275,
		},
		{
			latitude: 42.77582667,
			longitude: 31.357255,
		},
		{
			latitude: 42.77552167,
			longitude: 31.35793167,
		},
		{
			latitude: 42.77517167,
			longitude: 31.35865,
		},
		{
			latitude: 42.77491,
			longitude: 31.35924333,
		},
		{
			latitude: 42.77473167,
			longitude: 31.35958667,
		},
		{
			latitude: 42.77431667,
			longitude: 31.36052667,
		},
		{
			latitude: 42.77388167,
			longitude: 31.36147667,
		},
		{
			latitude: 42.77344333,
			longitude: 31.36245167,
		},
		{
			latitude: 42.77339,
			longitude: 31.36253333,
		},
		{
			latitude: 42.77319667,
			longitude: 31.36219667,
		},
		{
			latitude: 42.773195,
			longitude: 31.36223,
		},
		{
			latitude: 42.77319167,
			longitude: 31.36213833,
		},
		{
			latitude: 42.77317667,
			longitude: 31.36214333,
		},
		{
			latitude: 42.77309833,
			longitude: 31.36203833,
		},
		{
			latitude: 42.77309667,
			longitude: 31.36200667,
		},
		{
			latitude: 42.77311167,
			longitude: 31.36201167,
		},
		{
			latitude: 42.77309167,
			longitude: 31.362005,
		},
		{
			latitude: 42.773105,
			longitude: 31.36200167,
		},
		{
			latitude: 42.77309333,
			longitude: 31.36203167,
		},
		{
			latitude: 42.773145,
			longitude: 31.36224167,
		},
		{
			latitude: 42.77321667,
			longitude: 31.362595,
		},
		{
			latitude: 42.77330167,
			longitude: 31.36295,
		},
		{
			latitude: 42.77330167,
			longitude: 31.36302,
		},
		{
			latitude: 42.77330167,
			longitude: 31.363005,
		},
		{
			latitude: 42.773285,
			longitude: 31.363,
		},
		{
			latitude: 42.773295,
			longitude: 31.363005,
		},
		{
			latitude: 42.77330167,
			longitude: 31.36304,
		},
		{
			latitude: 42.773315,
			longitude: 31.36298333,
		},
		{
			latitude: 42.77332333,
			longitude: 31.36296833,
		},
		{
			latitude: 42.77328667,
			longitude: 31.36300667,
		},
		{
			latitude: 42.77331667,
			longitude: 31.36295667,
		},
		{
			latitude: 42.773335,
			longitude: 31.36295667,
		},
		{
			latitude: 42.77318167,
			longitude: 31.363165,
		},
		{
			latitude: 42.77313667,
			longitude: 31.36317667,
		},
		{
			latitude: 42.77314667,
			longitude: 31.363205,
		},
		{
			latitude: 42.77316333,
			longitude: 31.36321167,
		},
		{
			latitude: 42.77318333,
			longitude: 31.36313833,
		},
		{
			latitude: 42.77318833,
			longitude: 31.36312167,
		},
		{
			latitude: 42.77319,
			longitude: 31.363135,
		},
		{
			latitude: 42.77319667,
			longitude: 31.36315667,
		},
		{
			latitude: 42.77316833,
			longitude: 31.36316667,
		},
		{
			latitude: 42.773185,
			longitude: 31.36311833,
		},
		{
			latitude: 42.77317667,
			longitude: 31.36314833,
		},
		{
			latitude: 42.77319333,
			longitude: 31.36314333,
		},
		{
			latitude: 42.77318667,
			longitude: 31.36316,
		},
		{
			latitude: 42.77318167,
			longitude: 31.36313167,
		},
		{
			latitude: 42.77316667,
			longitude: 31.36315,
		},
		{
			latitude: 42.773185,
			longitude: 31.36311167,
		},
		{
			latitude: 42.77318,
			longitude: 31.36312333,
		},
		{
			latitude: 42.77317667,
			longitude: 31.36311833,
		},
		{
			latitude: 42.77317167,
			longitude: 31.363135,
		},
		{
			latitude: 42.77318833,
			longitude: 31.36314167,
		},
		{
			latitude: 42.77319833,
			longitude: 31.36315,
		},
		{
			latitude: 42.77317833,
			longitude: 31.36315333,
		},
		{
			latitude: 42.77317667,
			longitude: 31.36317,
		},
		{
			latitude: 42.77317333,
			longitude: 31.363175,
		},
		{
			latitude: 42.773185,
			longitude: 31.36314333,
		},
		{
			latitude: 42.77319167,
			longitude: 31.36311833,
		},
		{
			latitude: 42.77329333,
			longitude: 31.36308833,
		},
		{
			latitude: 42.773435,
			longitude: 31.36301333,
		},
		{
			latitude: 42.77343833,
			longitude: 31.36300333,
		},
		{
			latitude: 42.77351667,
			longitude: 31.36290833,
		},
		{
			latitude: 42.77351667,
			longitude: 31.36290333,
		},
		{
			latitude: 42.7735,
			longitude: 31.36289,
		},
		{
			latitude: 42.77365833,
			longitude: 31.36275,
		},
		{
			latitude: 42.77387167,
			longitude: 31.36253,
		},
		{
			latitude: 42.77386167,
			longitude: 31.36252333,
		},
		{
			latitude: 42.77387667,
			longitude: 31.36252833,
		},
		{
			latitude: 42.773875,
			longitude: 31.36253167,
		},
		{
			latitude: 42.77386833,
			longitude: 31.36252167,
		},
		{
			latitude: 42.773865,
			longitude: 31.36252167,
		},
		{
			latitude: 42.77386333,
			longitude: 31.36253,
		},
		{
			latitude: 42.77388333,
			longitude: 31.36251833,
		},
		{
			latitude: 42.77436833,
			longitude: 31.36173167,
		},
		{
			latitude: 42.77554167,
			longitude: 31.359165,
		},
		{
			latitude: 42.77698,
			longitude: 31.356075,
		},
		{
			latitude: 42.77841,
			longitude: 31.35296167,
		},
		{
			latitude: 42.779935,
			longitude: 31.34965,
		},
		{
			latitude: 42.78127833,
			longitude: 31.34676667,
		},
		{
			latitude: 42.78269,
			longitude: 31.34364667,
		},
		{
			latitude: 42.78413667,
			longitude: 31.34055667,
		},
		{
			latitude: 42.78557667,
			longitude: 31.33741167,
		},
		{
			latitude: 42.78705,
			longitude: 31.33422167,
		},
		{
			latitude: 42.78847333,
			longitude: 31.33109833,
		},
		{
			latitude: 42.78987333,
			longitude: 31.32811333,
		},
		{
			latitude: 42.79151333,
			longitude: 31.32458833,
		},
		{
			latitude: 42.79271833,
			longitude: 31.32187,
		},
		{
			latitude: 42.79414833,
			longitude: 31.31877667,
		},
		{
			latitude: 42.79555,
			longitude: 31.31577,
		},
		{
			latitude: 42.79643833,
			longitude: 31.313745,
		},
		{
			latitude: 42.79687167,
			longitude: 31.31264167,
		},
		{
			latitude: 42.797015,
			longitude: 31.31232833,
		},
		{
			latitude: 42.79691667,
			longitude: 31.31237,
		},
		{
			latitude: 42.79687333,
			longitude: 31.31236,
		},
		{
			latitude: 42.796945,
			longitude: 31.312225,
		},
		{
			latitude: 42.79693833,
			longitude: 31.31224167,
		},
		{
			latitude: 42.79689333,
			longitude: 31.31217667,
		},
		{
			latitude: 42.796935,
			longitude: 31.31216333,
		},
		{
			latitude: 42.79694333,
			longitude: 31.312185,
		},
		{
			latitude: 42.79696667,
			longitude: 31.31216667,
		},
		{
			latitude: 42.796965,
			longitude: 31.312295,
		},
		{
			latitude: 42.797005,
			longitude: 31.31233167,
		},
		{
			latitude: 42.79698167,
			longitude: 31.31222,
		},
		{
			latitude: 42.79693833,
			longitude: 31.312245,
		},
		{
			latitude: 42.79695,
			longitude: 31.312225,
		},
		{
			latitude: 42.79695667,
			longitude: 31.31223,
		},
		{
			latitude: 42.796945,
			longitude: 31.31215667,
		},
		{
			latitude: 42.7969,
			longitude: 31.31214,
		},
		{
			latitude: 42.79696167,
			longitude: 31.31220333,
		},
		{
			latitude: 42.796975,
			longitude: 31.31228833,
		},
		{
			latitude: 42.79698833,
			longitude: 31.312265,
		},
		{
			latitude: 42.79699833,
			longitude: 31.31227167,
		},
		{
			latitude: 42.797075,
			longitude: 31.312375,
		},
		{
			latitude: 42.79714333,
			longitude: 31.31243,
		},
		{
			latitude: 42.797125,
			longitude: 31.31258833,
		},
		{
			latitude: 42.79711667,
			longitude: 31.31260333,
		},
		{
			latitude: 42.797155,
			longitude: 31.31257167,
		},
		{
			latitude: 42.797205,
			longitude: 31.31252333,
		},
		{
			latitude: 42.797185,
			longitude: 31.31244833,
		},
		{
			latitude: 42.797225,
			longitude: 31.31243833,
		},
		{
			latitude: 42.79715,
			longitude: 31.31247833,
		},
		{
			latitude: 42.79708667,
			longitude: 31.312555,
		},
		{
			latitude: 42.79711833,
			longitude: 31.31253833,
		},
		{
			latitude: 42.79720167,
			longitude: 31.31255167,
		},
		{
			latitude: 42.79723667,
			longitude: 31.31250667,
		},
		{
			latitude: 42.79700167,
			longitude: 31.31268,
		},
		{
			latitude: 42.79815833,
			longitude: 31.311835,
		},
		{
			latitude: 42.804445,
			longitude: 31.31103167,
		},
		{
			latitude: 42.80880667,
			longitude: 31.310975,
		},
		{
			latitude: 42.80914667,
			longitude: 31.31082667,
		},
		{
			latitude: 42.80969167,
			longitude: 31.31108833,
		},
		{
			latitude: 42.80975667,
			longitude: 31.31089667,
		},
		{
			latitude: 42.809755,
			longitude: 31.31091833,
		},
		{
			latitude: 42.80975667,
			longitude: 31.31091,
		},
		{
			latitude: 42.80975333,
			longitude: 31.31091167,
		},
		{
			latitude: 42.80975667,
			longitude: 31.31091,
		},
		{
			latitude: 42.80975333,
			longitude: 31.31091,
		},
		{
			latitude: 42.809755,
			longitude: 31.31090833,
		},
		{
			latitude: 42.809755,
			longitude: 31.31091333,
		},
		{
			latitude: 42.809755,
			longitude: 31.31090833,
		},
		{
			latitude: 42.809755,
			longitude: 31.31090667,
		},
		{
			latitude: 42.809755,
			longitude: 31.31091833,
		},
		{
			latitude: 42.80975667,
			longitude: 31.31091833,
		},
		{
			latitude: 42.80958333,
			longitude: 31.31101667,
		},
		{
			latitude: 42.80909333,
			longitude: 31.31134,
		},
		{
			latitude: 42.80860333,
			longitude: 31.31164167,
		},
		{
			latitude: 42.80845667,
			longitude: 31.31173833,
		},
		{
			latitude: 42.80820333,
			longitude: 31.31190167,
		},
		{
			latitude: 42.80820333,
			longitude: 31.31189333,
		},
		{
			latitude: 42.80842833,
			longitude: 31.31196167,
		},
		{
			latitude: 42.80873833,
			longitude: 31.31201333,
		},
		{
			latitude: 42.80874,
			longitude: 31.31201167,
		},
		{
			latitude: 42.80873833,
			longitude: 31.31200833,
		},
		{
			latitude: 42.80873667,
			longitude: 31.31202,
		},
		{
			latitude: 42.80882333,
			longitude: 31.31204,
		},
		{
			latitude: 42.808825,
			longitude: 31.31204667,
		},
		{
			latitude: 42.80882667,
			longitude: 31.312045,
		},
		{
			latitude: 42.808825,
			longitude: 31.31204167,
		},
		{
			latitude: 42.80882667,
			longitude: 31.31203667,
		},
		{
			latitude: 42.80882667,
			longitude: 31.31203,
		},
		{
			latitude: 42.808825,
			longitude: 31.31204,
		},
		{
			latitude: 42.80882667,
			longitude: 31.31203833,
		},
		{
			latitude: 42.80882833,
			longitude: 31.31203833,
		},
		{
			latitude: 42.80882667,
			longitude: 31.31204167,
		},
		{
			latitude: 42.808825,
			longitude: 31.31204333,
		},
		{
			latitude: 42.80882833,
			longitude: 31.31204333,
		},
		{
			latitude: 42.80882833,
			longitude: 31.31204167,
		},
		{
			latitude: 42.80882333,
			longitude: 31.31204333,
		},
		{
			latitude: 42.808825,
			longitude: 31.312045,
		},
		{
			latitude: 42.80882333,
			longitude: 31.31204,
		},
		{
			latitude: 42.80882667,
			longitude: 31.31203667,
		},
		{
			latitude: 42.80882667,
			longitude: 31.31203833,
		},
		{
			latitude: 42.808825,
			longitude: 31.31204,
		},
		{
			latitude: 42.808825,
			longitude: 31.31203833,
		},
		{
			latitude: 42.808825,
			longitude: 31.31204667,
		},
		{
			latitude: 42.808825,
			longitude: 31.31204333,
		},
		{
			latitude: 42.80882667,
			longitude: 31.31204,
		},
		{
			latitude: 42.808585,
			longitude: 31.31198333,
		},
		{
			latitude: 42.808205,
			longitude: 31.31189333,
		},
		{
			latitude: 42.80820167,
			longitude: 31.311895,
		},
		{
			latitude: 42.8082,
			longitude: 31.31189333,
		},
		{
			latitude: 42.808205,
			longitude: 31.311895,
		},
		{
			latitude: 42.80820167,
			longitude: 31.3119,
		},
		{
			latitude: 42.80831,
			longitude: 31.31186,
		},
		{
			latitude: 42.80881333,
			longitude: 31.31166333,
		},
		{
			latitude: 42.80885667,
			longitude: 31.31165333,
		},
		{
			latitude: 42.808855,
			longitude: 31.311665,
		},
		{
			latitude: 42.80885,
			longitude: 31.31166167,
		},
		{
			latitude: 42.80907167,
			longitude: 31.31136667,
		},
		{
			latitude: 42.80945833,
			longitude: 31.31084167,
		},
		{
			latitude: 42.80964,
			longitude: 31.31058667,
		},
		{
			latitude: 42.80964,
			longitude: 31.31058667,
		},
		{
			latitude: 42.80963833,
			longitude: 31.31059,
		},
		{
			latitude: 42.80964833,
			longitude: 31.31056333,
		},
		{
			latitude: 42.80964833,
			longitude: 31.310575,
		},
		{
			latitude: 42.80965167,
			longitude: 31.31057167,
		},
		{
			latitude: 42.80965167,
			longitude: 31.31055667,
		},
		{
			latitude: 42.80964667,
			longitude: 31.31057333,
		},
		{
			latitude: 42.80965333,
			longitude: 31.31057167,
		},
		{
			latitude: 42.80965167,
			longitude: 31.31056,
		},
		{
			latitude: 42.80965167,
			longitude: 31.31056333,
		},
		{
			latitude: 42.80965333,
			longitude: 31.31056833,
		},
		{
			latitude: 42.80965167,
			longitude: 31.31056,
		},
		{
			latitude: 42.809655,
			longitude: 31.31056833,
		},
		{
			latitude: 42.80965667,
			longitude: 31.310585,
		},
		{
			latitude: 42.80966,
			longitude: 31.31055333,
		},
		{
			latitude: 42.80965833,
			longitude: 31.310545,
		},
		{
			latitude: 42.80966167,
			longitude: 31.310535,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31054,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31054667,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31054333,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31054167,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31054167,
		},
		{
			latitude: 42.80966833,
			longitude: 31.31053333,
		},
		{
			latitude: 42.80961333,
			longitude: 31.31062,
		},
		{
			latitude: 42.809445,
			longitude: 31.31088167,
		},
		{
			latitude: 42.80925667,
			longitude: 31.31119333,
		},
		{
			latitude: 42.80897167,
			longitude: 31.31164333,
		},
		{
			latitude: 42.808825,
			longitude: 31.311895,
		},
		{
			latitude: 42.80882667,
			longitude: 31.31188833,
		},
		{
			latitude: 42.80882333,
			longitude: 31.31190333,
		},
		{
			latitude: 42.808835,
			longitude: 31.31188833,
		},
		{
			latitude: 42.80915,
			longitude: 31.31136667,
		},
		{
			latitude: 42.809495,
			longitude: 31.3108,
		},
		{
			latitude: 42.80968167,
			longitude: 31.310495,
		},
		{
			latitude: 42.80968667,
			longitude: 31.31049167,
		},
		{
			latitude: 42.80969,
			longitude: 31.31049833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31051,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31052,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31051833,
		},
		{
			latitude: 42.809675,
			longitude: 31.310505,
		},
		{
			latitude: 42.80962333,
			longitude: 31.31060667,
		},
		{
			latitude: 42.80927167,
			longitude: 31.31120333,
		},
		{
			latitude: 42.809205,
			longitude: 31.311335,
		},
		{
			latitude: 42.808935,
			longitude: 31.311815,
		},
		{
			latitude: 42.80861,
			longitude: 31.312365,
		},
		{
			latitude: 42.80853167,
			longitude: 31.31252,
		},
		{
			latitude: 42.80855333,
			longitude: 31.312455,
		},
		{
			latitude: 42.80853833,
			longitude: 31.31247667,
		},
		{
			latitude: 42.80853833,
			longitude: 31.31251333,
		},
		{
			latitude: 42.80855833,
			longitude: 31.312455,
		},
		{
			latitude: 42.80856,
			longitude: 31.31246333,
		},
		{
			latitude: 42.80853833,
			longitude: 31.31249333,
		},
		{
			latitude: 42.808545,
			longitude: 31.31247167,
		},
		{
			latitude: 42.80854667,
			longitude: 31.31247,
		},
		{
			latitude: 42.80854667,
			longitude: 31.31246,
		},
		{
			latitude: 42.80854167,
			longitude: 31.31248167,
		},
		{
			latitude: 42.80854667,
			longitude: 31.31246833,
		},
		{
			latitude: 42.80854833,
			longitude: 31.3125,
		},
		{
			latitude: 42.80854,
			longitude: 31.31248,
		},
		{
			latitude: 42.80823833,
			longitude: 31.31289,
		},
		{
			latitude: 42.80774167,
			longitude: 31.31356667,
		},
		{
			latitude: 42.80741833,
			longitude: 31.31400333,
		},
		{
			latitude: 42.80696,
			longitude: 31.31463833,
		},
		{
			latitude: 42.806475,
			longitude: 31.31529167,
		},
		{
			latitude: 42.80599833,
			longitude: 31.31594167,
		},
		{
			latitude: 42.80551833,
			longitude: 31.316595,
		},
		{
			latitude: 42.80505333,
			longitude: 31.31722833,
		},
		{
			latitude: 42.80504333,
			longitude: 31.31758,
		},
		{
			latitude: 42.80457,
			longitude: 31.31829667,
		},
		{
			latitude: 42.8041,
			longitude: 31.318985,
		},
		{
			latitude: 42.80366333,
			longitude: 31.31960167,
		},
		{
			latitude: 42.8032,
			longitude: 31.32027833,
		},
		{
			latitude: 42.802805,
			longitude: 31.32084833,
		},
		{
			latitude: 42.80235333,
			longitude: 31.32160167,
		},
		{
			latitude: 42.80192667,
			longitude: 31.322375,
		},
		{
			latitude: 42.80150833,
			longitude: 31.32307833,
		},
		{
			latitude: 42.80108333,
			longitude: 31.32380167,
		},
		{
			latitude: 42.80063,
			longitude: 31.324475,
		},
		{
			latitude: 42.80042667,
			longitude: 31.32477667,
		},
		{
			latitude: 42.80044333,
			longitude: 31.32474333,
		},
		{
			latitude: 42.80044667,
			longitude: 31.32472333,
		},
		{
			latitude: 42.80044167,
			longitude: 31.32476,
		},
		{
			latitude: 42.80044667,
			longitude: 31.32477,
		},
		{
			latitude: 42.80011833,
			longitude: 31.325275,
		},
		{
			latitude: 42.79967333,
			longitude: 31.32599833,
		},
		{
			latitude: 42.79924167,
			longitude: 31.32669167,
		},
		{
			latitude: 42.79884333,
			longitude: 31.32732,
		},
		{
			latitude: 42.79839167,
			longitude: 31.32804333,
		},
		{
			latitude: 42.79791833,
			longitude: 31.328805,
		},
		{
			latitude: 42.79774833,
			longitude: 31.32910333,
		},
		{
			latitude: 42.79824333,
			longitude: 31.32845333,
		},
		{
			latitude: 42.798375,
			longitude: 31.32829,
		},
		{
			latitude: 42.79832333,
			longitude: 31.328375,
		},
		{
			latitude: 42.79793833,
			longitude: 31.32914667,
		},
		{
			latitude: 42.79783333,
			longitude: 31.32935,
		},
		{
			latitude: 42.79784333,
			longitude: 31.32934167,
		},
		{
			latitude: 42.797795,
			longitude: 31.32941333,
		},
		{
			latitude: 42.797325,
			longitude: 31.33032833,
		},
		{
			latitude: 42.796845,
			longitude: 31.33125333,
		},
		{
			latitude: 42.79649,
			longitude: 31.331955,
		},
		{
			latitude: 42.79648667,
			longitude: 31.33195833,
		},
		{
			latitude: 42.79650167,
			longitude: 31.33193167,
		},
		{
			latitude: 42.796265,
			longitude: 31.33229833,
		},
		{
			latitude: 42.79583167,
			longitude: 31.33303667,
		},
		{
			latitude: 42.79538667,
			longitude: 31.33373667,
		},
		{
			latitude: 42.79496333,
			longitude: 31.33442833,
		},
		{
			latitude: 42.79452833,
			longitude: 31.33515167,
		},
		{
			latitude: 42.7943,
			longitude: 31.33551333,
		},
		{
			latitude: 42.79412833,
			longitude: 31.33577833,
		},
		{
			latitude: 42.79375667,
			longitude: 31.33639,
		},
		{
			latitude: 42.793765,
			longitude: 31.33637,
		},
		{
			latitude: 42.79376,
			longitude: 31.336375,
		},
		{
			latitude: 42.793765,
			longitude: 31.33639667,
		},
		{
			latitude: 42.79342333,
			longitude: 31.33692833,
		},
		{
			latitude: 42.79299667,
			longitude: 31.33764,
		},
		{
			latitude: 42.79258167,
			longitude: 31.33829667,
		},
		{
			latitude: 42.792205,
			longitude: 31.33895,
		},
		{
			latitude: 42.79219833,
			longitude: 31.33891,
		},
		{
			latitude: 42.79218,
			longitude: 31.33895,
		},
		{
			latitude: 42.79171333,
			longitude: 31.339865,
		},
		{
			latitude: 42.79138167,
			longitude: 31.340515,
		},
		{
			latitude: 42.79138333,
			longitude: 31.340515,
		},
		{
			latitude: 42.79137333,
			longitude: 31.34049667,
		},
		{
			latitude: 42.79119,
			longitude: 31.34087667,
		},
		{
			latitude: 42.79096833,
			longitude: 31.34128833,
		},
		{
			latitude: 42.79051667,
			longitude: 31.34216,
		},
		{
			latitude: 42.79012833,
			longitude: 31.34293667,
		},
		{
			latitude: 42.78976333,
			longitude: 31.34363833,
		},
		{
			latitude: 42.78937,
			longitude: 31.34439167,
		},
		{
			latitude: 42.78896167,
			longitude: 31.34518833,
		},
		{
			latitude: 42.78860167,
			longitude: 31.34590333,
		},
		{
			latitude: 42.78821167,
			longitude: 31.34663333,
		},
		{
			latitude: 42.78780833,
			longitude: 31.34741667,
		},
		{
			latitude: 42.78744333,
			longitude: 31.34813833,
		},
		{
			latitude: 42.78703667,
			longitude: 31.34890833,
		},
		{
			latitude: 42.78666667,
			longitude: 31.34964667,
		},
		{
			latitude: 42.78626833,
			longitude: 31.3504,
		},
		{
			latitude: 42.78589,
			longitude: 31.35114167,
		},
		{
			latitude: 42.78549833,
			longitude: 31.35189,
		},
		{
			latitude: 42.785105,
			longitude: 31.35267,
		},
		{
			latitude: 42.784715,
			longitude: 31.35342333,
		},
		{
			latitude: 42.78441667,
			longitude: 31.35417667,
		},
		{
			latitude: 42.78423667,
			longitude: 31.3551,
		},
		{
			latitude: 42.78405833,
			longitude: 31.35597833,
		},
		{
			latitude: 42.78391667,
			longitude: 31.35685333,
		},
		{
			latitude: 42.78378,
			longitude: 31.35777,
		},
		{
			latitude: 42.78365667,
			longitude: 31.35864833,
		},
		{
			latitude: 42.783525,
			longitude: 31.35955667,
		},
		{
			latitude: 42.783395,
			longitude: 31.36045,
		},
		{
			latitude: 42.78327333,
			longitude: 31.361345,
		},
		{
			latitude: 42.783135,
			longitude: 31.362245,
		},
		{
			latitude: 42.783005,
			longitude: 31.36314667,
		},
		{
			latitude: 42.78288,
			longitude: 31.36404667,
		},
		{
			latitude: 42.78274833,
			longitude: 31.36493833,
		},
		{
			latitude: 42.782625,
			longitude: 31.36586833,
		},
		{
			latitude: 42.78260167,
			longitude: 31.366765,
		},
		{
			latitude: 42.78277333,
			longitude: 31.36765,
		},
		{
			latitude: 42.78295333,
			longitude: 31.36856333,
		},
		{
			latitude: 42.78310833,
			longitude: 31.36939167,
		},
		{
			latitude: 42.78327667,
			longitude: 31.37027833,
		},
		{
			latitude: 42.78346167,
			longitude: 31.37125833,
		},
		{
			latitude: 42.78364167,
			longitude: 31.37217333,
		},
		{
			latitude: 42.78378833,
			longitude: 31.37294667,
		},
		{
			latitude: 42.78395667,
			longitude: 31.37382667,
		},
		{
			latitude: 42.78413167,
			longitude: 31.37470833,
		},
		{
			latitude: 42.78430333,
			longitude: 31.3756,
		},
		{
			latitude: 42.78447667,
			longitude: 31.37651667,
		},
		{
			latitude: 42.78463833,
			longitude: 31.37738167,
		},
		{
			latitude: 42.78481167,
			longitude: 31.37828,
		},
		{
			latitude: 42.78504167,
			longitude: 31.37912667,
		},
		{
			latitude: 42.78527,
			longitude: 31.37999167,
		},
		{
			latitude: 42.78549667,
			longitude: 31.38084833,
		},
		{
			latitude: 42.785735,
			longitude: 31.38174,
		},
		{
			latitude: 42.78577,
			longitude: 31.38185833,
		},
		{
			latitude: 42.78603833,
			longitude: 31.38184833,
		},
		{
			latitude: 42.7859,
			longitude: 31.38105833,
		},
		{
			latitude: 42.78574167,
			longitude: 31.38017667,
		},
		{
			latitude: 42.78560833,
			longitude: 31.37933333,
		},
		{
			latitude: 42.78544667,
			longitude: 31.378375,
		},
		{
			latitude: 42.78529333,
			longitude: 31.37747833,
		},
		{
			latitude: 42.78513833,
			longitude: 31.37658833,
		},
		{
			latitude: 42.78499833,
			longitude: 31.37575167,
		},
		{
			latitude: 42.78485,
			longitude: 31.37487833,
		},
		{
			latitude: 42.78468333,
			longitude: 31.37394,
		},
		{
			latitude: 42.78454167,
			longitude: 31.37308667,
		},
		{
			latitude: 42.78439,
			longitude: 31.37214667,
		},
		{
			latitude: 42.78422833,
			longitude: 31.37122667,
		},
		{
			latitude: 42.78408667,
			longitude: 31.37039667,
		},
		{
			latitude: 42.783935,
			longitude: 31.36950667,
		},
		{
			latitude: 42.783805,
			longitude: 31.36861,
		},
		{
			latitude: 42.78373,
			longitude: 31.36766,
		},
		{
			latitude: 42.78365667,
			longitude: 31.36678667,
		},
		{
			latitude: 42.78358833,
			longitude: 31.36584167,
		},
		{
			latitude: 42.783535,
			longitude: 31.364965,
		},
		{
			latitude: 42.78354333,
			longitude: 31.36404667,
		},
		{
			latitude: 42.78355667,
			longitude: 31.36309,
		},
		{
			latitude: 42.78356833,
			longitude: 31.36220333,
		},
		{
			latitude: 42.783625,
			longitude: 31.36131667,
		},
		{
			latitude: 42.78376667,
			longitude: 31.3604,
		},
		{
			latitude: 42.78391167,
			longitude: 31.35952167,
		},
		{
			latitude: 42.78405333,
			longitude: 31.35861667,
		},
		{
			latitude: 42.78424333,
			longitude: 31.357725,
		},
		{
			latitude: 42.78447333,
			longitude: 31.35686667,
		},
		{
			latitude: 42.78472167,
			longitude: 31.35599,
		},
		{
			latitude: 42.78496833,
			longitude: 31.3551,
		},
		{
			latitude: 42.78522667,
			longitude: 31.35433333,
		},
		{
			latitude: 42.78564167,
			longitude: 31.35353667,
		},
		{
			latitude: 42.78596167,
			longitude: 31.352895,
		},
		{
			latitude: 42.78627167,
			longitude: 31.35229833,
		},
		{
			latitude: 42.78655667,
			longitude: 31.35174,
		},
		{
			latitude: 42.78693167,
			longitude: 31.35100333,
		},
		{
			latitude: 42.78732833,
			longitude: 31.35024167,
		},
		{
			latitude: 42.78773167,
			longitude: 31.34951333,
		},
		{
			latitude: 42.78814167,
			longitude: 31.34878,
		},
		{
			latitude: 42.78854667,
			longitude: 31.34805,
		},
		{
			latitude: 42.78896333,
			longitude: 31.34729333,
		},
		{
			latitude: 42.78937333,
			longitude: 31.34655833,
		},
		{
			latitude: 42.78976333,
			longitude: 31.34586,
		},
		{
			latitude: 42.79016833,
			longitude: 31.34512333,
		},
		{
			latitude: 42.79058333,
			longitude: 31.34440167,
		},
		{
			latitude: 42.79099667,
			longitude: 31.34367,
		},
		{
			latitude: 42.79141333,
			longitude: 31.342945,
		},
		{
			latitude: 42.791495,
			longitude: 31.3428,
		},
		{
			latitude: 42.791825,
			longitude: 31.34222667,
		},
		{
			latitude: 42.79224167,
			longitude: 31.341505,
		},
		{
			latitude: 42.79265833,
			longitude: 31.34078667,
		},
		{
			latitude: 42.79307333,
			longitude: 31.34006333,
		},
		{
			latitude: 42.79353167,
			longitude: 31.33926167,
		},
		{
			latitude: 42.793905,
			longitude: 31.33860667,
		},
		{
			latitude: 42.79432167,
			longitude: 31.33788333,
		},
		{
			latitude: 42.79473,
			longitude: 31.33716833,
		},
		{
			latitude: 42.79515167,
			longitude: 31.33643667,
		},
		{
			latitude: 42.79558167,
			longitude: 31.33569667,
		},
		{
			latitude: 42.79607833,
			longitude: 31.33483833,
		},
		{
			latitude: 42.79657667,
			longitude: 31.33395833,
		},
		{
			latitude: 42.79710833,
			longitude: 31.33304667,
		},
		{
			latitude: 42.79757833,
			longitude: 31.33222167,
		},
		{
			latitude: 42.79806167,
			longitude: 31.33135333,
		},
		{
			latitude: 42.7985,
			longitude: 31.330435,
		},
		{
			latitude: 42.79897333,
			longitude: 31.32954,
		},
		{
			latitude: 42.79946,
			longitude: 31.32865833,
		},
		{
			latitude: 42.79995,
			longitude: 31.32777833,
		},
		{
			latitude: 42.80043333,
			longitude: 31.32689,
		},
		{
			latitude: 42.80093333,
			longitude: 31.32599167,
		},
		{
			latitude: 42.80142333,
			longitude: 31.32511833,
		},
		{
			latitude: 42.80190667,
			longitude: 31.324275,
		},
		{
			latitude: 42.802405,
			longitude: 31.32340833,
		},
		{
			latitude: 42.80290167,
			longitude: 31.32253833,
		},
		{
			latitude: 42.80299833,
			longitude: 31.32237333,
		},
		{
			latitude: 42.8034,
			longitude: 31.32166833,
		},
		{
			latitude: 42.80387833,
			longitude: 31.32087833,
		},
		{
			latitude: 42.80439667,
			longitude: 31.320195,
		},
		{
			latitude: 42.80480667,
			longitude: 31.319655,
		},
		{
			latitude: 42.805195,
			longitude: 31.31915167,
		},
		{
			latitude: 42.80563,
			longitude: 31.31858167,
		},
		{
			latitude: 42.80611833,
			longitude: 31.31793833,
		},
		{
			latitude: 42.806575,
			longitude: 31.31727,
		},
		{
			latitude: 42.80698333,
			longitude: 31.316505,
		},
		{
			latitude: 42.80736833,
			longitude: 31.31579833,
		},
		{
			latitude: 42.80778,
			longitude: 31.31505667,
		},
		{
			latitude: 42.80829833,
			longitude: 31.31434167,
		},
		{
			latitude: 42.80872833,
			longitude: 31.31375167,
		},
		{
			latitude: 42.809205,
			longitude: 31.3131,
		},
		{
			latitude: 42.80945167,
			longitude: 31.312775,
		},
		{
			latitude: 42.80944833,
			longitude: 31.31278,
		},
		{
			latitude: 42.80944333,
			longitude: 31.31278,
		},
		{
			latitude: 42.80944333,
			longitude: 31.312785,
		},
		{
			latitude: 42.809445,
			longitude: 31.31277333,
		},
		{
			latitude: 42.809445,
			longitude: 31.31278,
		},
		{
			latitude: 42.809445,
			longitude: 31.31278,
		},
		{
			latitude: 42.80944333,
			longitude: 31.31278833,
		},
		{
			latitude: 42.80944333,
			longitude: 31.31278167,
		},
		{
			latitude: 42.80944333,
			longitude: 31.31278833,
		},
		{
			latitude: 42.80944667,
			longitude: 31.31278,
		},
		{
			latitude: 42.80944667,
			longitude: 31.31277667,
		},
		{
			latitude: 42.809445,
			longitude: 31.31277833,
		},
		{
			latitude: 42.80944667,
			longitude: 31.31277833,
		},
		{
			latitude: 42.80944667,
			longitude: 31.31278333,
		},
		{
			latitude: 42.80944833,
			longitude: 31.31278167,
		},
		{
			latitude: 42.80944333,
			longitude: 31.31278167,
		},
		{
			latitude: 42.809445,
			longitude: 31.312785,
		},
		{
			latitude: 42.80944833,
			longitude: 31.312775,
		},
		{
			latitude: 42.809445,
			longitude: 31.31278333,
		},
		{
			latitude: 42.809445,
			longitude: 31.31279,
		},
		{
			latitude: 42.809445,
			longitude: 31.31277833,
		},
		{
			latitude: 42.809445,
			longitude: 31.312785,
		},
		{
			latitude: 42.809445,
			longitude: 31.31278167,
		},
		{
			latitude: 42.80944333,
			longitude: 31.31278333,
		},
		{
			latitude: 42.80944667,
			longitude: 31.31278167,
		},
		{
			latitude: 42.80944667,
			longitude: 31.31278167,
		},
		{
			latitude: 42.809445,
			longitude: 31.31278,
		},
		{
			latitude: 42.80944667,
			longitude: 31.31277667,
		},
		{
			latitude: 42.80944667,
			longitude: 31.31278,
		},
		{
			latitude: 42.80944333,
			longitude: 31.31278167,
		},
		{
			latitude: 42.809445,
			longitude: 31.31278167,
		},
		{
			latitude: 42.80944667,
			longitude: 31.31278167,
		},
		{
			latitude: 42.80936833,
			longitude: 31.312935,
		},
		{
			latitude: 42.80937,
			longitude: 31.31292333,
		},
		{
			latitude: 42.80937167,
			longitude: 31.31292167,
		},
		{
			latitude: 42.809365,
			longitude: 31.312945,
		},
		{
			latitude: 42.809365,
			longitude: 31.31294333,
		},
		{
			latitude: 42.80936167,
			longitude: 31.31294167,
		},
		{
			latitude: 42.80936,
			longitude: 31.31295167,
		},
		{
			latitude: 42.80936,
			longitude: 31.312955,
		},
		{
			latitude: 42.80936,
			longitude: 31.312955,
		},
		{
			latitude: 42.80935833,
			longitude: 31.31295833,
		},
		{
			latitude: 42.80936,
			longitude: 31.31295333,
		},
		{
			latitude: 42.80936,
			longitude: 31.312955,
		},
		{
			latitude: 42.80936,
			longitude: 31.31296,
		},
		{
			latitude: 42.80936,
			longitude: 31.31295833,
		},
		{
			latitude: 42.80935833,
			longitude: 31.31296167,
		},
		{
			latitude: 42.80936,
			longitude: 31.31295167,
		},
		{
			latitude: 42.80936,
			longitude: 31.31295667,
		},
		{
			latitude: 42.80936167,
			longitude: 31.31296167,
		},
		{
			latitude: 42.80933,
			longitude: 31.31296,
		},
		{
			latitude: 42.80905333,
			longitude: 31.31271,
		},
		{
			latitude: 42.80905333,
			longitude: 31.312705,
		},
		{
			latitude: 42.80905333,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80905333,
			longitude: 31.31271,
		},
		{
			latitude: 42.80905667,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80905333,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80905333,
			longitude: 31.31271333,
		},
		{
			latitude: 42.809055,
			longitude: 31.312705,
		},
		{
			latitude: 42.80905333,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80911833,
			longitude: 31.31260167,
		},
		{
			latitude: 42.809555,
			longitude: 31.311895,
		},
		{
			latitude: 42.80999333,
			longitude: 31.31119667,
		},
		{
			latitude: 42.81042667,
			longitude: 31.310485,
		},
		{
			latitude: 42.810875,
			longitude: 31.309765,
		},
		{
			latitude: 42.81130667,
			longitude: 31.309065,
		},
		{
			latitude: 42.81174,
			longitude: 31.30835667,
		},
		{
			latitude: 42.812175,
			longitude: 31.30765333,
		},
		{
			latitude: 42.81252667,
			longitude: 31.30709,
		},
		{
			latitude: 42.81251833,
			longitude: 31.30712333,
		},
		{
			latitude: 42.81260833,
			longitude: 31.30697833,
		},
		{
			latitude: 42.81408667,
			longitude: 31.30252167,
		},
		{
			latitude: 42.81658,
			longitude: 31.28786167,
		},
		{
			latitude: 42.82059167,
			longitude: 31.27186167,
		},
		{
			latitude: 42.825245,
			longitude: 31.255945,
		},
		{
			latitude: 42.829855,
			longitude: 31.24011167,
		},
		{
			latitude: 42.83472167,
			longitude: 31.22439333,
		},
		{
			latitude: 42.839775,
			longitude: 31.20861,
		},
		{
			latitude: 42.84477667,
			longitude: 31.19399667,
		},
		{
			latitude: 42.84629167,
			longitude: 31.18925333,
		},
		{
			latitude: 42.84623167,
			longitude: 31.18865667,
		},
		{
			latitude: 42.84622,
			longitude: 31.18871167,
		},
		{
			latitude: 42.846225,
			longitude: 31.18870333,
		},
		{
			latitude: 42.846345,
			longitude: 31.18862833,
		},
		{
			latitude: 42.84637833,
			longitude: 31.18860167,
		},
		{
			latitude: 42.84637333,
			longitude: 31.18860333,
		},
		{
			latitude: 42.84637667,
			longitude: 31.1886,
		},
		{
			latitude: 42.84637167,
			longitude: 31.18862667,
		},
		{
			latitude: 42.84637333,
			longitude: 31.18862667,
		},
		{
			latitude: 42.84637167,
			longitude: 31.18862667,
		},
		{
			latitude: 42.84637167,
			longitude: 31.188635,
		},
		{
			latitude: 42.84637167,
			longitude: 31.18862667,
		},
		{
			latitude: 42.84637,
			longitude: 31.18862833,
		},
		{
			latitude: 42.84637,
			longitude: 31.188625,
		},
		{
			latitude: 42.84637167,
			longitude: 31.18863333,
		},
		{
			latitude: 42.84637167,
			longitude: 31.18863,
		},
		{
			latitude: 42.84637167,
			longitude: 31.18862833,
		},
		{
			latitude: 42.84637167,
			longitude: 31.18862833,
		},
		{
			latitude: 42.84637167,
			longitude: 31.18862667,
		},
		{
			latitude: 42.846375,
			longitude: 31.18863,
		},
		{
			latitude: 42.84637167,
			longitude: 31.18862833,
		},
		{
			latitude: 42.84637,
			longitude: 31.18862833,
		},
		{
			latitude: 42.84636,
			longitude: 31.18874833,
		},
		{
			latitude: 42.846285,
			longitude: 31.18876,
		},
		{
			latitude: 42.84622667,
			longitude: 31.18880167,
		},
		{
			latitude: 42.84622667,
			longitude: 31.18880667,
		},
		{
			latitude: 42.84622667,
			longitude: 31.18879333,
		},
		{
			latitude: 42.84622667,
			longitude: 31.18879833,
		},
		{
			latitude: 42.846225,
			longitude: 31.18879667,
		},
		{
			latitude: 42.84622667,
			longitude: 31.18879333,
		},
		{
			latitude: 42.84596167,
			longitude: 31.18900333,
		},
		{
			latitude: 42.84595333,
			longitude: 31.18901333,
		},
		{
			latitude: 42.84579833,
			longitude: 31.18912667,
		},
		{
			latitude: 42.84532667,
			longitude: 31.18949667,
		},
		{
			latitude: 42.84517,
			longitude: 31.18962667,
		},
		{
			latitude: 42.84517333,
			longitude: 31.18962333,
		},
		{
			latitude: 42.84517333,
			longitude: 31.189625,
		},
		{
			latitude: 42.84517333,
			longitude: 31.18961833,
		},
		{
			latitude: 42.845175,
			longitude: 31.18963833,
		},
		{
			latitude: 42.84517333,
			longitude: 31.189625,
		},
		{
			latitude: 42.84517167,
			longitude: 31.189615,
		},
		{
			latitude: 42.84517167,
			longitude: 31.18962667,
		},
		{
			latitude: 42.84517333,
			longitude: 31.18962333,
		},
		{
			latitude: 42.84517333,
			longitude: 31.189615,
		},
		{
			latitude: 42.842275,
			longitude: 31.19068667,
		},
		{
			latitude: 42.83229667,
			longitude: 31.19791,
		},
		{
			latitude: 42.82061833,
			longitude: 31.20630167,
		},
		{
			latitude: 42.80922333,
			longitude: 31.21451167,
		},
		{
			latitude: 42.79784667,
			longitude: 31.22261833,
		},
		{
			latitude: 42.78602333,
			longitude: 31.23093833,
		},
		{
			latitude: 42.77525167,
			longitude: 31.238735,
		},
		{
			latitude: 42.76369833,
			longitude: 31.24716833,
		},
		{
			latitude: 42.75185,
			longitude: 31.25577667,
		},
		{
			latitude: 42.74077,
			longitude: 31.26392667,
		},
		{
			latitude: 42.738075,
			longitude: 31.26589,
		},
		{
			latitude: 42.72935,
			longitude: 31.27222167,
		},
		{
			latitude: 42.71749667,
			longitude: 31.280605,
		},
		{
			latitude: 42.71275167,
			longitude: 31.28395333,
		},
		{
			latitude: 42.70516,
			longitude: 31.28936167,
		},
		{
			latitude: 42.69402167,
			longitude: 31.29695667,
		},
		{
			latitude: 42.68303167,
			longitude: 31.30410167,
		},
		{
			latitude: 42.66949833,
			longitude: 31.31266333,
		},
		{
			latitude: 42.65883,
			longitude: 31.31973667,
		},
		{
			latitude: 42.647015,
			longitude: 31.32789833,
		},
		{
			latitude: 42.63556333,
			longitude: 31.33578833,
		},
		{
			latitude: 42.623495,
			longitude: 31.344495,
		},
		{
			latitude: 42.61219167,
			longitude: 31.35263167,
		},
		{
			latitude: 42.60043333,
			longitude: 31.36095667,
		},
		{
			latitude: 42.58860167,
			longitude: 31.36907333,
		},
		{
			latitude: 42.57667833,
			longitude: 31.37721167,
		},
		{
			latitude: 42.56423833,
			longitude: 31.385655,
		},
		{
			latitude: 42.53566333,
			longitude: 31.40493,
		},
		{
			latitude: 42.52746,
			longitude: 31.41062167,
		},
		{
			latitude: 42.51628,
			longitude: 31.41848167,
		},
		{
			latitude: 42.5045,
			longitude: 31.42685833,
		},
		{
			latitude: 42.49288,
			longitude: 31.43510833,
		},
		{
			latitude: 42.480935,
			longitude: 31.44371167,
		},
		{
			latitude: 42.46930167,
			longitude: 31.45214333,
		},
		{
			latitude: 42.425,
			longitude: 31.485,
		},
		{
			latitude: 42.36,
			longitude: 31.53,
		},
		{
			latitude: 42.21833333,
			longitude: 31.62833333,
		},
		{
			latitude: 42.13166667,
			longitude: 31.68666667,
		},
		{
			latitude: 41.92684667,
			longitude: 31.82797333,
		},
		{
			latitude: 41.916665,
			longitude: 31.83484167,
		},
		{
			latitude: 41.9056,
			longitude: 31.842065,
		},
		{
			latitude: 41.89338667,
			longitude: 31.85032833,
		},
		{
			latitude: 41.87926167,
			longitude: 31.86013167,
		},
		{
			latitude: 41.86874667,
			longitude: 31.86765667,
		},
		{
			latitude: 41.860275,
			longitude: 31.87383833,
		},
		{
			latitude: 41.847325,
			longitude: 31.88340667,
		},
		{
			latitude: 41.83201167,
			longitude: 31.89444667,
		},
		{
			latitude: 41.82476167,
			longitude: 31.89960667,
		},
		{
			latitude: 41.81022167,
			longitude: 31.90986833,
		},
		{
			latitude: 41.79917333,
			longitude: 31.91762833,
		},
		{
			latitude: 41.78220333,
			longitude: 31.92949833,
		},
		{
			latitude: 41.77844833,
			longitude: 31.93214,
		},
		{
			latitude: 41.77660167,
			longitude: 31.933415,
		},
		{
			latitude: 41.76160833,
			longitude: 31.94451167,
		},
		{
			latitude: 41.756115,
			longitude: 31.94885333,
		},
		{
			latitude: 41.75420167,
			longitude: 31.95038,
		},
		{
			latitude: 41.74539833,
			longitude: 31.95731,
		},
		{
			latitude: 41.74306167,
			longitude: 31.9591,
		},
		{
			latitude: 41.73039167,
			longitude: 31.96861333,
		},
		{
			latitude: 41.720005,
			longitude: 31.97616667,
		},
		{
			latitude: 41.70890833,
			longitude: 31.98402167,
		},
		{
			latitude: 41.71286667,
			longitude: 31.98126167,
		},
		{
			latitude: 41.69778833,
			longitude: 31.99176833,
		},
		{
			latitude: 41.69581833,
			longitude: 31.99313333,
		},
		{
			latitude: 41.68205167,
			longitude: 32.00300833,
		},
		{
			latitude: 41.67164,
			longitude: 32.01131333,
		},
		{
			latitude: 41.66150833,
			longitude: 32.01924,
		},
		{
			latitude: 41.65407,
			longitude: 32.024785,
		},
		{
			latitude: 41.65193167,
			longitude: 32.02627667,
		},
		{
			latitude: 41.63983667,
			longitude: 32.03212667,
		},
		{
			latitude: 41.63143,
			longitude: 32.03572667,
		},
		{
			latitude: 41.63181333,
			longitude: 32.03556333,
		},
		{
			latitude: 41.61799167,
			longitude: 32.04287667,
		},
		{
			latitude: 41.610555,
			longitude: 32.047775,
		},
		{
			latitude: 41.59926,
			longitude: 32.05403167,
		},
		{
			latitude: 41.59854667,
			longitude: 32.05448333,
		},
		{
			latitude: 41.59317333,
			longitude: 32.06136833,
		},
		{
			latitude: 41.59292333,
			longitude: 32.06196667,
		},
		{
			latitude: 41.59004833,
			longitude: 32.07162667,
		},
		{
			latitude: 41.58620333,
			longitude: 32.07062667,
		},
		{
			latitude: 41.586125,
			longitude: 32.06992,
		},
		{
			latitude: 41.58608,
			longitude: 32.06936833,
		},
		{
			latitude: 41.58652167,
			longitude: 32.06840167,
		},
		{
			latitude: 41.58653,
			longitude: 32.06841667,
		},
		{
			latitude: 41.58663167,
			longitude: 32.06717,
		},
		{
			latitude: 41.58675667,
			longitude: 32.066475,
		},
		{
			latitude: 41.58667833,
			longitude: 32.066235,
		},
		{
			latitude: 41.58666,
			longitude: 32.06624333,
		},
		{
			latitude: 41.58665833,
			longitude: 32.066245,
		},
		{
			latitude: 41.58666167,
			longitude: 32.066245,
		},
		{
			latitude: 41.58666167,
			longitude: 32.06624333,
		},
		{
			latitude: 41.58666167,
			longitude: 32.06624333,
		},
		{
			latitude: 41.58666167,
			longitude: 32.066245,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624833,
		},
		{
			latitude: 41.58666333,
			longitude: 32.066245,
		},
		{
			latitude: 41.58666333,
			longitude: 32.066245,
		},
		{
			latitude: 41.58666333,
			longitude: 32.066245,
		},
		{
			latitude: 41.58666333,
			longitude: 32.066245,
		},
		{
			latitude: 41.58666333,
			longitude: 32.066245,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.066245,
		},
		{
			latitude: 41.58666333,
			longitude: 32.066245,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624833,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624833,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624833,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06625,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06625,
		},
		{
			latitude: 41.58666167,
			longitude: 32.06624167,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624833,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624833,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624833,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06624333,
		},
		{
			latitude: 41.586665,
			longitude: 32.06624667,
		},
		{
			latitude: 41.586665,
			longitude: 32.06624667,
		},
		{
			latitude: 41.586665,
			longitude: 32.06624833,
		},
		{
			latitude: 41.586665,
			longitude: 32.06624833,
		},
		{
			latitude: 41.58666667,
			longitude: 32.06666667,
		},
		{
			latitude: 41.58666667,
			longitude: 32.06666667,
		},
		{
			latitude: 41.58666333,
			longitude: 32.06625,
		},
		{
			latitude: 41.59072667,
			longitude: 32.07003167,
		},
		{
			latitude: 41.59097833,
			longitude: 32.06948167,
		},
		{
			latitude: 41.618375,
			longitude: 32.04473833,
		},
		{
			latitude: 42.26066667,
			longitude: 31.65649167,
		},
		{
			latitude: 42.30502,
			longitude: 31.628305,
		},
		{
			latitude: 42.31342167,
			longitude: 31.622865,
		},
		{
			latitude: 42.323615,
			longitude: 31.6163,
		},
		{
			latitude: 42.33264833,
			longitude: 31.61034833,
		},
		{
			latitude: 42.34639833,
			longitude: 31.60140833,
		},
		{
			latitude: 42.35283167,
			longitude: 31.59722167,
		},
		{
			latitude: 42.36841333,
			longitude: 31.587235,
		},
		{
			latitude: 42.37459167,
			longitude: 31.58322,
		},
		{
			latitude: 42.383335,
			longitude: 31.57755333,
		},
		{
			latitude: 42.392105,
			longitude: 31.57179833,
		},
		{
			latitude: 42.39439833,
			longitude: 31.57029167,
		},
		{
			latitude: 42.40138,
			longitude: 31.56569,
		},
		{
			latitude: 42.40983,
			longitude: 31.56015167,
		},
		{
			latitude: 42.41865,
			longitude: 31.554355,
		},
		{
			latitude: 42.42711333,
			longitude: 31.54870333,
		},
		{
			latitude: 42.43585,
			longitude: 31.54282333,
		},
		{
			latitude: 42.44489667,
			longitude: 31.53676833,
		},
		{
			latitude: 42.453315,
			longitude: 31.53111167,
		},
		{
			latitude: 42.46214833,
			longitude: 31.52527333,
		},
		{
			latitude: 42.47115333,
			longitude: 31.51919333,
		},
		{
			latitude: 42.480425,
			longitude: 31.51292167,
		},
		{
			latitude: 42.489175,
			longitude: 31.50706667,
		},
		{
			latitude: 42.49737,
			longitude: 31.50155333,
		},
		{
			latitude: 42.50584333,
			longitude: 31.49597333,
		},
		{
			latitude: 42.51454333,
			longitude: 31.49021333,
		},
		{
			latitude: 42.52317167,
			longitude: 31.484345,
		},
		{
			latitude: 42.53172333,
			longitude: 31.47843333,
		},
		{
			latitude: 42.54032667,
			longitude: 31.47255333,
		},
		{
			latitude: 42.548905,
			longitude: 31.46663667,
		},
		{
			latitude: 42.55738,
			longitude: 31.460755,
		},
		{
			latitude: 42.56617833,
			longitude: 31.454635,
		},
		{
			latitude: 42.57449833,
			longitude: 31.449035,
		},
		{
			latitude: 42.58304167,
			longitude: 31.44331833,
		},
		{
			latitude: 42.59162833,
			longitude: 31.43772333,
		},
		{
			latitude: 42.59336667,
			longitude: 31.436605,
		},
		{
			latitude: 42.60036667,
			longitude: 31.43214,
		},
		{
			latitude: 42.60914333,
			longitude: 31.42660833,
		},
		{
			latitude: 42.61783333,
			longitude: 31.42103167,
		},
		{
			latitude: 42.62685333,
			longitude: 31.41517333,
		},
		{
			latitude: 42.635925,
			longitude: 31.40959833,
		},
		{
			latitude: 42.64472667,
			longitude: 31.40429333,
		},
		{
			latitude: 42.65359833,
			longitude: 31.39903667,
		},
		{
			latitude: 42.66183167,
			longitude: 31.39422667,
		},
		{
			latitude: 42.670695,
			longitude: 31.38917667,
		},
		{
			latitude: 42.67954667,
			longitude: 31.38418333,
		},
		{
			latitude: 42.688515,
			longitude: 31.37913667,
		},
		{
			latitude: 42.69745833,
			longitude: 31.37403333,
		},
		{
			latitude: 42.70644833,
			longitude: 31.36886167,
		},
		{
			latitude: 42.71553,
			longitude: 31.36360833,
		},
		{
			latitude: 42.72467333,
			longitude: 31.35835667,
		},
		{
			latitude: 42.733945,
			longitude: 31.35306833,
		},
		{
			latitude: 42.74321667,
			longitude: 31.34785,
		},
		{
			latitude: 42.75285,
			longitude: 31.342565,
		},
		{
			latitude: 42.761935,
			longitude: 31.33768,
		},
		{
			latitude: 42.771605,
			longitude: 31.33253167,
		},
		{
			latitude: 42.78078833,
			longitude: 31.32678167,
		},
		{
			latitude: 42.78961833,
			longitude: 31.32043333,
		},
		{
			latitude: 42.79810667,
			longitude: 31.31409833,
		},
		{
			latitude: 42.80689333,
			longitude: 31.307535,
		},
		{
			latitude: 42.81578,
			longitude: 31.301005,
		},
		{
			latitude: 42.82438,
			longitude: 31.29422,
		},
		{
			latitude: 42.83283667,
			longitude: 31.28723667,
		},
		{
			latitude: 42.84132333,
			longitude: 31.28027167,
		},
		{
			latitude: 42.84987,
			longitude: 31.27338833,
		},
		{
			latitude: 42.85812,
			longitude: 31.26582667,
		},
		{
			latitude: 42.86543667,
			longitude: 31.256995,
		},
		{
			latitude: 42.86728667,
			longitude: 31.24888,
		},
		{
			latitude: 42.86777333,
			longitude: 31.24655333,
		},
		{
			latitude: 42.86768167,
			longitude: 31.24626167,
		},
		{
			latitude: 42.8677,
			longitude: 31.24630833,
		},
		{
			latitude: 42.86770167,
			longitude: 31.24630833,
		},
		{
			latitude: 42.8677,
			longitude: 31.24630833,
		},
		{
			latitude: 42.8677,
			longitude: 31.24631,
		},
		{
			latitude: 42.86784,
			longitude: 31.24625833,
		},
		{
			latitude: 42.867835,
			longitude: 31.24624667,
		},
		{
			latitude: 42.867835,
			longitude: 31.24624667,
		},
		{
			latitude: 42.867835,
			longitude: 31.24624833,
		},
		{
			latitude: 42.86828333,
			longitude: 31.24624833,
		},
		{
			latitude: 42.86882333,
			longitude: 31.24624667,
		},
		{
			latitude: 42.86936333,
			longitude: 31.24624667,
		},
		{
			latitude: 42.869905,
			longitude: 31.24624667,
		},
		{
			latitude: 42.870445,
			longitude: 31.24624667,
		},
		{
			latitude: 42.870985,
			longitude: 31.246245,
		},
		{
			latitude: 42.87143667,
			longitude: 31.24625167,
		},
		{
			latitude: 42.87143667,
			longitude: 31.246245,
		},
		{
			latitude: 42.87143667,
			longitude: 31.24624833,
		},
		{
			latitude: 42.87143667,
			longitude: 31.24624833,
		},
		{
			latitude: 42.871435,
			longitude: 31.24624667,
		},
		{
			latitude: 42.871435,
			longitude: 31.24624667,
		},
		{
			latitude: 42.87143667,
			longitude: 31.24624833,
		},
		{
			latitude: 42.87143667,
			longitude: 31.24624667,
		},
		{
			latitude: 42.871435,
			longitude: 31.24624667,
		},
		{
			latitude: 42.87143667,
			longitude: 31.24624833,
		},
		{
			latitude: 42.871435,
			longitude: 31.24624667,
		},
		{
			latitude: 42.871435,
			longitude: 31.24625,
		},
		{
			latitude: 42.871435,
			longitude: 31.24624833,
		},
		{
			latitude: 42.871435,
			longitude: 31.246245,
		},
		{
			latitude: 42.87143667,
			longitude: 31.24624833,
		},
		{
			latitude: 42.871435,
			longitude: 31.246245,
		},
		{
			latitude: 42.87143667,
			longitude: 31.24624833,
		},
		{
			latitude: 42.871435,
			longitude: 31.246245,
		},
		{
			latitude: 42.871435,
			longitude: 31.24624833,
		},
		{
			latitude: 42.871435,
			longitude: 31.24624833,
		},
		{
			latitude: 42.87141833,
			longitude: 31.246195,
		},
		{
			latitude: 42.87141667,
			longitude: 31.24619,
		},
		{
			latitude: 42.87141833,
			longitude: 31.24619333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24601833,
		},
		{
			latitude: 42.871385,
			longitude: 31.24602,
		},
		{
			latitude: 42.87138667,
			longitude: 31.24602333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24602333,
		},
		{
			latitude: 42.87138667,
			longitude: 31.246025,
		},
		{
			latitude: 42.87138667,
			longitude: 31.24602667,
		},
		{
			latitude: 42.87138667,
			longitude: 31.246025,
		},
		{
			latitude: 42.87138667,
			longitude: 31.246025,
		},
		{
			latitude: 42.87138667,
			longitude: 31.24602333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24602333,
		},
		{
			latitude: 42.87138667,
			longitude: 31.246025,
		},
		{
			latitude: 42.87138667,
			longitude: 31.24602167,
		},
		{
			latitude: 42.87138667,
			longitude: 31.246015,
		},
		{
			latitude: 42.871385,
			longitude: 31.24601667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24601667,
		},
		{
			latitude: 42.871385,
			longitude: 31.246015,
		},
		{
			latitude: 42.871385,
			longitude: 31.24602,
		},
		{
			latitude: 42.871385,
			longitude: 31.24601667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24601667,
		},
		{
			latitude: 42.87138667,
			longitude: 31.24601833,
		},
		{
			latitude: 42.87138667,
			longitude: 31.24602167,
		},
		{
			latitude: 42.871385,
			longitude: 31.246015,
		},
		{
			latitude: 42.871385,
			longitude: 31.246015,
		},
		{
			latitude: 42.871385,
			longitude: 31.24601833,
		},
		{
			latitude: 42.871385,
			longitude: 31.24602,
		},
		{
			latitude: 42.871385,
			longitude: 31.24601833,
		},
		{
			latitude: 42.87138667,
			longitude: 31.24602833,
		},
		{
			latitude: 42.871385,
			longitude: 31.24602667,
		},
		{
			latitude: 42.87138167,
			longitude: 31.24596,
		},
		{
			latitude: 42.87138667,
			longitude: 31.245845,
		},
		{
			latitude: 42.87138833,
			longitude: 31.24584,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24589667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138167,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138167,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591167,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590333,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590833,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591167,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591333,
		},
		{
			latitude: 42.87138333,
			longitude: 31.245895,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138167,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.245905,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.245905,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591167,
		},
		{
			latitude: 42.87138333,
			longitude: 31.245905,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138167,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591667,
		},
		{
			latitude: 42.87138167,
			longitude: 31.24591667,
		},
		{
			latitude: 42.87138167,
			longitude: 31.24592167,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591167,
		},
		{
			latitude: 42.871385,
			longitude: 31.245905,
		},
		{
			latitude: 42.87138333,
			longitude: 31.245905,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.245915,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591333,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24592333,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.24589833,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138167,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590833,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.245905,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590833,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590833,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590167,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590167,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590833,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138167,
			longitude: 31.24590333,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591167,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590333,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590833,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591167,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591333,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591333,
		},
		{
			latitude: 42.871385,
			longitude: 31.245915,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591167,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590833,
		},
		{
			latitude: 42.871385,
			longitude: 31.245905,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591167,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591167,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590667,
		},
		{
			latitude: 42.871385,
			longitude: 31.245905,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590833,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590833,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.2459,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590833,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590833,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138333,
			longitude: 31.245905,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24590667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590833,
		},
		{
			latitude: 42.871385,
			longitude: 31.245905,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87138667,
			longitude: 31.24590667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591167,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591833,
		},
		{
			latitude: 42.871385,
			longitude: 31.24592167,
		},
		{
			latitude: 42.87138333,
			longitude: 31.245915,
		},
		{
			latitude: 42.87138667,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590667,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590833,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.24590833,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591167,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591167,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591167,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591333,
		},
		{
			latitude: 42.87138333,
			longitude: 31.24591833,
		},
		{
			latitude: 42.871385,
			longitude: 31.245915,
		},
		{
			latitude: 42.87138333,
			longitude: 31.245915,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591333,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591,
		},
		{
			latitude: 42.871385,
			longitude: 31.245915,
		},
		{
			latitude: 42.871385,
			longitude: 31.245915,
		},
		{
			latitude: 42.871385,
			longitude: 31.24592,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591833,
		},
		{
			latitude: 42.871385,
			longitude: 31.24592167,
		},
		{
			latitude: 42.871385,
			longitude: 31.24591833,
		},
		{
			latitude: 42.87127167,
			longitude: 31.24590667,
		},
		{
			latitude: 42.87126833,
			longitude: 31.245905,
		},
		{
			latitude: 42.87113667,
			longitude: 31.24589167,
		},
		{
			latitude: 42.87101167,
			longitude: 31.24588167,
		},
		{
			latitude: 42.87087833,
			longitude: 31.245865,
		},
		{
			latitude: 42.87074167,
			longitude: 31.24583667,
		},
		{
			latitude: 42.87061,
			longitude: 31.24583333,
		},
		{
			latitude: 42.87047167,
			longitude: 31.245795,
		},
		{
			latitude: 42.87034,
			longitude: 31.24578667,
		},
		{
			latitude: 42.870205,
			longitude: 31.245775,
		},
		{
			latitude: 42.87007167,
			longitude: 31.24576167,
		},
		{
			latitude: 42.86994,
			longitude: 31.24575,
		},
		{
			latitude: 42.8698,
			longitude: 31.24572833,
		},
		{
			latitude: 42.86966667,
			longitude: 31.24571333,
		},
		{
			latitude: 42.86952833,
			longitude: 31.24568667,
		},
		{
			latitude: 42.86938833,
			longitude: 31.24567,
		},
		{
			latitude: 42.86936167,
			longitude: 31.24566667,
		},
		{
			latitude: 42.86926333,
			longitude: 31.24565667,
		},
		{
			latitude: 42.86912833,
			longitude: 31.24563833,
		},
		{
			latitude: 42.86908833,
			longitude: 31.24563667,
		},
		{
			latitude: 42.86899333,
			longitude: 31.24562333,
		},
		{
			latitude: 42.86886,
			longitude: 31.24560833,
		},
		{
			latitude: 42.86881667,
			longitude: 31.245605,
		},
		{
			latitude: 42.86871333,
			longitude: 31.24559167,
		},
		{
			latitude: 42.86859167,
			longitude: 31.24558333,
		},
		{
			latitude: 42.86874333,
			longitude: 31.24559333,
		},
		{
			latitude: 42.868515,
			longitude: 31.24556667,
		},
		{
			latitude: 42.86851667,
			longitude: 31.24556,
		},
		{
			latitude: 42.868515,
			longitude: 31.24556167,
		},
		{
			latitude: 42.868515,
			longitude: 31.24556667,
		},
		{
			latitude: 42.86851667,
			longitude: 31.24557,
		},
		{
			latitude: 42.868515,
			longitude: 31.245565,
		},
		{
			latitude: 42.868515,
			longitude: 31.245565,
		},
		{
			latitude: 42.868515,
			longitude: 31.245565,
		},
		{
			latitude: 42.868515,
			longitude: 31.24556333,
		},
		{
			latitude: 42.868515,
			longitude: 31.245565,
		},
		{
			latitude: 42.868515,
			longitude: 31.24556,
		},
		{
			latitude: 42.868515,
			longitude: 31.24556833,
		},
		{
			latitude: 42.86851667,
			longitude: 31.24556333,
		},
		{
			latitude: 42.86851667,
			longitude: 31.24556833,
		},
		{
			latitude: 42.86877333,
			longitude: 31.245565,
		},
		{
			latitude: 42.869065,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869315,
			longitude: 31.24556667,
		},
		{
			latitude: 42.86941667,
			longitude: 31.24556667,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.86941667,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.245565,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.86941667,
			longitude: 31.24555833,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.245565,
		},
		{
			latitude: 42.869415,
			longitude: 31.245565,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.245565,
		},
		{
			latitude: 42.869415,
			longitude: 31.245565,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556167,
		},
		{
			latitude: 42.869415,
			longitude: 31.245565,
		},
		{
			latitude: 42.869415,
			longitude: 31.24556333,
		},
		{
			latitude: 42.86941333,
			longitude: 31.24556,
		},
		{
			latitude: 42.869415,
			longitude: 31.245565,
		},
		{
			latitude: 42.86930833,
			longitude: 31.24564667,
		},
		{
			latitude: 42.86919167,
			longitude: 31.245735,
		},
		{
			latitude: 42.86906333,
			longitude: 31.24583833,
		},
		{
			latitude: 42.868955,
			longitude: 31.24592333,
		},
		{
			latitude: 42.86884333,
			longitude: 31.24601667,
		},
		{
			latitude: 42.868725,
			longitude: 31.24610833,
		},
		{
			latitude: 42.86860667,
			longitude: 31.24619833,
		},
		{
			latitude: 42.86849,
			longitude: 31.24628833,
		},
		{
			latitude: 42.86836333,
			longitude: 31.24638833,
		},
		{
			latitude: 42.86825,
			longitude: 31.24647833,
		},
		{
			latitude: 42.86814,
			longitude: 31.246565,
		},
		{
			latitude: 42.86802333,
			longitude: 31.24666,
		},
		{
			latitude: 42.86790667,
			longitude: 31.24674833,
		},
		{
			latitude: 42.867725,
			longitude: 31.24688833,
		},
		{
			latitude: 42.86748667,
			longitude: 31.24706333,
		},
		{
			latitude: 42.86721667,
			longitude: 31.24709333,
		},
		{
			latitude: 42.86695667,
			longitude: 31.24712833,
		},
		{
			latitude: 42.86668833,
			longitude: 31.24716167,
		},
		{
			latitude: 42.86641833,
			longitude: 31.24719167,
		},
		{
			latitude: 42.86615,
			longitude: 31.247225,
		},
		{
			latitude: 42.86588,
			longitude: 31.24725333,
		},
		{
			latitude: 42.86559333,
			longitude: 31.24729,
		},
		{
			latitude: 42.86534167,
			longitude: 31.24732167,
		},
		{
			latitude: 42.86507333,
			longitude: 31.24735167,
		},
		{
			latitude: 42.86487333,
			longitude: 31.247365,
		},
		{
			latitude: 42.86460333,
			longitude: 31.24734667,
		},
		{
			latitude: 42.864335,
			longitude: 31.24732667,
		},
		{
			latitude: 42.864065,
			longitude: 31.24731,
		},
		{
			latitude: 42.86378833,
			longitude: 31.24728167,
		},
		{
			latitude: 42.86351667,
			longitude: 31.24727,
		},
		{
			latitude: 42.86323,
			longitude: 31.24724167,
		},
		{
			latitude: 42.86298833,
			longitude: 31.24723333,
		},
		{
			latitude: 42.86271667,
			longitude: 31.24721,
		},
		{
			latitude: 42.86244667,
			longitude: 31.24719,
		},
		{
			latitude: 42.86224833,
			longitude: 31.24712333,
		},
		{
			latitude: 42.86199,
			longitude: 31.24703667,
		},
		{
			latitude: 42.86172833,
			longitude: 31.246935,
		},
		{
			latitude: 42.86159833,
			longitude: 31.24688667,
		},
		{
			latitude: 42.86159667,
			longitude: 31.246635,
		},
		{
			latitude: 42.86159833,
			longitude: 31.246235,
		},
		{
			latitude: 42.86159667,
			longitude: 31.24610833,
		},
		{
			latitude: 42.86159333,
			longitude: 31.246095,
		},
		{
			latitude: 42.861595,
			longitude: 31.2461,
		},
		{
			latitude: 42.86159333,
			longitude: 31.24610333,
		},
		{
			latitude: 42.86159833,
			longitude: 31.246105,
		},
		{
			latitude: 42.86159667,
			longitude: 31.24611667,
		},
		{
			latitude: 42.86159667,
			longitude: 31.24609333,
		},
		{
			latitude: 42.86159667,
			longitude: 31.24611167,
		},
		{
			latitude: 42.86159667,
			longitude: 31.246095,
		},
		{
			latitude: 42.86159833,
			longitude: 31.24609333,
		},
		{
			latitude: 42.86160167,
			longitude: 31.246085,
		},
		{
			latitude: 42.86159833,
			longitude: 31.24609333,
		},
		{
			latitude: 42.86159833,
			longitude: 31.24609333,
		},
		{
			latitude: 42.86159833,
			longitude: 31.24609333,
		},
		{
			latitude: 42.86159833,
			longitude: 31.24608833,
		},
		{
			latitude: 42.86159667,
			longitude: 31.2461,
		},
		{
			latitude: 42.86159667,
			longitude: 31.24609,
		},
		{
			latitude: 42.86159833,
			longitude: 31.24609167,
		},
		{
			latitude: 42.86159833,
			longitude: 31.2461,
		},
		{
			latitude: 42.86159667,
			longitude: 31.2461,
		},
		{
			latitude: 42.86159833,
			longitude: 31.246095,
		},
		{
			latitude: 42.86159667,
			longitude: 31.24609833,
		},
		{
			latitude: 42.86168833,
			longitude: 31.24611167,
		},
		{
			latitude: 42.86168833,
			longitude: 31.24611667,
		},
		{
			latitude: 42.86168667,
			longitude: 31.24611,
		},
		{
			latitude: 42.86168833,
			longitude: 31.24611,
		},
		{
			latitude: 42.86168667,
			longitude: 31.24610833,
		},
		{
			latitude: 42.86168667,
			longitude: 31.24611,
		},
		{
			latitude: 42.86168833,
			longitude: 31.246115,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24611667,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24612167,
		},
		{
			latitude: 42.86176833,
			longitude: 31.24607833,
		},
		{
			latitude: 42.861725,
			longitude: 31.24613,
		},
		{
			latitude: 42.86172333,
			longitude: 31.24614,
		},
		{
			latitude: 42.861725,
			longitude: 31.246135,
		},
		{
			latitude: 42.861725,
			longitude: 31.24612833,
		},
		{
			latitude: 42.861725,
			longitude: 31.24613333,
		},
		{
			latitude: 42.861725,
			longitude: 31.24613333,
		},
		{
			latitude: 42.86172333,
			longitude: 31.24613333,
		},
		{
			latitude: 42.861725,
			longitude: 31.24614,
		},
		{
			latitude: 42.86172667,
			longitude: 31.24613667,
		},
		{
			latitude: 42.86172667,
			longitude: 31.24612833,
		},
		{
			latitude: 42.86172667,
			longitude: 31.24614167,
		},
		{
			latitude: 42.861725,
			longitude: 31.24613,
		},
		{
			latitude: 42.86172333,
			longitude: 31.24613167,
		},
		{
			latitude: 42.861725,
			longitude: 31.24613833,
		},
		{
			latitude: 42.861725,
			longitude: 31.24613333,
		},
		{
			latitude: 42.861725,
			longitude: 31.24613333,
		},
		{
			latitude: 42.86172333,
			longitude: 31.24613167,
		},
		{
			latitude: 42.86172167,
			longitude: 31.24613,
		},
		{
			latitude: 42.861725,
			longitude: 31.246135,
		},
		{
			latitude: 42.861725,
			longitude: 31.24613333,
		},
		{
			latitude: 42.861725,
			longitude: 31.24613833,
		},
		{
			latitude: 42.86179333,
			longitude: 31.24612,
		},
		{
			latitude: 42.86179333,
			longitude: 31.246135,
		},
		{
			latitude: 42.861795,
			longitude: 31.24612833,
		},
		{
			latitude: 42.86179167,
			longitude: 31.246145,
		},
		{
			latitude: 42.86179167,
			longitude: 31.24613167,
		},
		{
			latitude: 42.86179167,
			longitude: 31.24612333,
		},
		{
			latitude: 42.86179,
			longitude: 31.24614,
		},
		{
			latitude: 42.86178833,
			longitude: 31.24612833,
		},
		{
			latitude: 42.86179333,
			longitude: 31.24612667,
		},
		{
			latitude: 42.86179167,
			longitude: 31.24612833,
		},
		{
			latitude: 42.86179,
			longitude: 31.24612333,
		},
		{
			latitude: 42.86179667,
			longitude: 31.24612667,
		},
		{
			latitude: 42.86179333,
			longitude: 31.24614333,
		},
		{
			latitude: 42.861795,
			longitude: 31.24612667,
		},
		{
			latitude: 42.86179167,
			longitude: 31.24613167,
		},
		{
			latitude: 42.86179,
			longitude: 31.24613833,
		},
		{
			latitude: 42.86179,
			longitude: 31.24613,
		},
		{
			latitude: 42.86179167,
			longitude: 31.24613333,
		},
		{
			latitude: 42.86179333,
			longitude: 31.24613833,
		},
		{
			latitude: 42.86178833,
			longitude: 31.24612,
		},
		{
			latitude: 42.86179167,
			longitude: 31.24613,
		},
		{
			latitude: 42.86179167,
			longitude: 31.24612833,
		},
		{
			latitude: 42.86162333,
			longitude: 31.24633,
		},
		{
			latitude: 42.86141833,
			longitude: 31.246565,
		},
		{
			latitude: 42.861205,
			longitude: 31.246795,
		},
		{
			latitude: 42.86099833,
			longitude: 31.24702667,
		},
		{
			latitude: 42.86079167,
			longitude: 31.24727167,
		},
		{
			latitude: 42.86076,
			longitude: 31.24730333,
		},
		{
			latitude: 42.86075833,
			longitude: 31.24732,
		},
		{
			latitude: 42.86075667,
			longitude: 31.24731333,
		},
		{
			latitude: 42.86075833,
			longitude: 31.24731167,
		},
		{
			latitude: 42.86076333,
			longitude: 31.24731833,
		},
		{
			latitude: 42.86075833,
			longitude: 31.24731,
		},
		{
			latitude: 42.86076,
			longitude: 31.2473,
		},
		{
			latitude: 42.86076,
			longitude: 31.247315,
		},
		{
			latitude: 42.86075667,
			longitude: 31.24730167,
		},
		{
			latitude: 42.86075833,
			longitude: 31.2473,
		},
		{
			latitude: 42.86076167,
			longitude: 31.24732333,
		},
		{
			latitude: 42.86075833,
			longitude: 31.24731167,
		},
		{
			latitude: 42.86076333,
			longitude: 31.24729667,
		},
		{
			latitude: 42.86076167,
			longitude: 31.24731333,
		},
		{
			latitude: 42.86075833,
			longitude: 31.24732167,
		},
		{
			latitude: 42.86077833,
			longitude: 31.24711333,
		},
		{
			latitude: 42.860755,
			longitude: 31.24725,
		},
		{
			latitude: 42.86076333,
			longitude: 31.24725,
		},
		{
			latitude: 42.86075833,
			longitude: 31.24723167,
		},
		{
			latitude: 42.860765,
			longitude: 31.24723833,
		},
		{
			latitude: 42.86076167,
			longitude: 31.24721833,
		},
		{
			latitude: 42.860795,
			longitude: 31.247085,
		},
		{
			latitude: 42.86078833,
			longitude: 31.24710333,
		},
		{
			latitude: 42.86078333,
			longitude: 31.24712833,
		},
		{
			latitude: 42.86077,
			longitude: 31.24714667,
		},
		{
			latitude: 42.86077167,
			longitude: 31.24713167,
		},
		{
			latitude: 42.86087333,
			longitude: 31.24692167,
		},
		{
			latitude: 42.86079333,
			longitude: 31.24711333,
		},
		{
			latitude: 42.86077167,
			longitude: 31.24711333,
		},
		{
			latitude: 42.86078667,
			longitude: 31.24711167,
		},
		{
			latitude: 42.86078833,
			longitude: 31.24711667,
		},
		{
			latitude: 42.86079,
			longitude: 31.24712,
		},
		{
			latitude: 42.86078333,
			longitude: 31.24711667,
		},
		{
			latitude: 42.86078333,
			longitude: 31.24713167,
		},
		{
			latitude: 42.86077667,
			longitude: 31.24709333,
		},
		{
			latitude: 42.86078,
			longitude: 31.24711,
		},
		{
			latitude: 42.86080167,
			longitude: 31.247095,
		},
		{
			latitude: 42.8608,
			longitude: 31.24710333,
		},
		{
			latitude: 42.86078667,
			longitude: 31.24711833,
		},
		{
			latitude: 42.86077333,
			longitude: 31.247085,
		},
		{
			latitude: 42.8608,
			longitude: 31.24710667,
		},
		{
			latitude: 42.86079167,
			longitude: 31.24709167,
		},
		{
			latitude: 42.86078333,
			longitude: 31.247105,
		},
		{
			latitude: 42.86078667,
			longitude: 31.24712833,
		},
		{
			latitude: 42.860795,
			longitude: 31.24711667,
		},
		{
			latitude: 42.860795,
			longitude: 31.24709667,
		},
		{
			latitude: 42.86078333,
			longitude: 31.24710667,
		},
		{
			latitude: 42.86077667,
			longitude: 31.247095,
		},
		{
			latitude: 42.86078167,
			longitude: 31.24711833,
		},
		{
			latitude: 42.86079,
			longitude: 31.24712833,
		},
		{
			latitude: 42.86078167,
			longitude: 31.2471,
		},
		{
			latitude: 42.860785,
			longitude: 31.2471,
		},
		{
			latitude: 42.86078167,
			longitude: 31.24709,
		},
		{
			latitude: 42.86078,
			longitude: 31.24711167,
		},
		{
			latitude: 42.86080333,
			longitude: 31.24716333,
		},
		{
			latitude: 42.86082667,
			longitude: 31.24698167,
		},
		{
			latitude: 42.860845,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86087333,
			longitude: 31.246885,
		},
		{
			latitude: 42.86087167,
			longitude: 31.24689167,
		},
		{
			latitude: 42.860875,
			longitude: 31.24687833,
		},
		{
			latitude: 42.86088,
			longitude: 31.24686833,
		},
		{
			latitude: 42.860885,
			longitude: 31.24686,
		},
		{
			latitude: 42.86088333,
			longitude: 31.24687,
		},
		{
			latitude: 42.86088,
			longitude: 31.24687167,
		},
		{
			latitude: 42.860865,
			longitude: 31.24687833,
		},
		{
			latitude: 42.86087333,
			longitude: 31.24686833,
		},
		{
			latitude: 42.86087167,
			longitude: 31.24686833,
		},
		{
			latitude: 42.86087833,
			longitude: 31.24686333,
		},
		{
			latitude: 42.86088,
			longitude: 31.24689167,
		},
		{
			latitude: 42.86088167,
			longitude: 31.24688833,
		},
		{
			latitude: 42.86086333,
			longitude: 31.24689167,
		},
		{
			latitude: 42.86088167,
			longitude: 31.24688667,
		},
		{
			latitude: 42.86087167,
			longitude: 31.24686333,
		},
		{
			latitude: 42.86087833,
			longitude: 31.24687833,
		},
		{
			latitude: 42.860885,
			longitude: 31.24687333,
		},
		{
			latitude: 42.86088667,
			longitude: 31.24688833,
		},
		{
			latitude: 42.86087,
			longitude: 31.24684833,
		},
		{
			latitude: 42.86088,
			longitude: 31.24687667,
		},
		{
			latitude: 42.86087,
			longitude: 31.24688667,
		},
		{
			latitude: 42.86097833,
			longitude: 31.24675,
		},
		{
			latitude: 42.861025,
			longitude: 31.24670333,
		},
		{
			latitude: 42.86113833,
			longitude: 31.24662333,
		},
		{
			latitude: 42.86119,
			longitude: 31.24658,
		},
		{
			latitude: 42.86119833,
			longitude: 31.2466,
		},
		{
			latitude: 42.86120667,
			longitude: 31.24660333,
		},
		{
			latitude: 42.86121833,
			longitude: 31.24662667,
		},
		{
			latitude: 42.8612,
			longitude: 31.24662333,
		},
		{
			latitude: 42.86118667,
			longitude: 31.24659833,
		},
		{
			latitude: 42.86122,
			longitude: 31.24662,
		},
		{
			latitude: 42.86119333,
			longitude: 31.246605,
		},
		{
			latitude: 42.86119333,
			longitude: 31.24661833,
		},
		{
			latitude: 42.86121,
			longitude: 31.24659833,
		},
		{
			latitude: 42.86120833,
			longitude: 31.24660833,
		},
		{
			latitude: 42.86118167,
			longitude: 31.24661,
		},
		{
			latitude: 42.86121333,
			longitude: 31.24661167,
		},
		{
			latitude: 42.86119667,
			longitude: 31.24660833,
		},
		{
			latitude: 42.86119833,
			longitude: 31.24660667,
		},
		{
			latitude: 42.86117333,
			longitude: 31.24661833,
		},
		{
			latitude: 42.86119833,
			longitude: 31.24662167,
		},
		{
			latitude: 42.8612,
			longitude: 31.246615,
		},
		{
			latitude: 42.86131667,
			longitude: 31.24658667,
		},
		{
			latitude: 42.86129833,
			longitude: 31.246595,
		},
		{
			latitude: 42.86131,
			longitude: 31.246585,
		},
		{
			latitude: 42.86130167,
			longitude: 31.24660167,
		},
		{
			latitude: 42.86130333,
			longitude: 31.24659167,
		},
		{
			latitude: 42.86128667,
			longitude: 31.24659333,
		},
		{
			latitude: 42.86128667,
			longitude: 31.24659,
		},
		{
			latitude: 42.861305,
			longitude: 31.24659333,
		},
		{
			latitude: 42.86129667,
			longitude: 31.246595,
		},
		{
			latitude: 42.86128667,
			longitude: 31.24659,
		},
		{
			latitude: 42.86129833,
			longitude: 31.24659333,
		},
		{
			latitude: 42.861295,
			longitude: 31.24659,
		},
		{
			latitude: 42.861275,
			longitude: 31.24659333,
		},
		{
			latitude: 42.861295,
			longitude: 31.24659167,
		},
		{
			latitude: 42.8613,
			longitude: 31.24659167,
		},
		{
			latitude: 42.86131333,
			longitude: 31.24659833,
		},
		{
			latitude: 42.8613,
			longitude: 31.24659667,
		},
		{
			latitude: 42.86129833,
			longitude: 31.2466,
		},
		{
			latitude: 42.86129667,
			longitude: 31.24659,
		},
		{
			latitude: 42.86132667,
			longitude: 31.24661333,
		},
		{
			latitude: 42.86128167,
			longitude: 31.246595,
		},
		{
			latitude: 42.8613,
			longitude: 31.24659833,
		},
		{
			latitude: 42.86130333,
			longitude: 31.246585,
		},
		{
			latitude: 42.861295,
			longitude: 31.24659333,
		},
		{
			latitude: 42.86129,
			longitude: 31.2466,
		},
		{
			latitude: 42.86129167,
			longitude: 31.246615,
		},
		{
			latitude: 42.86130167,
			longitude: 31.24659,
		},
		{
			latitude: 42.86130333,
			longitude: 31.24659167,
		},
		{
			latitude: 42.8613,
			longitude: 31.2466,
		},
		{
			latitude: 42.861295,
			longitude: 31.24659833,
		},
		{
			latitude: 42.86128333,
			longitude: 31.24659833,
		},
		{
			latitude: 42.86130833,
			longitude: 31.24658667,
		},
		{
			latitude: 42.86127333,
			longitude: 31.2466,
		},
		{
			latitude: 42.86129167,
			longitude: 31.24659167,
		},
		{
			latitude: 42.861305,
			longitude: 31.24659,
		},
		{
			latitude: 42.86130167,
			longitude: 31.24659167,
		},
		{
			latitude: 42.86129,
			longitude: 31.24658667,
		},
		{
			latitude: 42.8613,
			longitude: 31.24661,
		},
		{
			latitude: 42.86128833,
			longitude: 31.24658833,
		},
		{
			latitude: 42.86129,
			longitude: 31.246585,
		},
		{
			latitude: 42.86131333,
			longitude: 31.24661167,
		},
		{
			latitude: 42.86129667,
			longitude: 31.24659333,
		},
		{
			latitude: 42.86130167,
			longitude: 31.24659333,
		},
		{
			latitude: 42.86131167,
			longitude: 31.24659167,
		},
		{
			latitude: 42.86130833,
			longitude: 31.24659167,
		},
		{
			latitude: 42.86129,
			longitude: 31.24660333,
		},
		{
			latitude: 42.86125667,
			longitude: 31.2467,
		},
		{
			latitude: 42.86112667,
			longitude: 31.24704,
		},
		{
			latitude: 42.86104,
			longitude: 31.24736,
		},
		{
			latitude: 42.86093167,
			longitude: 31.24769667,
		},
		{
			latitude: 42.86080833,
			longitude: 31.24802833,
		},
		{
			latitude: 42.86072167,
			longitude: 31.24825833,
		},
		{
			latitude: 42.86071667,
			longitude: 31.24827667,
		},
		{
			latitude: 42.86073667,
			longitude: 31.24824667,
		},
		{
			latitude: 42.86072833,
			longitude: 31.24826833,
		},
		{
			latitude: 42.86072333,
			longitude: 31.248275,
		},
		{
			latitude: 42.86089,
			longitude: 31.24828833,
		},
		{
			latitude: 42.860815,
			longitude: 31.24826,
		},
		{
			latitude: 42.86082667,
			longitude: 31.24826333,
		},
		{
			latitude: 42.86082167,
			longitude: 31.24826833,
		},
		{
			latitude: 42.860825,
			longitude: 31.24827667,
		},
		{
			latitude: 42.860825,
			longitude: 31.24828167,
		},
		{
			latitude: 42.860825,
			longitude: 31.24827167,
		},
		{
			latitude: 42.86084167,
			longitude: 31.24826833,
		},
		{
			latitude: 42.86083667,
			longitude: 31.24827833,
		},
		{
			latitude: 42.860815,
			longitude: 31.248265,
		},
		{
			latitude: 42.86082,
			longitude: 31.24826667,
		},
		{
			latitude: 42.860815,
			longitude: 31.24826167,
		},
		{
			latitude: 42.86082333,
			longitude: 31.248285,
		},
		{
			latitude: 42.86083,
			longitude: 31.24827333,
		},
		{
			latitude: 42.86084833,
			longitude: 31.24827667,
		},
		{
			latitude: 42.86082333,
			longitude: 31.24826667,
		},
		{
			latitude: 42.86081333,
			longitude: 31.248265,
		},
		{
			latitude: 42.86082167,
			longitude: 31.24827167,
		},
		{
			latitude: 42.860825,
			longitude: 31.24826167,
		},
		{
			latitude: 42.86081667,
			longitude: 31.24826167,
		},
		{
			latitude: 42.86082,
			longitude: 31.24827167,
		},
		{
			latitude: 42.86082,
			longitude: 31.24825833,
		},
		{
			latitude: 42.86083,
			longitude: 31.24828,
		},
		{
			latitude: 42.86081667,
			longitude: 31.248255,
		},
		{
			latitude: 42.860825,
			longitude: 31.24826333,
		},
		{
			latitude: 42.86083,
			longitude: 31.24826333,
		},
		{
			latitude: 42.86082667,
			longitude: 31.24827,
		},
		{
			latitude: 42.86085167,
			longitude: 31.24828167,
		},
		{
			latitude: 42.86082167,
			longitude: 31.248265,
		},
		{
			latitude: 42.86083,
			longitude: 31.24826667,
		},
		{
			latitude: 42.86082333,
			longitude: 31.248255,
		},
		{
			latitude: 42.86084,
			longitude: 31.24827,
		},
		{
			latitude: 42.86084,
			longitude: 31.24827,
		},
		{
			latitude: 42.86083167,
			longitude: 31.24826333,
		},
		{
			latitude: 42.86083,
			longitude: 31.248265,
		},
		{
			latitude: 42.86082667,
			longitude: 31.24826833,
		},
		{
			latitude: 42.86081667,
			longitude: 31.24826333,
		},
		{
			latitude: 42.86081833,
			longitude: 31.24826167,
		},
		{
			latitude: 42.86082667,
			longitude: 31.24826833,
		},
		{
			latitude: 42.860815,
			longitude: 31.24827333,
		},
		{
			latitude: 42.86083333,
			longitude: 31.24826833,
		},
		{
			latitude: 42.86083833,
			longitude: 31.24826833,
		},
		{
			latitude: 42.860835,
			longitude: 31.24827667,
		},
		{
			latitude: 42.86083333,
			longitude: 31.24826333,
		},
		{
			latitude: 42.86082667,
			longitude: 31.24826167,
		},
		{
			latitude: 42.86083167,
			longitude: 31.24826833,
		},
		{
			latitude: 42.86082333,
			longitude: 31.248265,
		},
		{
			latitude: 42.86081833,
			longitude: 31.24827667,
		},
		{
			latitude: 42.860825,
			longitude: 31.24826667,
		},
		{
			latitude: 42.86082333,
			longitude: 31.248265,
		},
		{
			latitude: 42.86082333,
			longitude: 31.24827167,
		},
		{
			latitude: 42.86083,
			longitude: 31.24826167,
		},
		{
			latitude: 42.86082833,
			longitude: 31.24827167,
		},
		{
			latitude: 42.860825,
			longitude: 31.24826667,
		},
		{
			latitude: 42.86082833,
			longitude: 31.248265,
		},
		{
			latitude: 42.86076,
			longitude: 31.24831333,
		},
		{
			latitude: 42.86053,
			longitude: 31.24859167,
		},
		{
			latitude: 42.86036333,
			longitude: 31.24879833,
		},
		{
			latitude: 42.85995333,
			longitude: 31.24926,
		},
		{
			latitude: 42.859795,
			longitude: 31.24943833,
		},
		{
			latitude: 42.85979,
			longitude: 31.24945,
		},
		{
			latitude: 42.85964,
			longitude: 31.24944,
		},
		{
			latitude: 42.85959667,
			longitude: 31.24945333,
		},
		{
			latitude: 42.8596,
			longitude: 31.24945167,
		},
		{
			latitude: 42.85959,
			longitude: 31.24945833,
		},
		{
			latitude: 42.85959,
			longitude: 31.24946167,
		},
		{
			latitude: 42.85961,
			longitude: 31.24944167,
		},
		{
			latitude: 42.85960833,
			longitude: 31.24944333,
		},
		{
			latitude: 42.85958167,
			longitude: 31.24945833,
		},
		{
			latitude: 42.85960833,
			longitude: 31.24944667,
		},
		{
			latitude: 42.859605,
			longitude: 31.24945333,
		},
		{
			latitude: 42.85960667,
			longitude: 31.24944667,
		},
		{
			latitude: 42.85961,
			longitude: 31.24944333,
		},
		{
			latitude: 42.8596,
			longitude: 31.24945667,
		},
		{
			latitude: 42.85974333,
			longitude: 31.249435,
		},
		{
			latitude: 42.85973667,
			longitude: 31.24944,
		},
		{
			latitude: 42.859725,
			longitude: 31.24944,
		},
		{
			latitude: 42.859725,
			longitude: 31.24944,
		},
		{
			latitude: 42.85972667,
			longitude: 31.24944,
		},
		{
			latitude: 42.85973,
			longitude: 31.24943667,
		},
		{
			latitude: 42.859735,
			longitude: 31.24944,
		},
		{
			latitude: 42.85972667,
			longitude: 31.249435,
		},
		{
			latitude: 42.85971833,
			longitude: 31.249435,
		},
		{
			latitude: 42.85971833,
			longitude: 31.24943667,
		},
		{
			latitude: 42.85973,
			longitude: 31.24944,
		},
		{
			latitude: 42.85972167,
			longitude: 31.249445,
		},
		{
			latitude: 42.859775,
			longitude: 31.24937167,
		},
		{
			latitude: 42.86021833,
			longitude: 31.24890333,
		},
		{
			latitude: 42.86064,
			longitude: 31.24841333,
		},
		{
			latitude: 42.86075667,
			longitude: 31.248255,
		},
		{
			latitude: 42.860765,
			longitude: 31.24825333,
		},
		{
			latitude: 42.86075333,
			longitude: 31.24825167,
		},
		{
			latitude: 42.86076333,
			longitude: 31.24827167,
		},
		{
			latitude: 42.86076667,
			longitude: 31.24825833,
		},
		{
			latitude: 42.86072833,
			longitude: 31.24826167,
		},
		{
			latitude: 42.86067,
			longitude: 31.248255,
		},
		{
			latitude: 42.86068167,
			longitude: 31.24826167,
		},
		{
			latitude: 42.8609,
			longitude: 31.24786,
		},
		{
			latitude: 42.86111333,
			longitude: 31.24741667,
		},
		{
			latitude: 42.86136167,
			longitude: 31.24698667,
		},
		{
			latitude: 42.86156833,
			longitude: 31.24653833,
		},
		{
			latitude: 42.861785,
			longitude: 31.24609,
		},
		{
			latitude: 42.86186,
			longitude: 31.24595333,
		},
		{
			latitude: 42.86191167,
			longitude: 31.24595,
		},
		{
			latitude: 42.86190667,
			longitude: 31.24594333,
		},
		{
			latitude: 42.86192667,
			longitude: 31.24595,
		},
		{
			latitude: 42.86190333,
			longitude: 31.24595167,
		},
		{
			latitude: 42.86190333,
			longitude: 31.24595167,
		},
		{
			latitude: 42.86192833,
			longitude: 31.245955,
		},
		{
			latitude: 42.86192,
			longitude: 31.245955,
		},
		{
			latitude: 42.861915,
			longitude: 31.24595833,
		},
		{
			latitude: 42.861915,
			longitude: 31.245945,
		},
		{
			latitude: 42.86190833,
			longitude: 31.24594667,
		},
		{
			latitude: 42.86191833,
			longitude: 31.24595333,
		},
		{
			latitude: 42.86190833,
			longitude: 31.24594667,
		},
		{
			latitude: 42.861915,
			longitude: 31.24595,
		},
		{
			latitude: 42.86191,
			longitude: 31.24595167,
		},
		{
			latitude: 42.86191833,
			longitude: 31.24594667,
		},
		{
			latitude: 42.86191,
			longitude: 31.24595167,
		},
		{
			latitude: 42.86191333,
			longitude: 31.24594833,
		},
		{
			latitude: 42.86190833,
			longitude: 31.24596333,
		},
		{
			latitude: 42.86189833,
			longitude: 31.245945,
		},
		{
			latitude: 42.86189833,
			longitude: 31.24595333,
		},
		{
			latitude: 42.86193,
			longitude: 31.24595667,
		},
		{
			latitude: 42.861885,
			longitude: 31.245955,
		},
		{
			latitude: 42.86188167,
			longitude: 31.24595833,
		},
		{
			latitude: 42.86193833,
			longitude: 31.24595167,
		},
		{
			latitude: 42.86191833,
			longitude: 31.24594833,
		},
		{
			latitude: 42.86191167,
			longitude: 31.24595,
		},
		{
			latitude: 42.86190333,
			longitude: 31.24593833,
		},
		{
			latitude: 42.861885,
			longitude: 31.245955,
		},
		{
			latitude: 42.86191833,
			longitude: 31.24595,
		},
		{
			latitude: 42.86191,
			longitude: 31.245945,
		},
		{
			latitude: 42.86189667,
			longitude: 31.245935,
		},
		{
			latitude: 42.86189333,
			longitude: 31.24595667,
		},
		{
			latitude: 42.86191333,
			longitude: 31.24595667,
		},
		{
			latitude: 42.86191,
			longitude: 31.24595333,
		},
		{
			latitude: 42.86191,
			longitude: 31.24594,
		},
		{
			latitude: 42.86188667,
			longitude: 31.24594667,
		},
		{
			latitude: 42.86194833,
			longitude: 31.24587667,
		},
		{
			latitude: 42.86209333,
			longitude: 31.24556833,
		},
		{
			latitude: 42.86213833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86215333,
			longitude: 31.24542833,
		},
		{
			latitude: 42.86216333,
			longitude: 31.24544167,
		},
		{
			latitude: 42.86226833,
			longitude: 31.24547833,
		},
		{
			latitude: 42.86226833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86229,
			longitude: 31.24536167,
		},
		{
			latitude: 42.86233,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86228833,
			longitude: 31.245365,
		},
		{
			latitude: 42.86230167,
			longitude: 31.24536167,
		},
		{
			latitude: 42.86228833,
			longitude: 31.24537333,
		},
		{
			latitude: 42.86229,
			longitude: 31.24536167,
		},
		{
			latitude: 42.862255,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86224833,
			longitude: 31.24534167,
		},
		{
			latitude: 42.86225,
			longitude: 31.24534667,
		},
		{
			latitude: 42.86222667,
			longitude: 31.24535,
		},
		{
			latitude: 42.86222333,
			longitude: 31.245365,
		},
		{
			latitude: 42.86223667,
			longitude: 31.24534333,
		},
		{
			latitude: 42.86224667,
			longitude: 31.245355,
		},
		{
			latitude: 42.86225333,
			longitude: 31.24534667,
		},
		{
			latitude: 42.86224,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86224,
			longitude: 31.24535,
		},
		{
			latitude: 42.86224333,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86224,
			longitude: 31.245355,
		},
		{
			latitude: 42.86225333,
			longitude: 31.24535,
		},
		{
			latitude: 42.86227667,
			longitude: 31.24536333,
		},
		{
			latitude: 42.86226333,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86225,
			longitude: 31.24536,
		},
		{
			latitude: 42.86225167,
			longitude: 31.24534167,
		},
		{
			latitude: 42.86224333,
			longitude: 31.245355,
		},
		{
			latitude: 42.86222167,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86224333,
			longitude: 31.24535667,
		},
		{
			latitude: 42.862235,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86223667,
			longitude: 31.24536167,
		},
		{
			latitude: 42.86224833,
			longitude: 31.24534667,
		},
		{
			latitude: 42.86224167,
			longitude: 31.24535,
		},
		{
			latitude: 42.86223333,
			longitude: 31.24534333,
		},
		{
			latitude: 42.86224333,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86225,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86223833,
			longitude: 31.24536,
		},
		{
			latitude: 42.86223833,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86221667,
			longitude: 31.245345,
		},
		{
			latitude: 42.862245,
			longitude: 31.24535333,
		},
		{
			latitude: 42.862255,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86226333,
			longitude: 31.24534667,
		},
		{
			latitude: 42.86222333,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86223667,
			longitude: 31.24535,
		},
		{
			latitude: 42.86226167,
			longitude: 31.24535667,
		},
		{
			latitude: 42.862235,
			longitude: 31.24534,
		},
		{
			latitude: 42.86223,
			longitude: 31.24535333,
		},
		{
			latitude: 42.862255,
			longitude: 31.24535833,
		},
		{
			latitude: 42.86224667,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86224667,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86223833,
			longitude: 31.24534667,
		},
		{
			latitude: 42.862245,
			longitude: 31.24535333,
		},
		{
			latitude: 42.862245,
			longitude: 31.24535,
		},
		{
			latitude: 42.86224167,
			longitude: 31.24535667,
		},
		{
			latitude: 42.862235,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86225833,
			longitude: 31.245355,
		},
		{
			latitude: 42.86224,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86224667,
			longitude: 31.245345,
		},
		{
			latitude: 42.862245,
			longitude: 31.24536,
		},
		{
			latitude: 42.86224667,
			longitude: 31.24536167,
		},
		{
			latitude: 42.862255,
			longitude: 31.24535833,
		},
		{
			latitude: 42.86224833,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86226167,
			longitude: 31.245365,
		},
		{
			latitude: 42.86227167,
			longitude: 31.24534833,
		},
		{
			latitude: 42.86223667,
			longitude: 31.24534167,
		},
		{
			latitude: 42.86225667,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86226167,
			longitude: 31.245375,
		},
		{
			latitude: 42.86225833,
			longitude: 31.245345,
		},
		{
			latitude: 42.86225333,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86227167,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86224667,
			longitude: 31.24535833,
		},
		{
			latitude: 42.86224333,
			longitude: 31.24535,
		},
		{
			latitude: 42.86224333,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86224333,
			longitude: 31.24535833,
		},
		{
			latitude: 42.862235,
			longitude: 31.24536333,
		},
		{
			latitude: 42.86224167,
			longitude: 31.24535,
		},
		{
			latitude: 42.862245,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86225,
			longitude: 31.245365,
		},
		{
			latitude: 42.86224333,
			longitude: 31.24536333,
		},
		{
			latitude: 42.86223667,
			longitude: 31.24535167,
		},
		{
			latitude: 42.862245,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86224833,
			longitude: 31.24536167,
		},
		{
			latitude: 42.86224333,
			longitude: 31.24535333,
		},
		{
			latitude: 42.862245,
			longitude: 31.245355,
		},
		{
			latitude: 42.86225167,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86224167,
			longitude: 31.24537,
		},
		{
			latitude: 42.86223833,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86223167,
			longitude: 31.24535667,
		},
		{
			latitude: 42.862235,
			longitude: 31.245355,
		},
		{
			latitude: 42.86224833,
			longitude: 31.245355,
		},
		{
			latitude: 42.862235,
			longitude: 31.24535167,
		},
		{
			latitude: 42.862245,
			longitude: 31.24536333,
		},
		{
			latitude: 42.862255,
			longitude: 31.24535833,
		},
		{
			latitude: 42.86225667,
			longitude: 31.24536167,
		},
		{
			latitude: 42.862235,
			longitude: 31.24535667,
		},
		{
			latitude: 42.862255,
			longitude: 31.24534667,
		},
		{
			latitude: 42.86223167,
			longitude: 31.24536833,
		},
		{
			latitude: 42.86224667,
			longitude: 31.24535,
		},
		{
			latitude: 42.86223333,
			longitude: 31.24535333,
		},
		{
			latitude: 42.862235,
			longitude: 31.24534667,
		},
		{
			latitude: 42.862235,
			longitude: 31.24535833,
		},
		{
			latitude: 42.86224833,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86224833,
			longitude: 31.24535667,
		},
		{
			latitude: 42.862265,
			longitude: 31.24535,
		},
		{
			latitude: 42.86226,
			longitude: 31.24535,
		},
		{
			latitude: 42.86226,
			longitude: 31.245355,
		},
		{
			latitude: 42.86225833,
			longitude: 31.24535833,
		},
		{
			latitude: 42.862255,
			longitude: 31.24535333,
		},
		{
			latitude: 42.862245,
			longitude: 31.245355,
		},
		{
			latitude: 42.86224833,
			longitude: 31.245355,
		},
		{
			latitude: 42.862245,
			longitude: 31.24535167,
		},
		{
			latitude: 42.86224667,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86225333,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86225167,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86224167,
			longitude: 31.24535833,
		},
		{
			latitude: 42.86225667,
			longitude: 31.245355,
		},
		{
			latitude: 42.86224667,
			longitude: 31.245355,
		},
		{
			latitude: 42.862245,
			longitude: 31.245355,
		},
		{
			latitude: 42.86224833,
			longitude: 31.245355,
		},
		{
			latitude: 42.86226833,
			longitude: 31.24536167,
		},
		{
			latitude: 42.86224667,
			longitude: 31.245355,
		},
		{
			latitude: 42.86225333,
			longitude: 31.245355,
		},
		{
			latitude: 42.86225167,
			longitude: 31.24536333,
		},
		{
			latitude: 42.86225167,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86224667,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86225,
			longitude: 31.24535167,
		},
		{
			latitude: 42.862255,
			longitude: 31.24536333,
		},
		{
			latitude: 42.86225667,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86225,
			longitude: 31.24535667,
		},
		{
			latitude: 42.862245,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86225167,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86225,
			longitude: 31.24535,
		},
		{
			latitude: 42.86224833,
			longitude: 31.24535667,
		},
		{
			latitude: 42.862255,
			longitude: 31.24536,
		},
		{
			latitude: 42.86225167,
			longitude: 31.24535,
		},
		{
			latitude: 42.86224833,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86224833,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86225667,
			longitude: 31.245355,
		},
		{
			latitude: 42.86225,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86226,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86225667,
			longitude: 31.24535333,
		},
		{
			latitude: 42.86225167,
			longitude: 31.24535667,
		},
		{
			latitude: 42.86201833,
			longitude: 31.24543333,
		},
		{
			latitude: 42.86188833,
			longitude: 31.24554833,
		},
		{
			latitude: 42.86189667,
			longitude: 31.24554333,
		},
		{
			latitude: 42.86189667,
			longitude: 31.245555,
		},
		{
			latitude: 42.8619,
			longitude: 31.24553833,
		},
		{
			latitude: 42.86190667,
			longitude: 31.24552667,
		},
		{
			latitude: 42.86189833,
			longitude: 31.24554167,
		},
		{
			latitude: 42.86190167,
			longitude: 31.24553333,
		},
		{
			latitude: 42.86188833,
			longitude: 31.24555333,
		},
		{
			latitude: 42.86189167,
			longitude: 31.24554833,
		},
		{
			latitude: 42.86189667,
			longitude: 31.245545,
		},
		{
			latitude: 42.861895,
			longitude: 31.24555,
		},
		{
			latitude: 42.86189333,
			longitude: 31.24554333,
		},
		{
			latitude: 42.861895,
			longitude: 31.24554,
		},
		{
			latitude: 42.861895,
			longitude: 31.245545,
		},
		{
			latitude: 42.86189833,
			longitude: 31.24554167,
		},
		{
			latitude: 42.86189,
			longitude: 31.24554667,
		},
		{
			latitude: 42.86189667,
			longitude: 31.24553667,
		},
		{
			latitude: 42.86189167,
			longitude: 31.24555667,
		},
		{
			latitude: 42.861895,
			longitude: 31.24555167,
		},
		{
			latitude: 42.86189667,
			longitude: 31.24554167,
		},
		{
			latitude: 42.861895,
			longitude: 31.24554833,
		},
		{
			latitude: 42.86190167,
			longitude: 31.24553667,
		},
		{
			latitude: 42.8619,
			longitude: 31.24553833,
		},
		{
			latitude: 42.861895,
			longitude: 31.245545,
		},
		{
			latitude: 42.86190167,
			longitude: 31.24553667,
		},
		{
			latitude: 42.86189167,
			longitude: 31.245545,
		},
		{
			latitude: 42.861905,
			longitude: 31.24553167,
		},
		{
			latitude: 42.86190333,
			longitude: 31.245535,
		},
		{
			latitude: 42.86188667,
			longitude: 31.24555167,
		},
		{
			latitude: 42.86190167,
			longitude: 31.24554667,
		},
		{
			latitude: 42.861895,
			longitude: 31.24554167,
		},
		{
			latitude: 42.861905,
			longitude: 31.24554,
		},
		{
			latitude: 42.86189333,
			longitude: 31.24555167,
		},
		{
			latitude: 42.86189833,
			longitude: 31.24554,
		},
		{
			latitude: 42.86189167,
			longitude: 31.245545,
		},
		{
			latitude: 42.861895,
			longitude: 31.24554333,
		},
		{
			latitude: 42.86189333,
			longitude: 31.245545,
		},
		{
			latitude: 42.86189667,
			longitude: 31.24554,
		},
		{
			latitude: 42.86189667,
			longitude: 31.24555,
		},
		{
			latitude: 42.861905,
			longitude: 31.24552333,
		},
		{
			latitude: 42.861895,
			longitude: 31.245545,
		},
		{
			latitude: 42.86189167,
			longitude: 31.245535,
		},
		{
			latitude: 42.86188167,
			longitude: 31.24555667,
		},
		{
			latitude: 42.86190333,
			longitude: 31.24553167,
		},
		{
			latitude: 42.86189333,
			longitude: 31.24555,
		},
		{
			latitude: 42.86190667,
			longitude: 31.24554333,
		},
		{
			latitude: 42.861895,
			longitude: 31.24554167,
		},
		{
			latitude: 42.86189333,
			longitude: 31.24555167,
		},
		{
			latitude: 42.86189333,
			longitude: 31.24554,
		},
		{
			latitude: 42.86190667,
			longitude: 31.24553833,
		},
		{
			latitude: 42.86189833,
			longitude: 31.24554333,
		},
		{
			latitude: 42.86190333,
			longitude: 31.24554,
		},
		{
			latitude: 42.86189333,
			longitude: 31.24554833,
		},
		{
			latitude: 42.86189833,
			longitude: 31.24553333,
		},
		{
			latitude: 42.86189667,
			longitude: 31.24556,
		},
		{
			latitude: 42.86189833,
			longitude: 31.245535,
		},
		{
			latitude: 42.86189667,
			longitude: 31.24553833,
		},
		{
			latitude: 42.86190167,
			longitude: 31.245545,
		},
		{
			latitude: 42.86190333,
			longitude: 31.24553333,
		},
		{
			latitude: 42.86189,
			longitude: 31.24553667,
		},
		{
			latitude: 42.86189667,
			longitude: 31.24554,
		},
		{
			latitude: 42.86190667,
			longitude: 31.24553667,
		},
		{
			latitude: 42.86189667,
			longitude: 31.24554,
		},
		{
			latitude: 42.86189333,
			longitude: 31.24553833,
		},
		{
			latitude: 42.86189833,
			longitude: 31.24554667,
		},
		{
			latitude: 42.86188833,
			longitude: 31.24554833,
		},
		{
			latitude: 42.86188667,
			longitude: 31.24555,
		},
		{
			latitude: 42.86189167,
			longitude: 31.24555,
		},
		{
			latitude: 42.86189,
			longitude: 31.24555,
		},
		{
			latitude: 42.86189,
			longitude: 31.24554833,
		},
		{
			latitude: 42.861895,
			longitude: 31.24554333,
		},
		{
			latitude: 42.86189333,
			longitude: 31.245555,
		},
		{
			latitude: 42.86189,
			longitude: 31.24554833,
		},
		{
			latitude: 42.8619,
			longitude: 31.24555333,
		},
		{
			latitude: 42.86189167,
			longitude: 31.24554833,
		},
		{
			latitude: 42.86190167,
			longitude: 31.24554,
		},
		{
			latitude: 42.86189833,
			longitude: 31.24554,
		},
		{
			latitude: 42.86189,
			longitude: 31.24555333,
		},
		{
			latitude: 42.86178833,
			longitude: 31.24574,
		},
		{
			latitude: 42.86177167,
			longitude: 31.24575333,
		},
		{
			latitude: 42.86177333,
			longitude: 31.245745,
		},
		{
			latitude: 42.86177333,
			longitude: 31.245765,
		},
		{
			latitude: 42.86178167,
			longitude: 31.24577167,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24575,
		},
		{
			latitude: 42.86178,
			longitude: 31.24574833,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24573167,
		},
		{
			latitude: 42.86178333,
			longitude: 31.24574833,
		},
		{
			latitude: 42.861785,
			longitude: 31.24571833,
		},
		{
			latitude: 42.86177167,
			longitude: 31.24575333,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24575167,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24573667,
		},
		{
			latitude: 42.86178,
			longitude: 31.245755,
		},
		{
			latitude: 42.86177,
			longitude: 31.245765,
		},
		{
			latitude: 42.86177833,
			longitude: 31.245745,
		},
		{
			latitude: 42.86178,
			longitude: 31.24573667,
		},
		{
			latitude: 42.86177167,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177333,
			longitude: 31.24575333,
		},
		{
			latitude: 42.86177167,
			longitude: 31.24575333,
		},
		{
			latitude: 42.86178,
			longitude: 31.24574167,
		},
		{
			latitude: 42.86177333,
			longitude: 31.24574167,
		},
		{
			latitude: 42.86177667,
			longitude: 31.245745,
		},
		{
			latitude: 42.86177333,
			longitude: 31.24576333,
		},
		{
			latitude: 42.86178,
			longitude: 31.24575667,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574667,
		},
		{
			latitude: 42.861775,
			longitude: 31.24576167,
		},
		{
			latitude: 42.86178167,
			longitude: 31.24573167,
		},
		{
			latitude: 42.86178167,
			longitude: 31.24573333,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24574,
		},
		{
			latitude: 42.86177333,
			longitude: 31.24575667,
		},
		{
			latitude: 42.86178,
			longitude: 31.24575667,
		},
		{
			latitude: 42.86178,
			longitude: 31.24574833,
		},
		{
			latitude: 42.861775,
			longitude: 31.245745,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24575333,
		},
		{
			latitude: 42.86177333,
			longitude: 31.24575167,
		},
		{
			latitude: 42.86177,
			longitude: 31.24576,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24575667,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86178,
			longitude: 31.24573833,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574667,
		},
		{
			latitude: 42.861775,
			longitude: 31.24575,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24575167,
		},
		{
			latitude: 42.86177333,
			longitude: 31.24575,
		},
		{
			latitude: 42.861775,
			longitude: 31.24575167,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24576,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574333,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177667,
			longitude: 31.245755,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574167,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574333,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177333,
			longitude: 31.24574833,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24575,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24575833,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86178167,
			longitude: 31.24575167,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24575667,
		},
		{
			latitude: 42.86177833,
			longitude: 31.245745,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24574167,
		},
		{
			latitude: 42.86178,
			longitude: 31.245755,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24573667,
		},
		{
			latitude: 42.86178,
			longitude: 31.24574833,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574167,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24573833,
		},
		{
			latitude: 42.86178,
			longitude: 31.24572833,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574667,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86178,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86178,
			longitude: 31.245755,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574333,
		},
		{
			latitude: 42.861775,
			longitude: 31.245755,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24575,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574833,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574,
		},
		{
			latitude: 42.86178,
			longitude: 31.24575,
		},
		{
			latitude: 42.86178333,
			longitude: 31.24575,
		},
		{
			latitude: 42.86177833,
			longitude: 31.245755,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177167,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177833,
			longitude: 31.245745,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574333,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24574833,
		},
		{
			latitude: 42.86178333,
			longitude: 31.24574333,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574167,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24574333,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24575167,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574167,
		},
		{
			latitude: 42.86177333,
			longitude: 31.24575,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24574667,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574333,
		},
		{
			latitude: 42.86177667,
			longitude: 31.245745,
		},
		{
			latitude: 42.861775,
			longitude: 31.245745,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24575,
		},
		{
			latitude: 42.861775,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24575333,
		},
		{
			latitude: 42.86177833,
			longitude: 31.24574667,
		},
		{
			latitude: 42.86177667,
			longitude: 31.24575333,
		},
		{
			latitude: 42.86177167,
			longitude: 31.24574833,
		},
		{
			latitude: 42.86177167,
			longitude: 31.24575167,
		},
		{
			latitude: 42.86169667,
			longitude: 31.24567,
		},
		{
			latitude: 42.86143667,
			longitude: 31.24542833,
		},
		{
			latitude: 42.86124167,
			longitude: 31.24523333,
		},
		{
			latitude: 42.861035,
			longitude: 31.24503667,
		},
		{
			latitude: 42.86080833,
			longitude: 31.24483,
		},
		{
			latitude: 42.86059,
			longitude: 31.244615,
		},
		{
			latitude: 42.86035333,
			longitude: 31.244395,
		},
		{
			latitude: 42.86015,
			longitude: 31.24419333,
		},
		{
			latitude: 42.85991,
			longitude: 31.24397167,
		},
		{
			latitude: 42.85970333,
			longitude: 31.24377667,
		},
		{
			latitude: 42.859485,
			longitude: 31.24357333,
		},
		{
			latitude: 42.85926667,
			longitude: 31.24336333,
		},
		{
			latitude: 42.859045,
			longitude: 31.24314167,
		},
		{
			latitude: 42.858995,
			longitude: 31.24310333,
		},
		{
			latitude: 42.85882833,
			longitude: 31.24293167,
		},
		{
			latitude: 42.85859667,
			longitude: 31.24272833,
		},
		{
			latitude: 42.85838,
			longitude: 31.24251333,
		},
		{
			latitude: 42.85815833,
			longitude: 31.24230333,
		},
		{
			latitude: 42.85794,
			longitude: 31.24209833,
		},
		{
			latitude: 42.85769833,
			longitude: 31.24187333,
		},
		{
			latitude: 42.85748,
			longitude: 31.24165167,
		},
		{
			latitude: 42.85734333,
			longitude: 31.241585,
		},
		{
			latitude: 42.85727667,
			longitude: 31.24194,
		},
		{
			latitude: 42.8572,
			longitude: 31.24230167,
		},
		{
			latitude: 42.85712833,
			longitude: 31.242655,
		},
		{
			latitude: 42.85707667,
			longitude: 31.24295667,
		},
		{
			latitude: 42.85729167,
			longitude: 31.24314667,
		},
		{
			latitude: 42.85762667,
			longitude: 31.24344667,
		},
		{
			latitude: 42.85785667,
			longitude: 31.243645,
		},
		{
			latitude: 42.85785833,
			longitude: 31.24364833,
		},
		{
			latitude: 42.857855,
			longitude: 31.24365,
		},
		{
			latitude: 42.857855,
			longitude: 31.24366333,
		},
		{
			latitude: 42.85785833,
			longitude: 31.24364333,
		},
		{
			latitude: 42.85786333,
			longitude: 31.24364833,
		},
		{
			latitude: 42.85786333,
			longitude: 31.24364167,
		},
		{
			latitude: 42.85785833,
			longitude: 31.24364667,
		},
		{
			latitude: 42.85786,
			longitude: 31.243645,
		},
		{
			latitude: 42.85773667,
			longitude: 31.24354,
		},
		{
			latitude: 42.85753167,
			longitude: 31.24338333,
		},
		{
			latitude: 42.85729667,
			longitude: 31.24320167,
		},
		{
			latitude: 42.857065,
			longitude: 31.24302167,
		},
		{
			latitude: 42.85682667,
			longitude: 31.24284333,
		},
		{
			latitude: 42.856595,
			longitude: 31.24265333,
		},
		{
			latitude: 42.85636333,
			longitude: 31.24247667,
		},
		{
			latitude: 42.85629833,
			longitude: 31.24242167,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242667,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242833,
		},
		{
			latitude: 42.8563,
			longitude: 31.24242167,
		},
		{
			latitude: 42.8563,
			longitude: 31.242415,
		},
		{
			latitude: 42.85630333,
			longitude: 31.24241833,
		},
		{
			latitude: 42.856305,
			longitude: 31.24243667,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242,
		},
		{
			latitude: 42.85629833,
			longitude: 31.24242,
		},
		{
			latitude: 42.85630333,
			longitude: 31.24242167,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242167,
		},
		{
			latitude: 42.8563,
			longitude: 31.24242667,
		},
		{
			latitude: 42.85629833,
			longitude: 31.24241833,
		},
		{
			latitude: 42.8563,
			longitude: 31.24242667,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242333,
		},
		{
			latitude: 42.85629833,
			longitude: 31.24242167,
		},
		{
			latitude: 42.85629667,
			longitude: 31.242425,
		},
		{
			latitude: 42.85629833,
			longitude: 31.242425,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24243167,
		},
		{
			latitude: 42.8563,
			longitude: 31.24241667,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24241333,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24241833,
		},
		{
			latitude: 42.85629833,
			longitude: 31.24242333,
		},
		{
			latitude: 42.8563,
			longitude: 31.242425,
		},
		{
			latitude: 42.8563,
			longitude: 31.24242667,
		},
		{
			latitude: 42.85629833,
			longitude: 31.24242167,
		},
		{
			latitude: 42.8563,
			longitude: 31.24242333,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242,
		},
		{
			latitude: 42.85630333,
			longitude: 31.242425,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242,
		},
		{
			latitude: 42.85629833,
			longitude: 31.24242167,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242333,
		},
		{
			latitude: 42.85630333,
			longitude: 31.24241833,
		},
		{
			latitude: 42.8563,
			longitude: 31.242425,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242333,
		},
		{
			latitude: 42.85630333,
			longitude: 31.24241667,
		},
		{
			latitude: 42.856305,
			longitude: 31.24241333,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24241667,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242333,
		},
		{
			latitude: 42.8563,
			longitude: 31.24242167,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242333,
		},
		{
			latitude: 42.85629667,
			longitude: 31.242425,
		},
		{
			latitude: 42.8563,
			longitude: 31.24241833,
		},
		{
			latitude: 42.8563,
			longitude: 31.242425,
		},
		{
			latitude: 42.8563,
			longitude: 31.24242167,
		},
		{
			latitude: 42.8563,
			longitude: 31.24242167,
		},
		{
			latitude: 42.85629667,
			longitude: 31.242425,
		},
		{
			latitude: 42.85629833,
			longitude: 31.24243,
		},
		{
			latitude: 42.85629833,
			longitude: 31.24242833,
		},
		{
			latitude: 42.8563,
			longitude: 31.242425,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24242333,
		},
		{
			latitude: 42.8563,
			longitude: 31.24242,
		},
		{
			latitude: 42.856305,
			longitude: 31.24241167,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24241667,
		},
		{
			latitude: 42.85630333,
			longitude: 31.24241333,
		},
		{
			latitude: 42.8563,
			longitude: 31.24243167,
		},
		{
			latitude: 42.85630333,
			longitude: 31.24241833,
		},
		{
			latitude: 42.85630667,
			longitude: 31.24240667,
		},
		{
			latitude: 42.856305,
			longitude: 31.24241333,
		},
		{
			latitude: 42.85623167,
			longitude: 31.24271333,
		},
		{
			latitude: 42.85623,
			longitude: 31.24279167,
		},
		{
			latitude: 42.85622833,
			longitude: 31.242805,
		},
		{
			latitude: 42.85623333,
			longitude: 31.242815,
		},
		{
			latitude: 42.856235,
			longitude: 31.24282833,
		},
		{
			latitude: 42.85623,
			longitude: 31.24282333,
		},
		{
			latitude: 42.85623333,
			longitude: 31.24281,
		},
		{
			latitude: 42.85623167,
			longitude: 31.2428,
		},
		{
			latitude: 42.85623167,
			longitude: 31.24280167,
		},
		{
			latitude: 42.85623167,
			longitude: 31.24280667,
		},
		{
			latitude: 42.85623167,
			longitude: 31.242805,
		},
		{
			latitude: 42.85623167,
			longitude: 31.24281,
		},
		{
			latitude: 42.85623167,
			longitude: 31.242805,
		},
		{
			latitude: 42.85624167,
			longitude: 31.242635,
		},
		{
			latitude: 42.85625833,
			longitude: 31.24254,
		},
		{
			latitude: 42.85626,
			longitude: 31.24254833,
		},
		{
			latitude: 42.85626167,
			longitude: 31.24254167,
		},
		{
			latitude: 42.85625833,
			longitude: 31.24255167,
		},
		{
			latitude: 42.85626,
			longitude: 31.24254667,
		},
		{
			latitude: 42.85625667,
			longitude: 31.24256,
		},
		{
			latitude: 42.85626,
			longitude: 31.24253833,
		},
		{
			latitude: 42.85630167,
			longitude: 31.24241333,
		},
		{
			latitude: 42.85629333,
			longitude: 31.24243167,
		},
		{
			latitude: 42.85629,
			longitude: 31.24243167,
		},
		{
			latitude: 42.85641667,
			longitude: 31.24223333,
		},
		{
			latitude: 42.85639667,
			longitude: 31.24225167,
		},
		{
			latitude: 42.856375,
			longitude: 31.24227833,
		},
		{
			latitude: 42.85639667,
			longitude: 31.24224667,
		},
		{
			latitude: 42.85638167,
			longitude: 31.24227167,
		},
		{
			latitude: 42.85638,
			longitude: 31.24227333,
		},
		{
			latitude: 42.856385,
			longitude: 31.24226833,
		},
		{
			latitude: 42.85637833,
			longitude: 31.24227,
		},
		{
			latitude: 42.85638,
			longitude: 31.24227333,
		},
		{
			latitude: 42.85629667,
			longitude: 31.24241167,
		},
		{
			latitude: 42.856335,
			longitude: 31.24232,
		},
		{
			latitude: 42.85633833,
			longitude: 31.24233,
		},
		{
			latitude: 42.856345,
			longitude: 31.24231833,
		},
		{
			latitude: 42.85634833,
			longitude: 31.24231,
		},
		{
			latitude: 42.85641667,
			longitude: 31.24221167,
		},
		{
			latitude: 42.85639167,
			longitude: 31.24227667,
		},
		{
			latitude: 42.85638667,
			longitude: 31.24227167,
		},
		{
			latitude: 42.85636667,
			longitude: 31.24226333,
		},
		{
			latitude: 42.85639,
			longitude: 31.24225667,
		},
		{
			latitude: 42.85640167,
			longitude: 31.24228833,
		},
		{
			latitude: 42.85637333,
			longitude: 31.24227,
		},
		{
			latitude: 42.85636833,
			longitude: 31.24226167,
		},
		{
			latitude: 42.85641,
			longitude: 31.242245,
		},
		{
			latitude: 42.85655667,
			longitude: 31.24212333,
		},
		{
			latitude: 42.85649667,
			longitude: 31.242125,
		},
		{
			latitude: 42.85649167,
			longitude: 31.24214333,
		},
		{
			latitude: 42.856495,
			longitude: 31.24214667,
		},
		{
			latitude: 42.85649667,
			longitude: 31.24215167,
		},
		{
			latitude: 42.85650833,
			longitude: 31.24213833,
		},
		{
			latitude: 42.85648667,
			longitude: 31.24213667,
		},
		{
			latitude: 42.856495,
			longitude: 31.24214833,
		},
		{
			latitude: 42.85649833,
			longitude: 31.242145,
		},
		{
			latitude: 42.85652667,
			longitude: 31.2421,
		},
		{
			latitude: 42.85653667,
			longitude: 31.24210667,
		},
		{
			latitude: 42.85654167,
			longitude: 31.24210167,
		},
		{
			latitude: 42.85650833,
			longitude: 31.24212,
		},
		{
			latitude: 42.85653,
			longitude: 31.242125,
		},
		{
			latitude: 42.85652167,
			longitude: 31.24211833,
		},
		{
			latitude: 42.85654667,
			longitude: 31.24212833,
		},
		{
			latitude: 42.85652667,
			longitude: 31.24212333,
		},
		{
			latitude: 42.85651333,
			longitude: 31.24212167,
		},
		{
			latitude: 42.85653333,
			longitude: 31.24212,
		},
		{
			latitude: 42.8565,
			longitude: 31.24214167,
		},
		{
			latitude: 42.85649333,
			longitude: 31.24214333,
		},
		{
			latitude: 42.856495,
			longitude: 31.242135,
		},
		{
			latitude: 42.85649667,
			longitude: 31.242145,
		},
		{
			latitude: 42.85648333,
			longitude: 31.24213833,
		},
		{
			latitude: 42.85649167,
			longitude: 31.24214,
		},
		{
			latitude: 42.85648833,
			longitude: 31.24213833,
		},
		{
			latitude: 42.85649167,
			longitude: 31.24213667,
		},
		{
			latitude: 42.856505,
			longitude: 31.242145,
		},
		{
			latitude: 42.85649833,
			longitude: 31.24215167,
		},
		{
			latitude: 42.85649167,
			longitude: 31.24213667,
		},
		{
			latitude: 42.85649833,
			longitude: 31.24214167,
		},
		{
			latitude: 42.856495,
			longitude: 31.242145,
		},
		{
			latitude: 42.856495,
			longitude: 31.24213667,
		},
		{
			latitude: 42.856505,
			longitude: 31.24214167,
		},
		{
			latitude: 42.85648833,
			longitude: 31.24214167,
		},
		{
			latitude: 42.85649167,
			longitude: 31.24214,
		},
		{
			latitude: 42.85649333,
			longitude: 31.24214667,
		},
		{
			latitude: 42.85652833,
			longitude: 31.242125,
		},
		{
			latitude: 42.85653167,
			longitude: 31.24211,
		},
		{
			latitude: 42.85653333,
			longitude: 31.24211833,
		},
		{
			latitude: 42.856535,
			longitude: 31.24211167,
		},
		{
			latitude: 42.85653167,
			longitude: 31.24211167,
		},
		{
			latitude: 42.85653667,
			longitude: 31.242105,
		},
		{
			latitude: 42.85654,
			longitude: 31.24210667,
		},
		{
			latitude: 42.85653,
			longitude: 31.24211333,
		},
		{
			latitude: 42.85653667,
			longitude: 31.24211,
		},
		{
			latitude: 42.856715,
			longitude: 31.24203,
		},
		{
			latitude: 42.85676,
			longitude: 31.24202167,
		},
		{
			latitude: 42.85676667,
			longitude: 31.24202667,
		},
		{
			latitude: 42.85676333,
			longitude: 31.24202667,
		},
		{
			latitude: 42.85675833,
			longitude: 31.24203167,
		},
		{
			latitude: 42.85676667,
			longitude: 31.24202667,
		},
		{
			latitude: 42.85678167,
			longitude: 31.24203333,
		},
		{
			latitude: 42.85677333,
			longitude: 31.24202667,
		},
		{
			latitude: 42.85676667,
			longitude: 31.242025,
		},
		{
			latitude: 42.85677167,
			longitude: 31.24203167,
		},
		{
			latitude: 42.85696833,
			longitude: 31.24207167,
		},
		{
			latitude: 42.85696167,
			longitude: 31.24207,
		},
		{
			latitude: 42.85698167,
			longitude: 31.24207333,
		},
		{
			latitude: 42.85696667,
			longitude: 31.24207667,
		},
		{
			latitude: 42.85696333,
			longitude: 31.24207833,
		},
		{
			latitude: 42.85698,
			longitude: 31.24207833,
		},
		{
			latitude: 42.85696167,
			longitude: 31.242065,
		},
		{
			latitude: 42.85697333,
			longitude: 31.24207833,
		},
		{
			latitude: 42.85695833,
			longitude: 31.242075,
		},
		{
			latitude: 42.856975,
			longitude: 31.242075,
		},
		{
			latitude: 42.856965,
			longitude: 31.24207333,
		},
		{
			latitude: 42.85696833,
			longitude: 31.24207,
		},
		{
			latitude: 42.856975,
			longitude: 31.242085,
		},
		{
			latitude: 42.85697167,
			longitude: 31.24207167,
		},
		{
			latitude: 42.85699167,
			longitude: 31.24208167,
		},
		{
			latitude: 42.85696333,
			longitude: 31.24207333,
		},
		{
			latitude: 42.85695833,
			longitude: 31.24207,
		},
		{
			latitude: 42.85697167,
			longitude: 31.24208333,
		},
		{
			latitude: 42.85697333,
			longitude: 31.24207667,
		},
		{
			latitude: 42.85697167,
			longitude: 31.24206833,
		},
		{
			latitude: 42.85710667,
			longitude: 31.24217333,
		},
		{
			latitude: 42.85724167,
			longitude: 31.24235333,
		},
		{
			latitude: 42.857265,
			longitude: 31.24241167,
		},
		{
			latitude: 42.857265,
			longitude: 31.24240333,
		},
		{
			latitude: 42.85726,
			longitude: 31.24239333,
		},
		{
			latitude: 42.85726667,
			longitude: 31.24239,
		},
		{
			latitude: 42.85725833,
			longitude: 31.24242,
		},
		{
			latitude: 42.85726333,
			longitude: 31.24241667,
		},
		{
			latitude: 42.85726,
			longitude: 31.242395,
		},
		{
			latitude: 42.85730667,
			longitude: 31.24252,
		},
		{
			latitude: 42.857335,
			longitude: 31.24278833,
		},
		{
			latitude: 42.857335,
			longitude: 31.24265,
		},
		{
			latitude: 42.85733,
			longitude: 31.242645,
		},
		{
			latitude: 42.85733333,
			longitude: 31.24262833,
		},
		{
			latitude: 42.857325,
			longitude: 31.242635,
		},
		{
			latitude: 42.85733833,
			longitude: 31.242625,
		},
		{
			latitude: 42.857315,
			longitude: 31.24265333,
		},
		{
			latitude: 42.85733667,
			longitude: 31.24263667,
		},
		{
			latitude: 42.85733333,
			longitude: 31.24263,
		},
		{
			latitude: 42.85732333,
			longitude: 31.24264167,
		},
		{
			latitude: 42.85732333,
			longitude: 31.24262333,
		},
		{
			latitude: 42.85732833,
			longitude: 31.242655,
		},
		{
			latitude: 42.85702,
			longitude: 31.24264,
		},
		{
			latitude: 42.85658167,
			longitude: 31.24266,
		},
		{
			latitude: 42.85619,
			longitude: 31.24263333,
		},
		{
			latitude: 42.85597667,
			longitude: 31.24263333,
		},
		{
			latitude: 42.855985,
			longitude: 31.24263833,
		},
		{
			latitude: 42.85597667,
			longitude: 31.24264667,
		},
		{
			latitude: 42.85598167,
			longitude: 31.24263,
		},
		{
			latitude: 42.855995,
			longitude: 31.24263,
		},
		{
			latitude: 42.85598333,
			longitude: 31.242635,
		},
		{
			latitude: 42.85597833,
			longitude: 31.24262667,
		},
		{
			latitude: 42.85597833,
			longitude: 31.242625,
		},
		{
			latitude: 42.85598167,
			longitude: 31.24263333,
		},
		{
			latitude: 42.85597833,
			longitude: 31.24263333,
		},
		{
			latitude: 42.855985,
			longitude: 31.24263333,
		},
		{
			latitude: 42.85598333,
			longitude: 31.24264667,
		},
		{
			latitude: 42.85596667,
			longitude: 31.24263667,
		},
		{
			latitude: 42.85598167,
			longitude: 31.242645,
		},
		{
			latitude: 42.85597,
			longitude: 31.242635,
		},
		{
			latitude: 42.85597167,
			longitude: 31.24263,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24267,
		},
		{
			latitude: 42.855995,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85599667,
			longitude: 31.24276167,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24277167,
		},
		{
			latitude: 42.855975,
			longitude: 31.24279167,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24278167,
		},
		{
			latitude: 42.85598,
			longitude: 31.24277333,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24276,
		},
		{
			latitude: 42.85598833,
			longitude: 31.242785,
		},
		{
			latitude: 42.85599833,
			longitude: 31.242785,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24276833,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24274667,
		},
		{
			latitude: 42.85599833,
			longitude: 31.24277333,
		},
		{
			latitude: 42.85599,
			longitude: 31.24274167,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24277,
		},
		{
			latitude: 42.85598333,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24277,
		},
		{
			latitude: 42.85600667,
			longitude: 31.24278,
		},
		{
			latitude: 42.85599833,
			longitude: 31.24274667,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24276833,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24278,
		},
		{
			latitude: 42.85599833,
			longitude: 31.24275167,
		},
		{
			latitude: 42.855985,
			longitude: 31.24279833,
		},
		{
			latitude: 42.85597333,
			longitude: 31.24276333,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24277833,
		},
		{
			latitude: 42.85598167,
			longitude: 31.24279,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24275667,
		},
		{
			latitude: 42.85597833,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85599,
			longitude: 31.242765,
		},
		{
			latitude: 42.85599667,
			longitude: 31.24277833,
		},
		{
			latitude: 42.85599,
			longitude: 31.242765,
		},
		{
			latitude: 42.85599667,
			longitude: 31.242765,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24277,
		},
		{
			latitude: 42.85599,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276167,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24278,
		},
		{
			latitude: 42.85597667,
			longitude: 31.242775,
		},
		{
			latitude: 42.85599667,
			longitude: 31.24277333,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24277167,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24277333,
		},
		{
			latitude: 42.85599,
			longitude: 31.24275833,
		},
		{
			latitude: 42.855985,
			longitude: 31.242775,
		},
		{
			latitude: 42.85599667,
			longitude: 31.242785,
		},
		{
			latitude: 42.85598333,
			longitude: 31.242765,
		},
		{
			latitude: 42.855985,
			longitude: 31.24273833,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24277833,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85599,
			longitude: 31.242745,
		},
		{
			latitude: 42.85599833,
			longitude: 31.242765,
		},
		{
			latitude: 42.85599,
			longitude: 31.24275833,
		},
		{
			latitude: 42.855985,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24278,
		},
		{
			latitude: 42.85599167,
			longitude: 31.242755,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85600167,
			longitude: 31.242775,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276333,
		},
		{
			latitude: 42.85597667,
			longitude: 31.24275833,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24279333,
		},
		{
			latitude: 42.85599333,
			longitude: 31.242765,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24278,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24276,
		},
		{
			latitude: 42.855985,
			longitude: 31.24273,
		},
		{
			latitude: 42.85599667,
			longitude: 31.24277167,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24278167,
		},
		{
			latitude: 42.85596333,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85600333,
			longitude: 31.24276667,
		},
		{
			latitude: 42.85600167,
			longitude: 31.24275333,
		},
		{
			latitude: 42.85598,
			longitude: 31.24275667,
		},
		{
			latitude: 42.85598,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276833,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24277333,
		},
		{
			latitude: 42.85599,
			longitude: 31.242755,
		},
		{
			latitude: 42.85598333,
			longitude: 31.24278333,
		},
		{
			latitude: 42.85598167,
			longitude: 31.24274333,
		},
		{
			latitude: 42.855975,
			longitude: 31.24277833,
		},
		{
			latitude: 42.85599833,
			longitude: 31.242765,
		},
		{
			latitude: 42.85598833,
			longitude: 31.242775,
		},
		{
			latitude: 42.85600333,
			longitude: 31.24278333,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24275833,
		},
		{
			latitude: 42.85599,
			longitude: 31.24277333,
		},
		{
			latitude: 42.855985,
			longitude: 31.24277,
		},
		{
			latitude: 42.85597667,
			longitude: 31.24274667,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24278,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24276833,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276667,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85599667,
			longitude: 31.242755,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24276833,
		},
		{
			latitude: 42.85599667,
			longitude: 31.24278,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24276167,
		},
		{
			latitude: 42.85597333,
			longitude: 31.24276667,
		},
		{
			latitude: 42.855995,
			longitude: 31.24278,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24276333,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24276333,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24277333,
		},
		{
			latitude: 42.85599667,
			longitude: 31.24275167,
		},
		{
			latitude: 42.85599,
			longitude: 31.24275667,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276333,
		},
		{
			latitude: 42.85597833,
			longitude: 31.24280333,
		},
		{
			latitude: 42.85599833,
			longitude: 31.24278,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24275333,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24279333,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24275167,
		},
		{
			latitude: 42.855985,
			longitude: 31.242785,
		},
		{
			latitude: 42.855995,
			longitude: 31.24277333,
		},
		{
			latitude: 42.85599,
			longitude: 31.242755,
		},
		{
			latitude: 42.85599,
			longitude: 31.24277,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24279667,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276,
		},
		{
			latitude: 42.85599333,
			longitude: 31.242775,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24277,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24273833,
		},
		{
			latitude: 42.85599,
			longitude: 31.24278333,
		},
		{
			latitude: 42.85599,
			longitude: 31.24278,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24275667,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24276667,
		},
		{
			latitude: 42.85599333,
			longitude: 31.242765,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24276167,
		},
		{
			latitude: 42.85599333,
			longitude: 31.242775,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24275667,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24276333,
		},
		{
			latitude: 42.855995,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24274667,
		},
		{
			latitude: 42.85598667,
			longitude: 31.242765,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24275333,
		},
		{
			latitude: 42.85598333,
			longitude: 31.24276167,
		},
		{
			latitude: 42.85598333,
			longitude: 31.24277167,
		},
		{
			latitude: 42.855985,
			longitude: 31.24277333,
		},
		{
			latitude: 42.85599667,
			longitude: 31.24278167,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24275333,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276333,
		},
		{
			latitude: 42.855985,
			longitude: 31.24276,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276667,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24276333,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276333,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24276667,
		},
		{
			latitude: 42.855985,
			longitude: 31.24277667,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24274833,
		},
		{
			latitude: 42.85597833,
			longitude: 31.242755,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276167,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24274833,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24276833,
		},
		{
			latitude: 42.85599333,
			longitude: 31.242765,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24275833,
		},
		{
			latitude: 42.855985,
			longitude: 31.24277,
		},
		{
			latitude: 42.85599,
			longitude: 31.24276,
		},
		{
			latitude: 42.85598833,
			longitude: 31.24277,
		},
		{
			latitude: 42.85599,
			longitude: 31.24278333,
		},
		{
			latitude: 42.855985,
			longitude: 31.24276167,
		},
		{
			latitude: 42.85599167,
			longitude: 31.24276833,
		},
		{
			latitude: 42.85598667,
			longitude: 31.24275167,
		},
		{
			latitude: 42.85599333,
			longitude: 31.24277,
		},
		{
			latitude: 42.85599,
			longitude: 31.24277167,
		},
		{
			latitude: 42.85603,
			longitude: 31.242855,
		},
		{
			latitude: 42.85617333,
			longitude: 31.24319667,
		},
		{
			latitude: 42.856305,
			longitude: 31.243505,
		},
		{
			latitude: 42.85643833,
			longitude: 31.24382833,
		},
		{
			latitude: 42.85658167,
			longitude: 31.24417,
		},
		{
			latitude: 42.85671833,
			longitude: 31.24449833,
		},
		{
			latitude: 42.85684833,
			longitude: 31.24478,
		},
		{
			latitude: 42.85697667,
			longitude: 31.24510667,
		},
		{
			latitude: 42.85711333,
			longitude: 31.24541667,
		},
		{
			latitude: 42.85725,
			longitude: 31.24574667,
		},
		{
			latitude: 42.857335,
			longitude: 31.24595833,
		},
		{
			latitude: 42.85733833,
			longitude: 31.245965,
		},
		{
			latitude: 42.85733833,
			longitude: 31.24595,
		},
		{
			latitude: 42.857345,
			longitude: 31.24596333,
		},
		{
			latitude: 42.85734167,
			longitude: 31.24594167,
		},
		{
			latitude: 42.85734167,
			longitude: 31.24595167,
		},
		{
			latitude: 42.85734,
			longitude: 31.24594,
		},
		{
			latitude: 42.85733833,
			longitude: 31.24593667,
		},
		{
			latitude: 42.85734167,
			longitude: 31.24595167,
		},
		{
			latitude: 42.85733667,
			longitude: 31.24594333,
		},
		{
			latitude: 42.85734167,
			longitude: 31.24594167,
		},
		{
			latitude: 42.85733833,
			longitude: 31.24595333,
		},
		{
			latitude: 42.85733833,
			longitude: 31.24595833,
		},
		{
			latitude: 42.85733667,
			longitude: 31.24594167,
		},
		{
			latitude: 42.85733333,
			longitude: 31.24594833,
		},
		{
			latitude: 42.85733833,
			longitude: 31.24595,
		},
		{
			latitude: 42.85734167,
			longitude: 31.24595,
		},
		{
			latitude: 42.85734333,
			longitude: 31.24594333,
		},
		{
			latitude: 42.85734,
			longitude: 31.24593667,
		},
		{
			latitude: 42.85734,
			longitude: 31.24594333,
		},
		{
			latitude: 42.85733667,
			longitude: 31.24594333,
		},
		{
			latitude: 42.85734,
			longitude: 31.24593833,
		},
		{
			latitude: 42.85733833,
			longitude: 31.24595667,
		},
		{
			latitude: 42.85733833,
			longitude: 31.24594,
		},
		{
			latitude: 42.85734167,
			longitude: 31.24595167,
		},
		{
			latitude: 42.85734,
			longitude: 31.24593667,
		},
		{
			latitude: 42.85734,
			longitude: 31.24594333,
		},
		{
			latitude: 42.85733833,
			longitude: 31.24595,
		},
		{
			latitude: 42.85733667,
			longitude: 31.24594333,
		},
		{
			latitude: 42.85734,
			longitude: 31.24595333,
		},
		{
			latitude: 42.85732833,
			longitude: 31.24595833,
		},
		{
			latitude: 42.85734,
			longitude: 31.245955,
		},
		{
			latitude: 42.85734,
			longitude: 31.24594333,
		},
		{
			latitude: 42.85733833,
			longitude: 31.24595667,
		},
		{
			latitude: 42.85733167,
			longitude: 31.24595667,
		},
		{
			latitude: 42.85734167,
			longitude: 31.24596,
		},
		{
			latitude: 42.85734167,
			longitude: 31.24594,
		},
		{
			latitude: 42.85733833,
			longitude: 31.245955,
		},
		{
			latitude: 42.85733667,
			longitude: 31.24595833,
		},
		{
			latitude: 42.85734167,
			longitude: 31.24596667,
		},
		{
			latitude: 42.85734667,
			longitude: 31.24595167,
		},
		{
			latitude: 42.85734,
			longitude: 31.24595,
		},
		{
			latitude: 42.857355,
			longitude: 31.24596333,
		},
		{
			latitude: 42.857625,
			longitude: 31.24605,
		},
		{
			latitude: 42.85787667,
			longitude: 31.246165,
		},
		{
			latitude: 42.85813,
			longitude: 31.24623,
		},
		{
			latitude: 42.858395,
			longitude: 31.24633833,
		},
		{
			latitude: 42.85866333,
			longitude: 31.24644667,
		},
		{
			latitude: 42.85892,
			longitude: 31.24653667,
		},
		{
			latitude: 42.85918667,
			longitude: 31.24663,
		},
		{
			latitude: 42.85944333,
			longitude: 31.24670667,
		},
		{
			latitude: 42.85971667,
			longitude: 31.246825,
		},
		{
			latitude: 42.859945,
			longitude: 31.246895,
		},
		{
			latitude: 42.860035,
			longitude: 31.24688333,
		},
		{
			latitude: 42.86028333,
			longitude: 31.24679667,
		},
		{
			latitude: 42.860555,
			longitude: 31.246745,
		},
		{
			latitude: 42.860665,
			longitude: 31.24669333,
		},
		{
			latitude: 42.86066167,
			longitude: 31.24689667,
		},
		{
			latitude: 42.86066,
			longitude: 31.24726333,
		},
		{
			latitude: 42.860665,
			longitude: 31.24764833,
		},
		{
			latitude: 42.86066167,
			longitude: 31.24799,
		},
		{
			latitude: 42.86066167,
			longitude: 31.24830333,
		},
		{
			latitude: 42.860665,
			longitude: 31.24833833,
		},
		{
			latitude: 42.86075167,
			longitude: 31.24824667,
		},
		{
			latitude: 42.86098167,
			longitude: 31.24802333,
		},
		{
			latitude: 42.86120667,
			longitude: 31.24783167,
		},
		{
			latitude: 42.86143,
			longitude: 31.24761167,
		},
		{
			latitude: 42.861655,
			longitude: 31.24743167,
		},
		{
			latitude: 42.86187667,
			longitude: 31.24722167,
		},
		{
			latitude: 42.862105,
			longitude: 31.24700833,
		},
		{
			latitude: 42.86233333,
			longitude: 31.24679333,
		},
		{
			latitude: 42.86252667,
			longitude: 31.24661833,
		},
		{
			latitude: 42.86262833,
			longitude: 31.24632333,
		},
		{
			latitude: 42.86263333,
			longitude: 31.246315,
		},
		{
			latitude: 42.862635,
			longitude: 31.24630667,
		},
		{
			latitude: 42.86263167,
			longitude: 31.24631167,
		},
		{
			latitude: 42.862765,
			longitude: 31.24611333,
		},
		{
			latitude: 42.86279833,
			longitude: 31.24606667,
		},
		{
			latitude: 42.8628,
			longitude: 31.246075,
		},
		{
			latitude: 42.86279667,
			longitude: 31.24606167,
		},
		{
			latitude: 42.862865,
			longitude: 31.24608667,
		},
		{
			latitude: 42.86286667,
			longitude: 31.24609833,
		},
		{
			latitude: 42.86286667,
			longitude: 31.24609167,
		},
		{
			latitude: 42.86286833,
			longitude: 31.24610667,
		},
		{
			latitude: 42.862865,
			longitude: 31.24610833,
		},
		{
			latitude: 42.86286667,
			longitude: 31.24609667,
		},
		{
			latitude: 42.86286333,
			longitude: 31.24609167,
		},
		{
			latitude: 42.862865,
			longitude: 31.246095,
		},
		{
			latitude: 42.86286833,
			longitude: 31.24610667,
		},
		{
			latitude: 42.86286667,
			longitude: 31.24609333,
		},
		{
			latitude: 42.862865,
			longitude: 31.24610167,
		},
		{
			latitude: 42.86286667,
			longitude: 31.246105,
		},
		{
			latitude: 42.86286167,
			longitude: 31.2461,
		},
		{
			latitude: 42.86282333,
			longitude: 31.246075,
		},
		{
			latitude: 42.86279667,
			longitude: 31.24608667,
		},
		{
			latitude: 42.86279833,
			longitude: 31.24607167,
		},
		{
			latitude: 42.86279667,
			longitude: 31.24606333,
		},
		{
			latitude: 42.86279333,
			longitude: 31.24607,
		},
		{
			latitude: 42.86279833,
			longitude: 31.246075,
		},
		{
			latitude: 42.86279667,
			longitude: 31.24607333,
		},
		{
			latitude: 42.86280167,
			longitude: 31.24608167,
		},
		{
			latitude: 42.86279833,
			longitude: 31.24607667,
		},
		{
			latitude: 42.86279667,
			longitude: 31.246075,
		},
		{
			latitude: 42.86279833,
			longitude: 31.24607833,
		},
		{
			latitude: 42.86253667,
			longitude: 31.24643333,
		},
		{
			latitude: 42.86227,
			longitude: 31.24678333,
		},
		{
			latitude: 42.86198167,
			longitude: 31.247185,
		},
		{
			latitude: 42.86184,
			longitude: 31.24737667,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24739,
		},
		{
			latitude: 42.86184,
			longitude: 31.247375,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737667,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737833,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86184,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737833,
		},
		{
			latitude: 42.86184,
			longitude: 31.24736667,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24738167,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737,
		},
		{
			latitude: 42.86184167,
			longitude: 31.247375,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737,
		},
		{
			latitude: 42.86184333,
			longitude: 31.247375,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24738,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184,
			longitude: 31.24736667,
		},
		{
			latitude: 42.86183833,
			longitude: 31.24736667,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24738,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737833,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184,
			longitude: 31.24738,
		},
		{
			latitude: 42.86184167,
			longitude: 31.247375,
		},
		{
			latitude: 42.86183833,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24738167,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737,
		},
		{
			latitude: 42.86184167,
			longitude: 31.247365,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184,
			longitude: 31.24737,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24738333,
		},
		{
			latitude: 42.86183833,
			longitude: 31.247375,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184,
			longitude: 31.24738333,
		},
		{
			latitude: 42.86184,
			longitude: 31.24735,
		},
		{
			latitude: 42.86184,
			longitude: 31.24736,
		},
		{
			latitude: 42.86184,
			longitude: 31.24737667,
		},
		{
			latitude: 42.86184,
			longitude: 31.247375,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86183833,
			longitude: 31.247365,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24738167,
		},
		{
			latitude: 42.86183833,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184,
			longitude: 31.24738,
		},
		{
			latitude: 42.86184667,
			longitude: 31.24738167,
		},
		{
			latitude: 42.86184,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184,
			longitude: 31.24738333,
		},
		{
			latitude: 42.86184,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737,
		},
		{
			latitude: 42.86184167,
			longitude: 31.247365,
		},
		{
			latitude: 42.86183833,
			longitude: 31.24739167,
		},
		{
			latitude: 42.86184333,
			longitude: 31.247375,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737833,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184,
			longitude: 31.24738,
		},
		{
			latitude: 42.86183833,
			longitude: 31.24737,
		},
		{
			latitude: 42.86183833,
			longitude: 31.24737833,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737667,
		},
		{
			latitude: 42.86183667,
			longitude: 31.24736333,
		},
		{
			latitude: 42.86184,
			longitude: 31.24738333,
		},
		{
			latitude: 42.86184,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184,
			longitude: 31.24736667,
		},
		{
			latitude: 42.86184667,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86183667,
			longitude: 31.24738,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737833,
		},
		{
			latitude: 42.86184,
			longitude: 31.247365,
		},
		{
			latitude: 42.86184,
			longitude: 31.247385,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737667,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737667,
		},
		{
			latitude: 42.86183667,
			longitude: 31.24739167,
		},
		{
			latitude: 42.86183833,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86183667,
			longitude: 31.24738167,
		},
		{
			latitude: 42.86183667,
			longitude: 31.24735833,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24736667,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737667,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86184,
			longitude: 31.24735667,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184,
			longitude: 31.247375,
		},
		{
			latitude: 42.861845,
			longitude: 31.24737333,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24736667,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24736,
		},
		{
			latitude: 42.86183833,
			longitude: 31.24738333,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24736167,
		},
		{
			latitude: 42.86184,
			longitude: 31.24736667,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24736167,
		},
		{
			latitude: 42.86184,
			longitude: 31.247365,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24736,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24735667,
		},
		{
			latitude: 42.86183833,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737,
		},
		{
			latitude: 42.86184,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24736667,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24736667,
		},
		{
			latitude: 42.86184667,
			longitude: 31.247355,
		},
		{
			latitude: 42.86184,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184167,
			longitude: 31.247365,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737667,
		},
		{
			latitude: 42.86184167,
			longitude: 31.247375,
		},
		{
			latitude: 42.86184167,
			longitude: 31.247355,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24736667,
		},
		{
			latitude: 42.861845,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86184,
			longitude: 31.24736,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24738167,
		},
		{
			latitude: 42.861845,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86184167,
			longitude: 31.247365,
		},
		{
			latitude: 42.86184,
			longitude: 31.24736667,
		},
		{
			latitude: 42.86184333,
			longitude: 31.247365,
		},
		{
			latitude: 42.86184167,
			longitude: 31.247375,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24736167,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24735833,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184667,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184167,
			longitude: 31.247365,
		},
		{
			latitude: 42.86184167,
			longitude: 31.24736333,
		},
		{
			latitude: 42.86184333,
			longitude: 31.24737167,
		},
		{
			latitude: 42.86184,
			longitude: 31.24736333,
		},
		{
			latitude: 42.86180167,
			longitude: 31.24709667,
		},
		{
			latitude: 42.86176333,
			longitude: 31.247005,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86175833,
			longitude: 31.24699,
		},
		{
			latitude: 42.861765,
			longitude: 31.247,
		},
		{
			latitude: 42.86175833,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86176,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86176333,
			longitude: 31.247,
		},
		{
			latitude: 42.86176,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86175833,
			longitude: 31.247,
		},
		{
			latitude: 42.86175833,
			longitude: 31.246995,
		},
		{
			latitude: 42.86175833,
			longitude: 31.24699667,
		},
		{
			latitude: 42.861765,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86176333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86176,
			longitude: 31.247,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86175667,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86176333,
			longitude: 31.24700833,
		},
		{
			latitude: 42.86175833,
			longitude: 31.246995,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86175833,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86176333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86176333,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86176333,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86176333,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86175833,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86175667,
			longitude: 31.246995,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247005,
		},
		{
			latitude: 42.86176333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86175833,
			longitude: 31.246995,
		},
		{
			latitude: 42.86175667,
			longitude: 31.246995,
		},
		{
			latitude: 42.86176333,
			longitude: 31.247,
		},
		{
			latitude: 42.86175833,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86176667,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86175333,
			longitude: 31.24698833,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86176,
			longitude: 31.247,
		},
		{
			latitude: 42.86176,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247,
		},
		{
			latitude: 42.86175667,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86176,
			longitude: 31.247,
		},
		{
			latitude: 42.861765,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247,
		},
		{
			latitude: 42.86176,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86176,
			longitude: 31.247,
		},
		{
			latitude: 42.86175667,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86176667,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86175667,
			longitude: 31.246995,
		},
		{
			latitude: 42.86176,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86176,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86175833,
			longitude: 31.246995,
		},
		{
			latitude: 42.86176,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86176333,
			longitude: 31.247005,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247,
		},
		{
			latitude: 42.86176,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86176,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247,
		},
		{
			latitude: 42.86176333,
			longitude: 31.24700667,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24700667,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247005,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247,
		},
		{
			latitude: 42.86175667,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86176,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86175833,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86176,
			longitude: 31.246995,
		},
		{
			latitude: 42.86176333,
			longitude: 31.24700833,
		},
		{
			latitude: 42.86175667,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24701,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247005,
		},
		{
			latitude: 42.86175833,
			longitude: 31.247,
		},
		{
			latitude: 42.86176167,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86175667,
			longitude: 31.246995,
		},
		{
			latitude: 42.86176167,
			longitude: 31.247,
		},
		{
			latitude: 42.86175833,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86176,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86175833,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86176,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86183333,
			longitude: 31.2469,
		},
		{
			latitude: 42.862025,
			longitude: 31.24664,
		},
		{
			latitude: 42.862245,
			longitude: 31.24635333,
		},
		{
			latitude: 42.86240333,
			longitude: 31.24611833,
		},
		{
			latitude: 42.8626,
			longitude: 31.245875,
		},
		{
			latitude: 42.862695,
			longitude: 31.24572333,
		},
		{
			latitude: 42.862695,
			longitude: 31.24572667,
		},
		{
			latitude: 42.86271,
			longitude: 31.245735,
		},
		{
			latitude: 42.86280833,
			longitude: 31.24572,
		},
		{
			latitude: 42.862685,
			longitude: 31.24553667,
		},
		{
			latitude: 42.86247833,
			longitude: 31.245405,
		},
		{
			latitude: 42.86234,
			longitude: 31.245385,
		},
		{
			latitude: 42.86234,
			longitude: 31.245385,
		},
		{
			latitude: 42.86233833,
			longitude: 31.245385,
		},
		{
			latitude: 42.86234167,
			longitude: 31.245385,
		},
		{
			latitude: 42.86234,
			longitude: 31.24538667,
		},
		{
			latitude: 42.86233667,
			longitude: 31.245385,
		},
		{
			latitude: 42.86234,
			longitude: 31.245385,
		},
		{
			latitude: 42.862335,
			longitude: 31.245385,
		},
		{
			latitude: 42.86233833,
			longitude: 31.24538667,
		},
		{
			latitude: 42.862345,
			longitude: 31.245365,
		},
		{
			latitude: 42.86235333,
			longitude: 31.245365,
		},
		{
			latitude: 42.86236167,
			longitude: 31.24537167,
		},
		{
			latitude: 42.86236167,
			longitude: 31.24536833,
		},
		{
			latitude: 42.86232,
			longitude: 31.24535167,
		},
		{
			latitude: 42.862235,
			longitude: 31.24532667,
		},
		{
			latitude: 42.86222833,
			longitude: 31.24533167,
		},
		{
			latitude: 42.8624,
			longitude: 31.24535833,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542833,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86250833,
			longitude: 31.245425,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250833,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542333,
		},
		{
			latitude: 42.862515,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251333,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.862515,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251333,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251333,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542833,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86251333,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542167,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251333,
			longitude: 31.245425,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542833,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542833,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542833,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542833,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251667,
			longitude: 31.24542833,
		},
		{
			latitude: 42.86251333,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250333,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250333,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541833,
		},
		{
			latitude: 42.862505,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250333,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250333,
			longitude: 31.24542,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541833,
		},
		{
			latitude: 42.8625,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541667,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250167,
			longitude: 31.245415,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541667,
		},
		{
			latitude: 42.862505,
			longitude: 31.24541667,
		},
		{
			latitude: 42.862505,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.8625,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250167,
			longitude: 31.245415,
		},
		{
			latitude: 42.862505,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250333,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250167,
			longitude: 31.245415,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250333,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250333,
			longitude: 31.24541667,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250333,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.862505,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250333,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.8625,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541833,
		},
		{
			latitude: 42.862505,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.862505,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.862505,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250167,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250333,
			longitude: 31.24541667,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.862515,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251333,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251333,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251667,
			longitude: 31.24542833,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541833,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24541667,
		},
		{
			latitude: 42.862505,
			longitude: 31.24542,
		},
		{
			latitude: 42.862505,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542167,
		},
		{
			latitude: 42.862505,
			longitude: 31.24541833,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542833,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250667,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86251333,
			longitude: 31.245425,
		},
		{
			latitude: 42.862515,
			longitude: 31.24542833,
		},
		{
			latitude: 42.86251,
			longitude: 31.245425,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24541833,
		},
		{
			latitude: 42.86251333,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86250833,
			longitude: 31.24542,
		},
		{
			latitude: 42.86251167,
			longitude: 31.245425,
		},
		{
			latitude: 42.86251333,
			longitude: 31.24542667,
		},
		{
			latitude: 42.86251167,
			longitude: 31.24542333,
		},
		{
			latitude: 42.86253,
			longitude: 31.24542667,
		},
		{
			latitude: 42.862615,
			longitude: 31.245455,
		},
		{
			latitude: 42.86264167,
			longitude: 31.245465,
		},
		{
			latitude: 42.86263833,
			longitude: 31.24547667,
		},
		{
			latitude: 42.86263833,
			longitude: 31.24547333,
		},
		{
			latitude: 42.86259333,
			longitude: 31.245475,
		},
		{
			latitude: 42.862595,
			longitude: 31.24547667,
		},
		{
			latitude: 42.862595,
			longitude: 31.24547667,
		},
		{
			latitude: 42.86259333,
			longitude: 31.24547667,
		},
		{
			latitude: 42.862515,
			longitude: 31.24545,
		},
		{
			latitude: 42.86243333,
			longitude: 31.245425,
		},
		{
			latitude: 42.86243,
			longitude: 31.24542167,
		},
		{
			latitude: 42.86243,
			longitude: 31.24542,
		},
		{
			latitude: 42.86228667,
			longitude: 31.24558333,
		},
		{
			latitude: 42.86208167,
			longitude: 31.24581833,
		},
		{
			latitude: 42.86186667,
			longitude: 31.24606333,
		},
		{
			latitude: 42.861665,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86161,
			longitude: 31.24635333,
		},
		{
			latitude: 42.86145833,
			longitude: 31.24652667,
		},
		{
			latitude: 42.86125333,
			longitude: 31.246765,
		},
		{
			latitude: 42.861045,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86083833,
			longitude: 31.247235,
		},
		{
			latitude: 42.86064,
			longitude: 31.24746667,
		},
		{
			latitude: 42.86063333,
			longitude: 31.24746333,
		},
		{
			latitude: 42.86063333,
			longitude: 31.24746333,
		},
		{
			latitude: 42.86063,
			longitude: 31.247465,
		},
		{
			latitude: 42.86063667,
			longitude: 31.24746333,
		},
		{
			latitude: 42.86063167,
			longitude: 31.247465,
		},
		{
			latitude: 42.86062667,
			longitude: 31.24746,
		},
		{
			latitude: 42.86063333,
			longitude: 31.247465,
		},
		{
			latitude: 42.86063833,
			longitude: 31.24746833,
		},
		{
			latitude: 42.86063167,
			longitude: 31.24746333,
		},
		{
			latitude: 42.86043833,
			longitude: 31.24737833,
		},
		{
			latitude: 42.86019667,
			longitude: 31.24740833,
		},
		{
			latitude: 42.86000167,
			longitude: 31.24756167,
		},
		{
			latitude: 42.860005,
			longitude: 31.24755833,
		},
		{
			latitude: 42.860005,
			longitude: 31.24755667,
		},
		{
			latitude: 42.86000667,
			longitude: 31.247555,
		},
		{
			latitude: 42.86000333,
			longitude: 31.24756,
		},
		{
			latitude: 42.86000667,
			longitude: 31.247555,
		},
		{
			latitude: 42.860005,
			longitude: 31.24755667,
		},
		{
			latitude: 42.860005,
			longitude: 31.24755833,
		},
		{
			latitude: 42.86000167,
			longitude: 31.24756167,
		},
		{
			latitude: 42.86000333,
			longitude: 31.24756,
		},
		{
			latitude: 42.860005,
			longitude: 31.24755667,
		},
		{
			latitude: 42.86000333,
			longitude: 31.24756,
		},
		{
			latitude: 42.86007667,
			longitude: 31.247485,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749167,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24749,
		},
		{
			latitude: 42.860075,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749167,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007667,
			longitude: 31.247485,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007667,
			longitude: 31.24748833,
		},
		{
			latitude: 42.860075,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749167,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24749167,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749167,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.860075,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749167,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749167,
		},
		{
			latitude: 42.860075,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.860075,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749167,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749167,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86008167,
			longitude: 31.24748333,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749167,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.860075,
			longitude: 31.247485,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749,
		},
		{
			latitude: 42.860075,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007833,
			longitude: 31.247485,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.860075,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749167,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86006833,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24749,
		},
		{
			latitude: 42.86006667,
			longitude: 31.24749333,
		},
		{
			latitude: 42.86007167,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007333,
			longitude: 31.24749,
		},
		{
			latitude: 42.86006667,
			longitude: 31.24749333,
		},
		{
			latitude: 42.86007667,
			longitude: 31.247485,
		},
		{
			latitude: 42.860075,
			longitude: 31.24748667,
		},
		{
			latitude: 42.86007667,
			longitude: 31.24748833,
		},
		{
			latitude: 42.86007667,
			longitude: 31.24748667,
		},
		{
			latitude: 42.86002333,
			longitude: 31.24749167,
		},
		{
			latitude: 42.85948,
			longitude: 31.24748833,
		},
		{
			latitude: 42.85892167,
			longitude: 31.24749167,
		},
		{
			latitude: 42.85837667,
			longitude: 31.24749,
		},
		{
			latitude: 42.85787333,
			longitude: 31.24749,
		},
		{
			latitude: 42.85733833,
			longitude: 31.24748833,
		},
		{
			latitude: 42.85678,
			longitude: 31.2475,
		},
		{
			latitude: 42.85646,
			longitude: 31.24749167,
		},
		{
			latitude: 42.85230167,
			longitude: 31.250815,
		},
		{
			latitude: 42.84599833,
			longitude: 31.25944667,
		},
		{
			latitude: 42.83983667,
			longitude: 31.26823333,
		},
		{
			latitude: 42.83366667,
			longitude: 31.27706,
		},
		{
			latitude: 42.82723,
			longitude: 31.28635333,
		},
		{
			latitude: 42.82094333,
			longitude: 31.29483,
		},
		{
			latitude: 42.81465,
			longitude: 31.30327667,
		},
		{
			latitude: 42.80986167,
			longitude: 31.31017833,
		},
		{
			latitude: 42.80954167,
			longitude: 31.31098833,
		},
		{
			latitude: 42.80958333,
			longitude: 31.31126833,
		},
		{
			latitude: 42.80987667,
			longitude: 31.31120333,
		},
		{
			latitude: 42.81038667,
			longitude: 31.3108,
		},
		{
			latitude: 42.81038667,
			longitude: 31.31080167,
		},
		{
			latitude: 42.81039,
			longitude: 31.31080167,
		},
		{
			latitude: 42.81038667,
			longitude: 31.31080167,
		},
		{
			latitude: 42.81015333,
			longitude: 31.31114167,
		},
		{
			latitude: 42.80986667,
			longitude: 31.31156167,
		},
		{
			latitude: 42.80958667,
			longitude: 31.31196667,
		},
		{
			latitude: 42.80931167,
			longitude: 31.31236833,
		},
		{
			latitude: 42.80921833,
			longitude: 31.31250167,
		},
		{
			latitude: 42.80921667,
			longitude: 31.312505,
		},
		{
			latitude: 42.80921667,
			longitude: 31.31250333,
		},
		{
			latitude: 42.80921833,
			longitude: 31.31250333,
		},
		{
			latitude: 42.80922,
			longitude: 31.31250333,
		},
		{
			latitude: 42.80921833,
			longitude: 31.312505,
		},
		{
			latitude: 42.80922,
			longitude: 31.3125,
		},
		{
			latitude: 42.80921833,
			longitude: 31.31250167,
		},
		{
			latitude: 42.80922,
			longitude: 31.3125,
		},
		{
			latitude: 42.80921833,
			longitude: 31.31250167,
		},
		{
			latitude: 42.80921833,
			longitude: 31.31250167,
		},
		{
			latitude: 42.80922,
			longitude: 31.31250167,
		},
		{
			latitude: 42.80921833,
			longitude: 31.31250333,
		},
		{
			latitude: 42.80921333,
			longitude: 31.312515,
		},
		{
			latitude: 42.809215,
			longitude: 31.312505,
		},
		{
			latitude: 42.80921,
			longitude: 31.31250833,
		},
		{
			latitude: 42.80921167,
			longitude: 31.31250833,
		},
		{
			latitude: 42.80933333,
			longitude: 31.31244833,
		},
		{
			latitude: 42.80999333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024167,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024167,
			longitude: 31.31244,
		},
		{
			latitude: 42.81024167,
			longitude: 31.31244,
		},
		{
			latitude: 42.810235,
			longitude: 31.31244,
		},
		{
			latitude: 42.810245,
			longitude: 31.312445,
		},
		{
			latitude: 42.81023667,
			longitude: 31.31243833,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024833,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024667,
			longitude: 31.312445,
		},
		{
			latitude: 42.810245,
			longitude: 31.312445,
		},
		{
			latitude: 42.81024833,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024333,
			longitude: 31.312445,
		},
		{
			latitude: 42.81024,
			longitude: 31.31244,
		},
		{
			latitude: 42.81024667,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024167,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024667,
			longitude: 31.31244,
		},
		{
			latitude: 42.81024833,
			longitude: 31.312445,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244333,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244333,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81025,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024667,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024667,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024667,
			longitude: 31.312445,
		},
		{
			latitude: 42.81024,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81025,
			longitude: 31.31244333,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024667,
			longitude: 31.312445,
		},
		{
			latitude: 42.81024167,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024667,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024667,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244167,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244167,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024167,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024833,
			longitude: 31.31244167,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024333,
			longitude: 31.312445,
		},
		{
			latitude: 42.81024167,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81022667,
			longitude: 31.312435,
		},
		{
			latitude: 42.81023833,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81023667,
			longitude: 31.31244,
		},
		{
			latitude: 42.81024167,
			longitude: 31.31244167,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024667,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024667,
			longitude: 31.31244333,
		},
		{
			latitude: 42.81024167,
			longitude: 31.31243833,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81024333,
			longitude: 31.31244167,
		},
		{
			latitude: 42.810245,
			longitude: 31.31244167,
		},
		{
			latitude: 42.81017167,
			longitude: 31.31240333,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31215,
		},
		{
			latitude: 42.80939167,
			longitude: 31.31202,
		},
		{
			latitude: 42.809165,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917333,
			longitude: 31.31191333,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31191,
		},
		{
			latitude: 42.80916833,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917333,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80916833,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80917,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80917,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80917333,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917333,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80916833,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917,
			longitude: 31.31191,
		},
		{
			latitude: 42.80917167,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80916833,
			longitude: 31.31191,
		},
		{
			latitude: 42.80921833,
			longitude: 31.31183667,
		},
		{
			latitude: 42.80926333,
			longitude: 31.311915,
		},
		{
			latitude: 42.80928833,
			longitude: 31.31196333,
		},
		{
			latitude: 42.80928833,
			longitude: 31.31196167,
		},
		{
			latitude: 42.80928833,
			longitude: 31.31196333,
		},
		{
			latitude: 42.80929,
			longitude: 31.31196333,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926667,
			longitude: 31.31193,
		},
		{
			latitude: 42.809265,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926667,
			longitude: 31.31193,
		},
		{
			latitude: 42.809265,
			longitude: 31.31192833,
		},
		{
			latitude: 42.809265,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926667,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192667,
		},
		{
			latitude: 42.809265,
			longitude: 31.31192833,
		},
		{
			latitude: 42.809265,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926667,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926667,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80925667,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80925833,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925833,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192667,
		},
		{
			latitude: 42.809255,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80925833,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926833,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926667,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926667,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926667,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926667,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80927,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80905667,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80892833,
			longitude: 31.31195167,
		},
		{
			latitude: 42.80893667,
			longitude: 31.31195167,
		},
		{
			latitude: 42.80893167,
			longitude: 31.31195333,
		},
		{
			latitude: 42.80892333,
			longitude: 31.31195833,
		},
		{
			latitude: 42.80892333,
			longitude: 31.31195833,
		},
		{
			latitude: 42.80892833,
			longitude: 31.31195667,
		},
		{
			latitude: 42.80892167,
			longitude: 31.31195833,
		},
		{
			latitude: 42.808925,
			longitude: 31.31195833,
		},
		{
			latitude: 42.80892333,
			longitude: 31.31195833,
		},
		{
			latitude: 42.80892667,
			longitude: 31.31195833,
		},
		{
			latitude: 42.80892667,
			longitude: 31.31195667,
		},
		{
			latitude: 42.80892167,
			longitude: 31.31196,
		},
		{
			latitude: 42.80893,
			longitude: 31.311955,
		},
		{
			latitude: 42.80892333,
			longitude: 31.31195833,
		},
		{
			latitude: 42.80892667,
			longitude: 31.31195667,
		},
		{
			latitude: 42.80893333,
			longitude: 31.311955,
		},
		{
			latitude: 42.80892333,
			longitude: 31.311955,
		},
		{
			latitude: 42.808925,
			longitude: 31.31195833,
		},
		{
			latitude: 42.808925,
			longitude: 31.31195667,
		},
		{
			latitude: 42.80892667,
			longitude: 31.31195667,
		},
		{
			latitude: 42.808925,
			longitude: 31.31196167,
		},
		{
			latitude: 42.808925,
			longitude: 31.31195833,
		},
		{
			latitude: 42.808945,
			longitude: 31.31194833,
		},
		{
			latitude: 42.80907,
			longitude: 31.31191,
		},
		{
			latitude: 42.809075,
			longitude: 31.31190833,
		},
		{
			latitude: 42.809065,
			longitude: 31.31191,
		},
		{
			latitude: 42.80907,
			longitude: 31.31191333,
		},
		{
			latitude: 42.809075,
			longitude: 31.31191,
		},
		{
			latitude: 42.809065,
			longitude: 31.31191,
		},
		{
			latitude: 42.80905833,
			longitude: 31.31191,
		},
		{
			latitude: 42.80905833,
			longitude: 31.31191,
		},
		{
			latitude: 42.809065,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80905833,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80906333,
			longitude: 31.31191,
		},
		{
			latitude: 42.80906167,
			longitude: 31.31191,
		},
		{
			latitude: 42.80906167,
			longitude: 31.31191,
		},
		{
			latitude: 42.80906667,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80906333,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80907667,
			longitude: 31.31191333,
		},
		{
			latitude: 42.80907,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80906833,
			longitude: 31.31191,
		},
		{
			latitude: 42.80906833,
			longitude: 31.31191,
		},
		{
			latitude: 42.809065,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80906667,
			longitude: 31.31191,
		},
		{
			latitude: 42.809065,
			longitude: 31.31191,
		},
		{
			latitude: 42.80906,
			longitude: 31.31191167,
		},
		{
			latitude: 42.809065,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80906333,
			longitude: 31.31191,
		},
		{
			latitude: 42.809065,
			longitude: 31.31191,
		},
		{
			latitude: 42.80905833,
			longitude: 31.31190833,
		},
		{
			latitude: 42.80906,
			longitude: 31.31190833,
		},
		{
			latitude: 42.80906333,
			longitude: 31.31191,
		},
		{
			latitude: 42.80907333,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80906333,
			longitude: 31.31191,
		},
		{
			latitude: 42.80906,
			longitude: 31.31191,
		},
		{
			latitude: 42.80906,
			longitude: 31.31191,
		},
		{
			latitude: 42.80906333,
			longitude: 31.31190833,
		},
		{
			latitude: 42.80906333,
			longitude: 31.31191,
		},
		{
			latitude: 42.80907,
			longitude: 31.31191,
		},
		{
			latitude: 42.80921833,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80920333,
			longitude: 31.31190833,
		},
		{
			latitude: 42.809215,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80923333,
			longitude: 31.311925,
		},
		{
			latitude: 42.80921,
			longitude: 31.31191333,
		},
		{
			latitude: 42.809205,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80922333,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80900333,
			longitude: 31.311925,
		},
		{
			latitude: 42.80900667,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80901333,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80901333,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80901167,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80902,
			longitude: 31.311925,
		},
		{
			latitude: 42.809015,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80901167,
			longitude: 31.31192,
		},
		{
			latitude: 42.80901333,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80901667,
			longitude: 31.31192167,
		},
		{
			latitude: 42.80902333,
			longitude: 31.31192167,
		},
		{
			latitude: 42.80901833,
			longitude: 31.31192167,
		},
		{
			latitude: 42.80902333,
			longitude: 31.31192,
		},
		{
			latitude: 42.80902,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902667,
			longitude: 31.311925,
		},
		{
			latitude: 42.80901833,
			longitude: 31.311925,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80900333,
			longitude: 31.31192167,
		},
		{
			latitude: 42.80900667,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80902333,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31192,
		},
		{
			latitude: 42.80901833,
			longitude: 31.31192,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31192,
		},
		{
			latitude: 42.80902,
			longitude: 31.31192333,
		},
		{
			latitude: 42.809015,
			longitude: 31.31191667,
		},
		{
			latitude: 42.809015,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31192167,
		},
		{
			latitude: 42.80901667,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80902667,
			longitude: 31.31192,
		},
		{
			latitude: 42.80903,
			longitude: 31.31192333,
		},
		{
			latitude: 42.809025,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902333,
			longitude: 31.31192167,
		},
		{
			latitude: 42.809025,
			longitude: 31.31192333,
		},
		{
			latitude: 42.809015,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80902833,
			longitude: 31.31191333,
		},
		{
			latitude: 42.809015,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80901333,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31191167,
		},
		{
			latitude: 42.80902,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80903,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80901167,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80901833,
			longitude: 31.311925,
		},
		{
			latitude: 42.80902333,
			longitude: 31.311925,
		},
		{
			latitude: 42.80902333,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80901833,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80901833,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902167,
			longitude: 31.311915,
		},
		{
			latitude: 42.809015,
			longitude: 31.31192,
		},
		{
			latitude: 42.80902833,
			longitude: 31.311915,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31192167,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31191833,
		},
		{
			latitude: 42.809025,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80901833,
			longitude: 31.311915,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31191833,
		},
		{
			latitude: 42.809025,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80902,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80901833,
			longitude: 31.31192167,
		},
		{
			latitude: 42.80902,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80902,
			longitude: 31.311915,
		},
		{
			latitude: 42.80901667,
			longitude: 31.31192,
		},
		{
			latitude: 42.80902,
			longitude: 31.31192,
		},
		{
			latitude: 42.809025,
			longitude: 31.31192,
		},
		{
			latitude: 42.80901333,
			longitude: 31.31192167,
		},
		{
			latitude: 42.809025,
			longitude: 31.31192,
		},
		{
			latitude: 42.80902167,
			longitude: 31.31192,
		},
		{
			latitude: 42.80902,
			longitude: 31.31192,
		},
		{
			latitude: 42.809025,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80901833,
			longitude: 31.31192,
		},
		{
			latitude: 42.80901667,
			longitude: 31.31192,
		},
		{
			latitude: 42.80902,
			longitude: 31.31192,
		},
		{
			latitude: 42.80902,
			longitude: 31.31191833,
		},
		{
			latitude: 42.80901833,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80901333,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80901833,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80901,
			longitude: 31.31191667,
		},
		{
			latitude: 42.80901167,
			longitude: 31.31192333,
		},
		{
			latitude: 42.809015,
			longitude: 31.31192,
		},
		{
			latitude: 42.80901333,
			longitude: 31.31192167,
		},
		{
			latitude: 42.80901167,
			longitude: 31.31192,
		},
		{
			latitude: 42.80901833,
			longitude: 31.31191833,
		},
		{
			latitude: 42.809015,
			longitude: 31.31192333,
		},
		{
			latitude: 42.809225,
			longitude: 31.311915,
		},
		{
			latitude: 42.809465,
			longitude: 31.31205833,
		},
		{
			latitude: 42.80951167,
			longitude: 31.31211333,
		},
		{
			latitude: 42.80950667,
			longitude: 31.3121,
		},
		{
			latitude: 42.80951833,
			longitude: 31.31212,
		},
		{
			latitude: 42.80950333,
			longitude: 31.31210667,
		},
		{
			latitude: 42.80951333,
			longitude: 31.312125,
		},
		{
			latitude: 42.809515,
			longitude: 31.31212,
		},
		{
			latitude: 42.809505,
			longitude: 31.31210167,
		},
		{
			latitude: 42.809385,
			longitude: 31.31198833,
		},
		{
			latitude: 42.80938833,
			longitude: 31.31198667,
		},
		{
			latitude: 42.809385,
			longitude: 31.31199167,
		},
		{
			latitude: 42.809385,
			longitude: 31.31198833,
		},
		{
			latitude: 42.8094,
			longitude: 31.31200833,
		},
		{
			latitude: 42.80939667,
			longitude: 31.312,
		},
		{
			latitude: 42.80931,
			longitude: 31.31194167,
		},
		{
			latitude: 42.80925,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80925833,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80925667,
			longitude: 31.311925,
		},
		{
			latitude: 42.80924,
			longitude: 31.31192167,
		},
		{
			latitude: 42.809255,
			longitude: 31.31192167,
		},
		{
			latitude: 42.809255,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80925167,
			longitude: 31.311925,
		},
		{
			latitude: 42.809265,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80925167,
			longitude: 31.31192,
		},
		{
			latitude: 42.80925167,
			longitude: 31.31192167,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80925667,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31193167,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80925833,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926167,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925667,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192667,
		},
		{
			latitude: 42.809255,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80925833,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925667,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926333,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926167,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925667,
			longitude: 31.31192333,
		},
		{
			latitude: 42.809255,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925833,
			longitude: 31.31192667,
		},
		{
			latitude: 42.809255,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192833,
		},
		{
			latitude: 42.809255,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925833,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80925667,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192833,
		},
		{
			latitude: 42.809265,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926833,
			longitude: 31.31193,
		},
		{
			latitude: 42.80926167,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192833,
		},
		{
			latitude: 42.809265,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80925833,
			longitude: 31.311925,
		},
		{
			latitude: 42.809255,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925833,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80925833,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926167,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925833,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80925667,
			longitude: 31.31192833,
		},
		{
			latitude: 42.809255,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80925833,
			longitude: 31.31192333,
		},
		{
			latitude: 42.809255,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80925667,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925333,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192333,
		},
		{
			latitude: 42.809265,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80925333,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925833,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926167,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926333,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925833,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926167,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925833,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80925833,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925667,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925833,
			longitude: 31.311925,
		},
		{
			latitude: 42.80925667,
			longitude: 31.31192667,
		},
		{
			latitude: 42.80926333,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926333,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926167,
			longitude: 31.31192833,
		},
		{
			latitude: 42.809255,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192833,
		},
		{
			latitude: 42.80925667,
			longitude: 31.311925,
		},
		{
			latitude: 42.80926,
			longitude: 31.31192333,
		},
		{
			latitude: 42.80929167,
			longitude: 31.31194167,
		},
		{
			latitude: 42.809445,
			longitude: 31.31203,
		},
		{
			latitude: 42.80944,
			longitude: 31.31203333,
		},
		{
			latitude: 42.80943167,
			longitude: 31.31202667,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31202667,
		},
		{
			latitude: 42.80943833,
			longitude: 31.31203333,
		},
		{
			latitude: 42.80942667,
			longitude: 31.31202667,
		},
		{
			latitude: 42.80943833,
			longitude: 31.31203167,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31202833,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31203,
		},
		{
			latitude: 42.80944,
			longitude: 31.31203333,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31203167,
		},
		{
			latitude: 42.80943333,
			longitude: 31.31203,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31202833,
		},
		{
			latitude: 42.80943167,
			longitude: 31.31202833,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31203,
		},
		{
			latitude: 42.80944,
			longitude: 31.31203,
		},
		{
			latitude: 42.80943167,
			longitude: 31.31203167,
		},
		{
			latitude: 42.80944333,
			longitude: 31.31203833,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31203333,
		},
		{
			latitude: 42.80943833,
			longitude: 31.31203333,
		},
		{
			latitude: 42.80942833,
			longitude: 31.31203,
		},
		{
			latitude: 42.80943167,
			longitude: 31.31202833,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31203,
		},
		{
			latitude: 42.809445,
			longitude: 31.31203167,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31203,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31203167,
		},
		{
			latitude: 42.80943333,
			longitude: 31.31203167,
		},
		{
			latitude: 42.80943,
			longitude: 31.31203167,
		},
		{
			latitude: 42.80943667,
			longitude: 31.31203167,
		},
		{
			latitude: 42.80944,
			longitude: 31.312035,
		},
		{
			latitude: 42.80943,
			longitude: 31.31203,
		},
		{
			latitude: 42.80944167,
			longitude: 31.31203,
		},
		{
			latitude: 42.80944,
			longitude: 31.31204167,
		},
		{
			latitude: 42.809435,
			longitude: 31.31202833,
		},
		{
			latitude: 42.80942,
			longitude: 31.31202333,
		},
		{
			latitude: 42.809435,
			longitude: 31.31202833,
		},
		{
			latitude: 42.80942833,
			longitude: 31.31202833,
		},
		{
			latitude: 42.80943167,
			longitude: 31.31203,
		},
		{
			latitude: 42.80943,
			longitude: 31.31203167,
		},
		{
			latitude: 42.80944,
			longitude: 31.312035,
		},
		{
			latitude: 42.80944333,
			longitude: 31.31203333,
		},
		{
			latitude: 42.80954667,
			longitude: 31.31216167,
		},
		{
			latitude: 42.80957833,
			longitude: 31.31221667,
		},
		{
			latitude: 42.80957167,
			longitude: 31.31220833,
		},
		{
			latitude: 42.809575,
			longitude: 31.31221167,
		},
		{
			latitude: 42.809575,
			longitude: 31.31221333,
		},
		{
			latitude: 42.80957667,
			longitude: 31.312215,
		},
		{
			latitude: 42.80957833,
			longitude: 31.31221333,
		},
		{
			latitude: 42.80957667,
			longitude: 31.31221167,
		},
		{
			latitude: 42.80957667,
			longitude: 31.312215,
		},
		{
			latitude: 42.80955833,
			longitude: 31.31218667,
		},
		{
			latitude: 42.80957833,
			longitude: 31.31221,
		},
		{
			latitude: 42.80956833,
			longitude: 31.31220667,
		},
		{
			latitude: 42.80958,
			longitude: 31.31221833,
		},
		{
			latitude: 42.80958,
			longitude: 31.31222,
		},
		{
			latitude: 42.80957667,
			longitude: 31.312215,
		},
		{
			latitude: 42.80957333,
			longitude: 31.31221667,
		},
		{
			latitude: 42.80957833,
			longitude: 31.31221667,
		},
		{
			latitude: 42.80956833,
			longitude: 31.31221333,
		},
		{
			latitude: 42.80957333,
			longitude: 31.31220833,
		},
		{
			latitude: 42.80957167,
			longitude: 31.31221,
		},
		{
			latitude: 42.80957333,
			longitude: 31.31220833,
		},
		{
			latitude: 42.809575,
			longitude: 31.31221167,
		},
		{
			latitude: 42.809575,
			longitude: 31.31221333,
		},
		{
			latitude: 42.80957333,
			longitude: 31.31221167,
		},
		{
			latitude: 42.80957167,
			longitude: 31.31221,
		},
		{
			latitude: 42.809575,
			longitude: 31.31221,
		},
		{
			latitude: 42.80957333,
			longitude: 31.31221,
		},
		{
			latitude: 42.80958,
			longitude: 31.31222167,
		},
		{
			latitude: 42.80957167,
			longitude: 31.31220833,
		},
		{
			latitude: 42.80957,
			longitude: 31.31220667,
		},
		{
			latitude: 42.809585,
			longitude: 31.31222,
		},
		{
			latitude: 42.80958,
			longitude: 31.312215,
		},
		{
			latitude: 42.809575,
			longitude: 31.31221167,
		},
		{
			latitude: 42.80957167,
			longitude: 31.31220833,
		},
		{
			latitude: 42.80957,
			longitude: 31.312205,
		},
		{
			latitude: 42.809575,
			longitude: 31.31221667,
		},
		{
			latitude: 42.80957667,
			longitude: 31.312215,
		},
		{
			latitude: 42.80958167,
			longitude: 31.312215,
		},
		{
			latitude: 42.80956833,
			longitude: 31.31220667,
		},
		{
			latitude: 42.80957333,
			longitude: 31.31221,
		},
		{
			latitude: 42.809575,
			longitude: 31.31222,
		},
		{
			latitude: 42.80957,
			longitude: 31.31220333,
		},
		{
			latitude: 42.80958,
			longitude: 31.31222167,
		},
		{
			latitude: 42.80957333,
			longitude: 31.31221,
		},
		{
			latitude: 42.80960333,
			longitude: 31.31226833,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31244333,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31244333,
		},
		{
			latitude: 42.80965667,
			longitude: 31.31244,
		},
		{
			latitude: 42.80966,
			longitude: 31.312455,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31245,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31245167,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31245667,
		},
		{
			latitude: 42.80965667,
			longitude: 31.31243667,
		},
		{
			latitude: 42.80965667,
			longitude: 31.31244667,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31245,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31244667,
		},
		{
			latitude: 42.80966,
			longitude: 31.31244667,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31244833,
		},
		{
			latitude: 42.80966,
			longitude: 31.31244667,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31245333,
		},
		{
			latitude: 42.80966,
			longitude: 31.31244333,
		},
		{
			latitude: 42.80966,
			longitude: 31.31244833,
		},
		{
			latitude: 42.80966,
			longitude: 31.31245,
		},
		{
			latitude: 42.80966,
			longitude: 31.31244167,
		},
		{
			latitude: 42.809665,
			longitude: 31.31245167,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31245833,
		},
		{
			latitude: 42.809665,
			longitude: 31.31246,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31244333,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31243333,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31245,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31245333,
		},
		{
			latitude: 42.80965167,
			longitude: 31.312425,
		},
		{
			latitude: 42.80965667,
			longitude: 31.31243667,
		},
		{
			latitude: 42.809655,
			longitude: 31.31243167,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31244833,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31245167,
		},
		{
			latitude: 42.80965833,
			longitude: 31.312445,
		},
		{
			latitude: 42.80965667,
			longitude: 31.31243333,
		},
		{
			latitude: 42.80965667,
			longitude: 31.312435,
		},
		{
			latitude: 42.80965833,
			longitude: 31.312435,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31243333,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31244833,
		},
		{
			latitude: 42.809655,
			longitude: 31.312435,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31244667,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31244667,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31243833,
		},
		{
			latitude: 42.80966,
			longitude: 31.31244,
		},
		{
			latitude: 42.80966167,
			longitude: 31.312445,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31244,
		},
		{
			latitude: 42.809655,
			longitude: 31.312435,
		},
		{
			latitude: 42.80965,
			longitude: 31.31242167,
		},
		{
			latitude: 42.80965833,
			longitude: 31.312435,
		},
		{
			latitude: 42.80966167,
			longitude: 31.312445,
		},
		{
			latitude: 42.809665,
			longitude: 31.31246167,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31244833,
		},
		{
			latitude: 42.80965667,
			longitude: 31.31243167,
		},
		{
			latitude: 42.80966,
			longitude: 31.312455,
		},
		{
			latitude: 42.80965667,
			longitude: 31.31243833,
		},
		{
			latitude: 42.80966,
			longitude: 31.31244667,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31245,
		},
		{
			latitude: 42.80966167,
			longitude: 31.312445,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31245167,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31244833,
		},
		{
			latitude: 42.80965667,
			longitude: 31.31244167,
		},
		{
			latitude: 42.80966,
			longitude: 31.31244167,
		},
		{
			latitude: 42.809665,
			longitude: 31.312455,
		},
		{
			latitude: 42.809665,
			longitude: 31.31245833,
		},
		{
			latitude: 42.80965833,
			longitude: 31.312435,
		},
		{
			latitude: 42.80966,
			longitude: 31.31243667,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31244667,
		},
		{
			latitude: 42.809655,
			longitude: 31.31243,
		},
		{
			latitude: 42.80966,
			longitude: 31.31244,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31244833,
		},
		{
			latitude: 42.80966,
			longitude: 31.31244333,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31245167,
		},
		{
			latitude: 42.80965667,
			longitude: 31.31243833,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31245167,
		},
		{
			latitude: 42.80966,
			longitude: 31.31245,
		},
		{
			latitude: 42.80965667,
			longitude: 31.312435,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31244667,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31244667,
		},
		{
			latitude: 42.809655,
			longitude: 31.31243,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31244333,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31244833,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31243833,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31244333,
		},
		{
			latitude: 42.80966333,
			longitude: 31.312445,
		},
		{
			latitude: 42.809665,
			longitude: 31.31246,
		},
		{
			latitude: 42.80965667,
			longitude: 31.31243833,
		},
		{
			latitude: 42.80966,
			longitude: 31.312445,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31245167,
		},
		{
			latitude: 42.80964667,
			longitude: 31.312425,
		},
		{
			latitude: 42.80966,
			longitude: 31.31243333,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31244833,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31245333,
		},
		{
			latitude: 42.80966667,
			longitude: 31.312465,
		},
		{
			latitude: 42.80965667,
			longitude: 31.312435,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31243667,
		},
		{
			latitude: 42.80966167,
			longitude: 31.31245167,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31245333,
		},
		{
			latitude: 42.80968,
			longitude: 31.31254333,
		},
		{
			latitude: 42.80966833,
			longitude: 31.31277167,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31269833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312695,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31270167,
		},
		{
			latitude: 42.809675,
			longitude: 31.312705,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312705,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31271333,
		},
		{
			latitude: 42.80967333,
			longitude: 31.31272167,
		},
		{
			latitude: 42.80968,
			longitude: 31.31272333,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31272333,
		},
		{
			latitude: 42.80968,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80967167,
			longitude: 31.31271167,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31269667,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31271667,
		},
		{
			latitude: 42.809675,
			longitude: 31.31272,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31272833,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31272833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31271,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31269167,
		},
		{
			latitude: 42.80968667,
			longitude: 31.3127,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312685,
		},
		{
			latitude: 42.809685,
			longitude: 31.31269167,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80967333,
			longitude: 31.31271333,
		},
		{
			latitude: 42.809685,
			longitude: 31.312685,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31271833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31269667,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271,
		},
		{
			latitude: 42.80967667,
			longitude: 31.3127,
		},
		{
			latitude: 42.809685,
			longitude: 31.312705,
		},
		{
			latitude: 42.80967333,
			longitude: 31.31271833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312695,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271667,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31272,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31272167,
		},
		{
			latitude: 42.80968,
			longitude: 31.3127,
		},
		{
			latitude: 42.80968,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968,
			longitude: 31.312705,
		},
		{
			latitude: 42.80966,
			longitude: 31.31271,
		},
		{
			latitude: 42.809685,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31269,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31271667,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31271,
		},
		{
			latitude: 42.80967667,
			longitude: 31.312725,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31269667,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31269333,
		},
		{
			latitude: 42.809675,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312705,
		},
		{
			latitude: 42.80968,
			longitude: 31.3127,
		},
		{
			latitude: 42.80968667,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31269333,
		},
		{
			latitude: 42.809685,
			longitude: 31.31269333,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312705,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312705,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31271333,
		},
		{
			latitude: 42.80968833,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80968,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80969,
			longitude: 31.31269167,
		},
		{
			latitude: 42.80967833,
			longitude: 31.312725,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31271,
		},
		{
			latitude: 42.80967833,
			longitude: 31.312695,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312705,
		},
		{
			latitude: 42.809685,
			longitude: 31.31269833,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312695,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312715,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80968167,
			longitude: 31.3127,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968,
			longitude: 31.31272667,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31271,
		},
		{
			latitude: 42.80968,
			longitude: 31.312695,
		},
		{
			latitude: 42.809685,
			longitude: 31.312695,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271167,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31272333,
		},
		{
			latitude: 42.80968,
			longitude: 31.31269667,
		},
		{
			latitude: 42.809675,
			longitude: 31.312725,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312715,
		},
		{
			latitude: 42.809685,
			longitude: 31.31271,
		},
		{
			latitude: 42.80968,
			longitude: 31.31270167,
		},
		{
			latitude: 42.809675,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271167,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312705,
		},
		{
			latitude: 42.809685,
			longitude: 31.31269667,
		},
		{
			latitude: 42.80968,
			longitude: 31.31273667,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31272,
		},
		{
			latitude: 42.809685,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80967167,
			longitude: 31.31268833,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31271667,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31271,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31272667,
		},
		{
			latitude: 42.80967333,
			longitude: 31.312735,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312715,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31269667,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31272333,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31271333,
		},
		{
			latitude: 42.80968,
			longitude: 31.31272833,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31269333,
		},
		{
			latitude: 42.80968333,
			longitude: 31.3127,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312705,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80966667,
			longitude: 31.31273333,
		},
		{
			latitude: 42.809685,
			longitude: 31.312695,
		},
		{
			latitude: 42.80968,
			longitude: 31.312715,
		},
		{
			latitude: 42.80968667,
			longitude: 31.312695,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31269,
		},
		{
			latitude: 42.80968833,
			longitude: 31.3127,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31271833,
		},
		{
			latitude: 42.80968,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80967333,
			longitude: 31.31269833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31271,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31270833,
		},
		{
			latitude: 42.809685,
			longitude: 31.31271,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31271167,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.3127,
		},
		{
			latitude: 42.80967333,
			longitude: 31.31271167,
		},
		{
			latitude: 42.809695,
			longitude: 31.312705,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80967167,
			longitude: 31.31272333,
		},
		{
			latitude: 42.80968,
			longitude: 31.31273667,
		},
		{
			latitude: 42.80967167,
			longitude: 31.31268167,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312705,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31271667,
		},
		{
			latitude: 42.80968667,
			longitude: 31.31271167,
		},
		{
			latitude: 42.80968667,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80967667,
			longitude: 31.3127,
		},
		{
			latitude: 42.809685,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80967667,
			longitude: 31.3127,
		},
		{
			latitude: 42.809685,
			longitude: 31.312705,
		},
		{
			latitude: 42.80966333,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80967833,
			longitude: 31.3127,
		},
		{
			latitude: 42.80968167,
			longitude: 31.3127,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80967,
			longitude: 31.312715,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968667,
			longitude: 31.31269833,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31269167,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271333,
		},
		{
			latitude: 42.80968833,
			longitude: 31.31269,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271833,
		},
		{
			latitude: 42.80968667,
			longitude: 31.312705,
		},
		{
			latitude: 42.809675,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80968,
			longitude: 31.312685,
		},
		{
			latitude: 42.80967,
			longitude: 31.31271833,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31272167,
		},
		{
			latitude: 42.80968,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31271,
		},
		{
			latitude: 42.80967333,
			longitude: 31.31274,
		},
		{
			latitude: 42.809675,
			longitude: 31.31272167,
		},
		{
			latitude: 42.809675,
			longitude: 31.31269833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312715,
		},
		{
			latitude: 42.80967167,
			longitude: 31.31269833,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31269833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312705,
		},
		{
			latitude: 42.809685,
			longitude: 31.31269333,
		},
		{
			latitude: 42.80968,
			longitude: 31.31272333,
		},
		{
			latitude: 42.80967333,
			longitude: 31.312715,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312715,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31269667,
		},
		{
			latitude: 42.80968,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80968667,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80967833,
			longitude: 31.312695,
		},
		{
			latitude: 42.80967833,
			longitude: 31.312715,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31272167,
		},
		{
			latitude: 42.80967333,
			longitude: 31.31271667,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312715,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80967333,
			longitude: 31.312705,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80967833,
			longitude: 31.3127,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31271167,
		},
		{
			latitude: 42.80968,
			longitude: 31.312695,
		},
		{
			latitude: 42.80968,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271667,
		},
		{
			latitude: 42.80967167,
			longitude: 31.31269833,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31271833,
		},
		{
			latitude: 42.80968,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312705,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31272167,
		},
		{
			latitude: 42.80968667,
			longitude: 31.31272167,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31271,
		},
		{
			latitude: 42.80968333,
			longitude: 31.312705,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31271167,
		},
		{
			latitude: 42.80968167,
			longitude: 31.312705,
		},
		{
			latitude: 42.80967167,
			longitude: 31.312715,
		},
		{
			latitude: 42.80967333,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968,
			longitude: 31.31269833,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31271333,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270667,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271167,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31272,
		},
		{
			latitude: 42.809685,
			longitude: 31.31271167,
		},
		{
			latitude: 42.809685,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968333,
			longitude: 31.31271333,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31270333,
		},
		{
			latitude: 42.809685,
			longitude: 31.31271,
		},
		{
			latitude: 42.80968,
			longitude: 31.31269833,
		},
		{
			latitude: 42.80968167,
			longitude: 31.3127,
		},
		{
			latitude: 42.80968167,
			longitude: 31.3127,
		},
		{
			latitude: 42.80967667,
			longitude: 31.312715,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31273,
		},
		{
			latitude: 42.809685,
			longitude: 31.31270167,
		},
		{
			latitude: 42.80968,
			longitude: 31.31271667,
		},
		{
			latitude: 42.80966833,
			longitude: 31.31271667,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31268833,
		},
		{
			latitude: 42.80967667,
			longitude: 31.31272,
		},
		{
			latitude: 42.809675,
			longitude: 31.312715,
		},
		{
			latitude: 42.80968167,
			longitude: 31.31270833,
		},
		{
			latitude: 42.80967833,
			longitude: 31.312715,
		},
		{
			latitude: 42.80967833,
			longitude: 31.31270333,
		},
		{
			latitude: 42.80968,
			longitude: 31.312725,
		},
		{
			latitude: 42.80966667,
			longitude: 31.312495,
		},
		{
			latitude: 42.80964167,
			longitude: 31.312375,
		},
		{
			latitude: 42.80963667,
			longitude: 31.312375,
		},
		{
			latitude: 42.80964167,
			longitude: 31.312365,
		},
		{
			latitude: 42.80964667,
			longitude: 31.31239333,
		},
		{
			latitude: 42.80964167,
			longitude: 31.31238667,
		},
		{
			latitude: 42.80965,
			longitude: 31.31238,
		},
		{
			latitude: 42.809655,
			longitude: 31.31239667,
		},
		{
			latitude: 42.809645,
			longitude: 31.31238333,
		},
		{
			latitude: 42.80963667,
			longitude: 31.312365,
		},
		{
			latitude: 42.80964167,
			longitude: 31.31237333,
		},
		{
			latitude: 42.80964667,
			longitude: 31.312395,
		},
		{
			latitude: 42.80964833,
			longitude: 31.312395,
		},
		{
			latitude: 42.809645,
			longitude: 31.31238167,
		},
		{
			latitude: 42.80964833,
			longitude: 31.31238,
		},
		{
			latitude: 42.80964667,
			longitude: 31.31238667,
		},
		{
			latitude: 42.80964833,
			longitude: 31.31239833,
		},
		{
			latitude: 42.80964333,
			longitude: 31.312375,
		},
		{
			latitude: 42.80964167,
			longitude: 31.31239667,
		},
		{
			latitude: 42.80963833,
			longitude: 31.31238833,
		},
		{
			latitude: 42.809645,
			longitude: 31.31238833,
		},
		{
			latitude: 42.80964667,
			longitude: 31.31238833,
		},
		{
			latitude: 42.80965,
			longitude: 31.312385,
		},
		{
			latitude: 42.80964667,
			longitude: 31.31238,
		},
		{
			latitude: 42.80964333,
			longitude: 31.31237667,
		},
		{
			latitude: 42.80964,
			longitude: 31.31238,
		},
		{
			latitude: 42.80964667,
			longitude: 31.31239333,
		},
		{
			latitude: 42.80964333,
			longitude: 31.312385,
		},
		{
			latitude: 42.80964333,
			longitude: 31.31238833,
		},
		{
			latitude: 42.80965333,
			longitude: 31.31239667,
		},
		{
			latitude: 42.80965333,
			longitude: 31.31240167,
		},
		{
			latitude: 42.80964833,
			longitude: 31.31239,
		},
		{
			latitude: 42.80964333,
			longitude: 31.31238167,
		},
		{
			latitude: 42.80964,
			longitude: 31.31238,
		},
		{
			latitude: 42.80964667,
			longitude: 31.312385,
		},
		{
			latitude: 42.809635,
			longitude: 31.31237333,
		},
		{
			latitude: 42.809645,
			longitude: 31.31236167,
		},
		{
			latitude: 42.80965167,
			longitude: 31.312395,
		},
		{
			latitude: 42.80964667,
			longitude: 31.31239667,
		},
		{
			latitude: 42.809645,
			longitude: 31.31239,
		},
		{
			latitude: 42.80964167,
			longitude: 31.31237333,
		},
		{
			latitude: 42.80965167,
			longitude: 31.31238667,
		},
		{
			latitude: 42.80964833,
			longitude: 31.31239667,
		},
		{
			latitude: 42.80964,
			longitude: 31.312385,
		},
		{
			latitude: 42.80963333,
			longitude: 31.31238,
		},
		{
			latitude: 42.80964167,
			longitude: 31.312375,
		},
		{
			latitude: 42.80964667,
			longitude: 31.31239333,
		},
		{
			latitude: 42.80964833,
			longitude: 31.31239167,
		},
		{
			latitude: 42.80965,
			longitude: 31.31238333,
		},
		{
			latitude: 42.80965833,
			longitude: 31.31240833,
		},
		{
			latitude: 42.809665,
			longitude: 31.31241833,
		},
		{
			latitude: 42.80967167,
			longitude: 31.31242833,
		},
		{
			latitude: 42.80967167,
			longitude: 31.312425,
		},
		{
			latitude: 42.80967,
			longitude: 31.31242,
		},
		{
			latitude: 42.80966667,
			longitude: 31.31242667,
		},
		{
			latitude: 42.809665,
			longitude: 31.31242,
		},
		{
			latitude: 42.80969,
			longitude: 31.31282667,
		},
		{
			latitude: 42.80982333,
			longitude: 31.313205,
		},
		{
			latitude: 42.81,
			longitude: 31.31368,
		},
		{
			latitude: 42.81007833,
			longitude: 31.31393833,
		},
		{
			latitude: 42.81008333,
			longitude: 31.31390833,
		},
		{
			latitude: 42.81008,
			longitude: 31.31390667,
		},
		{
			latitude: 42.81008333,
			longitude: 31.31391333,
		},
		{
			latitude: 42.81008167,
			longitude: 31.31397667,
		},
		{
			latitude: 42.810045,
			longitude: 31.31398333,
		},
		{
			latitude: 42.81004167,
			longitude: 31.31396,
		},
		{
			latitude: 42.81002833,
			longitude: 31.314015,
		},
		{
			latitude: 42.81004167,
			longitude: 31.31399167,
		},
		{
			latitude: 42.81044,
			longitude: 31.31397833,
		},
		{
			latitude: 42.81085,
			longitude: 31.313985,
		},
		{
			latitude: 42.81127,
			longitude: 31.31398,
		},
		{
			latitude: 42.81162333,
			longitude: 31.31399667,
		},
		{
			latitude: 42.81202167,
			longitude: 31.31398333,
		},
		{
			latitude: 42.81244833,
			longitude: 31.313975,
		},
		{
			latitude: 42.812845,
			longitude: 31.313985,
		},
		{
			latitude: 42.813245,
			longitude: 31.31398833,
		},
		{
			latitude: 42.81333,
			longitude: 31.313985,
		},
		{
			latitude: 42.81366167,
			longitude: 31.31397833,
		},
		{
			latitude: 42.81407333,
			longitude: 31.31398333,
		},
		{
			latitude: 42.81447333,
			longitude: 31.31397333,
		},
		{
			latitude: 42.81486667,
			longitude: 31.31398667,
		},
		{
			latitude: 42.815275,
			longitude: 31.314,
		},
		{
			latitude: 42.815685,
			longitude: 31.31397167,
		},
		{
			latitude: 42.81609,
			longitude: 31.31396167,
		},
		{
			latitude: 42.816345,
			longitude: 31.313975,
		},
		{
			latitude: 42.81634833,
			longitude: 31.31397833,
		},
		{
			latitude: 42.81634833,
			longitude: 31.31397833,
		},
		{
			latitude: 42.816345,
			longitude: 31.31399333,
		},
		{
			latitude: 42.81634667,
			longitude: 31.31397667,
		},
		{
			latitude: 42.81635,
			longitude: 31.31397667,
		},
		{
			latitude: 42.81635167,
			longitude: 31.31397667,
		},
		{
			latitude: 42.81633833,
			longitude: 31.31398167,
		},
		{
			latitude: 42.81634333,
			longitude: 31.31398333,
		},
		{
			latitude: 42.816345,
			longitude: 31.31397833,
		},
		{
			latitude: 42.81634,
			longitude: 31.31399667,
		},
		{
			latitude: 42.816345,
			longitude: 31.31398333,
		},
		{
			latitude: 42.81634833,
			longitude: 31.31397833,
		},
		{
			latitude: 42.81634667,
			longitude: 31.313975,
		},
		{
			latitude: 42.81634333,
			longitude: 31.313985,
		},
		{
			latitude: 42.81634667,
			longitude: 31.31396333,
		},
		{
			latitude: 42.81634833,
			longitude: 31.313995,
		},
		{
			latitude: 42.81635,
			longitude: 31.31396667,
		},
		{
			latitude: 42.81634833,
			longitude: 31.31398167,
		},
		{
			latitude: 42.816345,
			longitude: 31.313995,
		},
		{
			latitude: 42.81634667,
			longitude: 31.31398667,
		},
		{
			latitude: 42.81634333,
			longitude: 31.31398333,
		},
		{
			latitude: 42.81635,
			longitude: 31.31397,
		},
		{
			latitude: 42.816345,
			longitude: 31.31399333,
		},
		{
			latitude: 42.81635,
			longitude: 31.31397833,
		},
		{
			latitude: 42.81634167,
			longitude: 31.31398167,
		},
		{
			latitude: 42.816335,
			longitude: 31.313965,
		},
		{
			latitude: 42.816345,
			longitude: 31.31397667,
		},
		{
			latitude: 42.81634333,
			longitude: 31.31397333,
		},
		{
			latitude: 42.81633667,
			longitude: 31.31399667,
		},
		{
			latitude: 42.81634167,
			longitude: 31.31401333,
		},
		{
			latitude: 42.81634667,
			longitude: 31.31399,
		},
		{
			latitude: 42.81634833,
			longitude: 31.31396833,
		},
		{
			latitude: 42.81635667,
			longitude: 31.313945,
		},
		{
			latitude: 42.816345,
			longitude: 31.31397,
		},
		{
			latitude: 42.81634667,
			longitude: 31.31398333,
		},
		{
			latitude: 42.81635,
			longitude: 31.31398167,
		},
		{
			latitude: 42.81632333,
			longitude: 31.313965,
		},
		{
			latitude: 42.81634,
			longitude: 31.31398667,
		},
		{
			latitude: 42.81635,
			longitude: 31.31398667,
		},
		{
			latitude: 42.81635167,
			longitude: 31.313985,
		},
		{
			latitude: 42.81634833,
			longitude: 31.31398667,
		},
		{
			latitude: 42.81634333,
			longitude: 31.31396,
		},
		{
			latitude: 42.81635333,
			longitude: 31.313975,
		},
		{
			latitude: 42.816345,
			longitude: 31.31399,
		},
		{
			latitude: 42.81635333,
			longitude: 31.31398167,
		},
		{
			latitude: 42.81633667,
			longitude: 31.31396833,
		},
		{
			latitude: 42.81634833,
			longitude: 31.313985,
		},
		{
			latitude: 42.81634333,
			longitude: 31.313985,
		},
		{
			latitude: 42.81634833,
			longitude: 31.313995,
		},
		{
			latitude: 42.81633,
			longitude: 31.31397333,
		},
		{
			latitude: 42.81635167,
			longitude: 31.313985,
		},
		{
			latitude: 42.81634833,
			longitude: 31.31396667,
		},
		{
			latitude: 42.81635333,
			longitude: 31.314,
		},
		{
			latitude: 42.81633333,
			longitude: 31.31397833,
		},
		{
			latitude: 42.81634167,
			longitude: 31.31398667,
		},
		{
			latitude: 42.81635333,
			longitude: 31.31395833,
		},
		{
			latitude: 42.816345,
			longitude: 31.31397667,
		},
		{
			latitude: 42.81634333,
			longitude: 31.31400333,
		},
		{
			latitude: 42.81634833,
			longitude: 31.31396667,
		},
		{
			latitude: 42.81635333,
			longitude: 31.31398667,
		},
		{
			latitude: 42.81634,
			longitude: 31.31400667,
		},
		{
			latitude: 42.816355,
			longitude: 31.31398,
		},
		{
			latitude: 42.81634167,
			longitude: 31.31399833,
		},
		{
			latitude: 42.81633167,
			longitude: 31.313925,
		},
		{
			latitude: 42.816325,
			longitude: 31.314085,
		},
		{
			latitude: 42.81632167,
			longitude: 31.31411667,
		},
		{
			latitude: 42.81633167,
			longitude: 31.314105,
		},
		{
			latitude: 42.81631833,
			longitude: 31.31410833,
		},
		{
			latitude: 42.81632833,
			longitude: 31.31410833,
		},
		{
			latitude: 42.81632333,
			longitude: 31.31411,
		},
		{
			latitude: 42.81632,
			longitude: 31.31411,
		},
		{
			latitude: 42.81632167,
			longitude: 31.31408167,
		},
		{
			latitude: 42.81632167,
			longitude: 31.31412167,
		},
		{
			latitude: 42.81632333,
			longitude: 31.31412,
		},
		{
			latitude: 42.81631167,
			longitude: 31.314065,
		},
		{
			latitude: 42.816325,
			longitude: 31.31412,
		},
		{
			latitude: 42.81632833,
			longitude: 31.31412167,
		},
		{
			latitude: 42.816325,
			longitude: 31.31411167,
		},
		{
			latitude: 42.81632167,
			longitude: 31.31410833,
		},
		{
			latitude: 42.81632,
			longitude: 31.314105,
		},
		{
			latitude: 42.816325,
			longitude: 31.31412833,
		},
		{
			latitude: 42.81631667,
			longitude: 31.31412,
		},
		{
			latitude: 42.81632,
			longitude: 31.31410833,
		},
		{
			latitude: 42.816325,
			longitude: 31.31411,
		},
		{
			latitude: 42.816325,
			longitude: 31.31412167,
		},
		{
			latitude: 42.81631667,
			longitude: 31.31409667,
		},
		{
			latitude: 42.81632667,
			longitude: 31.31410167,
		},
		{
			latitude: 42.816315,
			longitude: 31.31411333,
		},
		{
			latitude: 42.81632,
			longitude: 31.314095,
		},
		{
			latitude: 42.81631833,
			longitude: 31.314135,
		},
		{
			latitude: 42.81632167,
			longitude: 31.31412167,
		},
		{
			latitude: 42.816325,
			longitude: 31.31411167,
		},
		{
			latitude: 42.81631833,
			longitude: 31.314085,
		},
		{
			latitude: 42.81632,
			longitude: 31.31410667,
		},
		{
			latitude: 42.81630833,
			longitude: 31.314075,
		},
		{
			latitude: 42.81632,
			longitude: 31.31414167,
		},
		{
			latitude: 42.81632,
			longitude: 31.31409333,
		},
		{
			latitude: 42.816305,
			longitude: 31.31408167,
		},
		{
			latitude: 42.81631833,
			longitude: 31.31412833,
		},
		{
			latitude: 42.81632167,
			longitude: 31.31410667,
		},
		{
			latitude: 42.81631,
			longitude: 31.31414167,
		},
		{
			latitude: 42.81631833,
			longitude: 31.31411833,
		},
		{
			latitude: 42.81632833,
			longitude: 31.31410833,
		},
		{
			latitude: 42.81631333,
			longitude: 31.31415167,
		},
		{
			latitude: 42.81632833,
			longitude: 31.314105,
		},
		{
			latitude: 42.81632667,
			longitude: 31.314085,
		},
		{
			latitude: 42.81633167,
			longitude: 31.31408667,
		},
		{
			latitude: 42.81631667,
			longitude: 31.31412667,
		},
		{
			latitude: 42.81633,
			longitude: 31.31412167,
		},
		{
			latitude: 42.81680833,
			longitude: 31.314025,
		},
		{
			latitude: 42.81735333,
			longitude: 31.31389833,
		},
		{
			latitude: 42.81785667,
			longitude: 31.313755,
		},
		{
			latitude: 42.81844833,
			longitude: 31.31366167,
		},
		{
			latitude: 42.8189,
			longitude: 31.313565,
		},
		{
			latitude: 42.81944333,
			longitude: 31.31346833,
		},
		{
			latitude: 42.82001333,
			longitude: 31.31334833,
		},
		{
			latitude: 42.82052333,
			longitude: 31.3132,
		},
		{
			latitude: 42.82104667,
			longitude: 31.31309167,
		},
		{
			latitude: 42.82158333,
			longitude: 31.31299333,
		},
		{
			latitude: 42.82210667,
			longitude: 31.31288,
		},
		{
			latitude: 42.822645,
			longitude: 31.31274167,
		},
		{
			latitude: 42.82319333,
			longitude: 31.312625,
		},
		{
			latitude: 42.82371167,
			longitude: 31.31255333,
		},
		{
			latitude: 42.82425,
			longitude: 31.31242167,
		},
		{
			latitude: 42.82478833,
			longitude: 31.31230167,
		},
		{
			latitude: 42.82536,
			longitude: 31.31203333,
		},
		{
			latitude: 42.82591667,
			longitude: 31.31189,
		},
		{
			latitude: 42.82638833,
			longitude: 31.31195167,
		},
		{
			latitude: 42.82691833,
			longitude: 31.31177,
		},
		{
			latitude: 42.82745167,
			longitude: 31.31166167,
		},
		{
			latitude: 42.827865,
			longitude: 31.311555,
		},
		{
			latitude: 42.82787167,
			longitude: 31.31159167,
		},
		{
			latitude: 42.82787167,
			longitude: 31.31159,
		},
		{
			latitude: 42.82787333,
			longitude: 31.31154167,
		},
		{
			latitude: 42.827875,
			longitude: 31.31158667,
		},
		{
			latitude: 42.82786333,
			longitude: 31.311625,
		},
		{
			latitude: 42.82785833,
			longitude: 31.311575,
		},
		{
			latitude: 42.82786167,
			longitude: 31.3116,
		},
		{
			latitude: 42.82785,
			longitude: 31.31166333,
		},
		{
			latitude: 42.82784333,
			longitude: 31.31168167,
		},
		{
			latitude: 42.82785,
			longitude: 31.31165833,
		},
		{
			latitude: 42.82785333,
			longitude: 31.31165333,
		},
		{
			latitude: 42.82785833,
			longitude: 31.31164833,
		},
		{
			latitude: 42.82785333,
			longitude: 31.311635,
		},
		{
			latitude: 42.82784667,
			longitude: 31.31166833,
		},
		{
			latitude: 42.82785167,
			longitude: 31.311655,
		},
		{
			latitude: 42.82786167,
			longitude: 31.31161,
		},
		{
			latitude: 42.82785167,
			longitude: 31.311645,
		},
		{
			latitude: 42.82785333,
			longitude: 31.311665,
		},
		{
			latitude: 42.82786333,
			longitude: 31.31164833,
		},
		{
			latitude: 42.82784833,
			longitude: 31.31165333,
		},
		{
			latitude: 42.82786333,
			longitude: 31.31163167,
		},
		{
			latitude: 42.82784333,
			longitude: 31.31166333,
		},
		{
			latitude: 42.82786833,
			longitude: 31.31164167,
		},
		{
			latitude: 42.827855,
			longitude: 31.31163833,
		},
		{
			latitude: 42.82784833,
			longitude: 31.31167833,
		},
		{
			latitude: 42.82785167,
			longitude: 31.31164167,
		},
		{
			latitude: 42.827845,
			longitude: 31.311615,
		},
		{
			latitude: 42.82785167,
			longitude: 31.31165167,
		},
		{
			latitude: 42.82785,
			longitude: 31.31161833,
		},
		{
			latitude: 42.82784667,
			longitude: 31.311645,
		},
		{
			latitude: 42.82785,
			longitude: 31.311655,
		},
		{
			latitude: 42.82784333,
			longitude: 31.311655,
		},
		{
			latitude: 42.82785333,
			longitude: 31.31165,
		},
		{
			latitude: 42.82784833,
			longitude: 31.31163667,
		},
		{
			latitude: 42.82785167,
			longitude: 31.311645,
		},
		{
			latitude: 42.82783667,
			longitude: 31.31168,
		},
		{
			latitude: 42.827845,
			longitude: 31.31162,
		},
		{
			latitude: 42.82785667,
			longitude: 31.31164667,
		},
		{
			latitude: 42.82784667,
			longitude: 31.31169833,
		},
		{
			latitude: 42.82786167,
			longitude: 31.31164667,
		},
		{
			latitude: 42.82786333,
			longitude: 31.31162667,
		},
		{
			latitude: 42.827855,
			longitude: 31.311625,
		},
		{
			latitude: 42.82790667,
			longitude: 31.31168167,
		},
		{
			latitude: 42.83093,
			longitude: 31.30861667,
		},
		{
			latitude: 42.83509667,
			longitude: 31.300835,
		},
		{
			latitude: 42.83869,
			longitude: 31.29273333,
		},
		{
			latitude: 42.842905,
			longitude: 31.28363167,
		},
		{
			latitude: 42.847205,
			longitude: 31.274335,
		},
		{
			latitude: 42.84806,
			longitude: 31.272525,
		},
		{
			latitude: 42.85141,
			longitude: 31.26507333,
		},
		{
			latitude: 42.85549333,
			longitude: 31.25468167,
		},
		{
			latitude: 42.85922167,
			longitude: 31.24764333,
		},
		{
			latitude: 42.86147167,
			longitude: 31.24731,
		},
		{
			latitude: 42.86149667,
			longitude: 31.24734167,
		},
		{
			latitude: 42.861505,
			longitude: 31.24728333,
		},
		{
			latitude: 42.86149167,
			longitude: 31.24730667,
		},
		{
			latitude: 42.861605,
			longitude: 31.24816167,
		},
		{
			latitude: 42.86155,
			longitude: 31.24811833,
		},
		{
			latitude: 42.86156667,
			longitude: 31.24818333,
		},
		{
			latitude: 42.86156667,
			longitude: 31.24816,
		},
		{
			latitude: 42.86157667,
			longitude: 31.24817667,
		},
		{
			latitude: 42.861555,
			longitude: 31.24816333,
		},
		{
			latitude: 42.86157,
			longitude: 31.24816333,
		},
		{
			latitude: 42.86157833,
			longitude: 31.24817167,
		},
		{
			latitude: 42.86156167,
			longitude: 31.24816667,
		},
		{
			latitude: 42.86156833,
			longitude: 31.248165,
		},
		{
			latitude: 42.86155667,
			longitude: 31.24816167,
		},
		{
			latitude: 42.861565,
			longitude: 31.24814,
		},
		{
			latitude: 42.86156833,
			longitude: 31.24817333,
		},
		{
			latitude: 42.86156667,
			longitude: 31.24814167,
		},
		{
			latitude: 42.86157167,
			longitude: 31.248155,
		},
		{
			latitude: 42.86156,
			longitude: 31.24818,
		},
		{
			latitude: 42.86156167,
			longitude: 31.24811333,
		},
		{
			latitude: 42.86153167,
			longitude: 31.248305,
		},
		{
			latitude: 42.86152833,
			longitude: 31.24827,
		},
		{
			latitude: 42.861545,
			longitude: 31.24825833,
		},
		{
			latitude: 42.86153,
			longitude: 31.24823667,
		},
		{
			latitude: 42.86175333,
			longitude: 31.24807667,
		},
		{
			latitude: 42.86215667,
			longitude: 31.247735,
		},
		{
			latitude: 42.86260667,
			longitude: 31.24732833,
		},
		{
			latitude: 42.86258833,
			longitude: 31.247345,
		},
		{
			latitude: 42.86259667,
			longitude: 31.24731833,
		},
		{
			latitude: 42.86259833,
			longitude: 31.24734167,
		},
		{
			latitude: 42.86259167,
			longitude: 31.24732833,
		},
		{
			latitude: 42.86258167,
			longitude: 31.24731,
		},
		{
			latitude: 42.86258167,
			longitude: 31.24732667,
		},
		{
			latitude: 42.86259667,
			longitude: 31.247325,
		},
		{
			latitude: 42.86259167,
			longitude: 31.24732333,
		},
		{
			latitude: 42.86273,
			longitude: 31.247255,
		},
		{
			latitude: 42.862885,
			longitude: 31.24715167,
		},
		{
			latitude: 42.86286,
			longitude: 31.24718333,
		},
		{
			latitude: 42.862935,
			longitude: 31.24707167,
		},
		{
			latitude: 42.86307667,
			longitude: 31.24664667,
		},
		{
			latitude: 42.863075,
			longitude: 31.246515,
		},
		{
			latitude: 42.86308,
			longitude: 31.24653667,
		},
		{
			latitude: 42.86306,
			longitude: 31.24654,
		},
		{
			latitude: 42.863075,
			longitude: 31.24651667,
		},
		{
			latitude: 42.86308667,
			longitude: 31.24652,
		},
		{
			latitude: 42.86306167,
			longitude: 31.246565,
		},
		{
			latitude: 42.86306,
			longitude: 31.246795,
		},
		{
			latitude: 42.86304833,
			longitude: 31.24680833,
		},
		{
			latitude: 42.86303833,
			longitude: 31.24682833,
		},
		{
			latitude: 42.86304667,
			longitude: 31.24679167,
		},
		{
			latitude: 42.86304833,
			longitude: 31.24678,
		},
		{
			latitude: 42.863055,
			longitude: 31.24678833,
		},
		{
			latitude: 42.86304333,
			longitude: 31.24679,
		},
		{
			latitude: 42.86304667,
			longitude: 31.246795,
		},
		{
			latitude: 42.86306333,
			longitude: 31.24679167,
		},
		{
			latitude: 42.86306,
			longitude: 31.24680833,
		},
		{
			latitude: 42.86306333,
			longitude: 31.24679,
		},
		{
			latitude: 42.863055,
			longitude: 31.24676833,
		},
		{
			latitude: 42.863055,
			longitude: 31.24680333,
		},
		{
			latitude: 42.86304667,
			longitude: 31.24679,
		},
		{
			latitude: 42.86306,
			longitude: 31.24678333,
		},
		{
			latitude: 42.86304333,
			longitude: 31.24678333,
		},
		{
			latitude: 42.86306,
			longitude: 31.24677833,
		},
		{
			latitude: 42.863045,
			longitude: 31.24680667,
		},
		{
			latitude: 42.86305,
			longitude: 31.24682,
		},
		{
			latitude: 42.86303333,
			longitude: 31.24677,
		},
		{
			latitude: 42.86304333,
			longitude: 31.24683167,
		},
		{
			latitude: 42.86305333,
			longitude: 31.24680333,
		},
		{
			latitude: 42.86303833,
			longitude: 31.24682833,
		},
		{
			latitude: 42.86259333,
			longitude: 31.24704667,
		},
		{
			latitude: 42.86211,
			longitude: 31.24730333,
		},
		{
			latitude: 42.86167667,
			longitude: 31.24753167,
		},
		{
			latitude: 42.86166667,
			longitude: 31.24755333,
		},
		{
			latitude: 42.86168833,
			longitude: 31.24753333,
		},
		{
			latitude: 42.861675,
			longitude: 31.24757167,
		},
		{
			latitude: 42.86166667,
			longitude: 31.24757167,
		},
		{
			latitude: 42.86166167,
			longitude: 31.247535,
		},
		{
			latitude: 42.86168,
			longitude: 31.247555,
		},
		{
			latitude: 42.86167833,
			longitude: 31.24753167,
		},
		{
			latitude: 42.86167333,
			longitude: 31.24752667,
		},
		{
			latitude: 42.86165833,
			longitude: 31.24755,
		},
		{
			latitude: 42.86165167,
			longitude: 31.24755667,
		},
		{
			latitude: 42.861675,
			longitude: 31.24755833,
		},
		{
			latitude: 42.86167667,
			longitude: 31.24755333,
		},
		{
			latitude: 42.86166167,
			longitude: 31.24755333,
		},
		{
			latitude: 42.86166,
			longitude: 31.24755167,
		},
		{
			latitude: 42.861665,
			longitude: 31.247515,
		},
		{
			latitude: 42.86167167,
			longitude: 31.247565,
		},
		{
			latitude: 42.86166333,
			longitude: 31.24758667,
		},
		{
			latitude: 42.86166833,
			longitude: 31.24755333,
		},
		{
			latitude: 42.861675,
			longitude: 31.24753667,
		},
		{
			latitude: 42.86167333,
			longitude: 31.24755,
		},
		{
			latitude: 42.86167,
			longitude: 31.24755833,
		},
		{
			latitude: 42.86167667,
			longitude: 31.247545,
		},
		{
			latitude: 42.86166833,
			longitude: 31.24754167,
		},
		{
			latitude: 42.86168167,
			longitude: 31.247565,
		},
		{
			latitude: 42.861675,
			longitude: 31.24757167,
		},
		{
			latitude: 42.86167333,
			longitude: 31.24756167,
		},
		{
			latitude: 42.86167667,
			longitude: 31.247535,
		},
		{
			latitude: 42.86167,
			longitude: 31.247575,
		},
		{
			latitude: 42.86167,
			longitude: 31.24755333,
		},
		{
			latitude: 42.86167,
			longitude: 31.24753833,
		},
		{
			latitude: 42.86167667,
			longitude: 31.24754833,
		},
		{
			latitude: 42.86202,
			longitude: 31.24729833,
		},
		{
			latitude: 42.86236333,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86267167,
			longitude: 31.24680667,
		},
		{
			latitude: 42.862655,
			longitude: 31.24681667,
		},
		{
			latitude: 42.86268333,
			longitude: 31.24685167,
		},
		{
			latitude: 42.86267167,
			longitude: 31.24684833,
		},
		{
			latitude: 42.862685,
			longitude: 31.24684667,
		},
		{
			latitude: 42.86266833,
			longitude: 31.24685833,
		},
		{
			latitude: 42.86268333,
			longitude: 31.246835,
		},
		{
			latitude: 42.862675,
			longitude: 31.24685,
		},
		{
			latitude: 42.862685,
			longitude: 31.24683,
		},
		{
			latitude: 42.86268333,
			longitude: 31.24684167,
		},
		{
			latitude: 42.862685,
			longitude: 31.24683333,
		},
		{
			latitude: 42.86271167,
			longitude: 31.246835,
		},
		{
			latitude: 42.86302667,
			longitude: 31.24676,
		},
		{
			latitude: 42.86305667,
			longitude: 31.24680167,
		},
		{
			latitude: 42.86305333,
			longitude: 31.24680333,
		},
		{
			latitude: 42.86304333,
			longitude: 31.24678167,
		},
		{
			latitude: 42.86305667,
			longitude: 31.24675667,
		},
		{
			latitude: 42.86306167,
			longitude: 31.24680833,
		},
		{
			latitude: 42.86305833,
			longitude: 31.24677833,
		},
		{
			latitude: 42.86306333,
			longitude: 31.246775,
		},
		{
			latitude: 42.86307,
			longitude: 31.24678,
		},
		{
			latitude: 42.86304833,
			longitude: 31.24680833,
		},
		{
			latitude: 42.86304333,
			longitude: 31.246775,
		},
		{
			latitude: 42.86306167,
			longitude: 31.24677667,
		},
		{
			latitude: 42.86305,
			longitude: 31.24679667,
		},
		{
			latitude: 42.86305333,
			longitude: 31.24681167,
		},
		{
			latitude: 42.86304167,
			longitude: 31.24676667,
		},
		{
			latitude: 42.86304,
			longitude: 31.24675,
		},
		{
			latitude: 42.86304333,
			longitude: 31.246795,
		},
		{
			latitude: 42.86305333,
			longitude: 31.24677833,
		},
		{
			latitude: 42.86305167,
			longitude: 31.24677667,
		},
		{
			latitude: 42.86305,
			longitude: 31.24677667,
		},
		{
			latitude: 42.86305167,
			longitude: 31.24677,
		},
		{
			latitude: 42.86306167,
			longitude: 31.24679,
		},
		{
			latitude: 42.86306167,
			longitude: 31.24679167,
		},
		{
			latitude: 42.863045,
			longitude: 31.24679333,
		},
		{
			latitude: 42.86305333,
			longitude: 31.24677833,
		},
		{
			latitude: 42.86306,
			longitude: 31.24678833,
		},
		{
			latitude: 42.863045,
			longitude: 31.246805,
		},
		{
			latitude: 42.863055,
			longitude: 31.246795,
		},
		{
			latitude: 42.86305,
			longitude: 31.246795,
		},
		{
			latitude: 42.863055,
			longitude: 31.24678,
		},
		{
			latitude: 42.86305833,
			longitude: 31.24679167,
		},
		{
			latitude: 42.86306333,
			longitude: 31.24679,
		},
		{
			latitude: 42.86305667,
			longitude: 31.24679,
		},
		{
			latitude: 42.86305667,
			longitude: 31.24678167,
		},
		{
			latitude: 42.86304667,
			longitude: 31.24679833,
		},
		{
			latitude: 42.863055,
			longitude: 31.2468,
		},
		{
			latitude: 42.86305167,
			longitude: 31.24679,
		},
		{
			latitude: 42.86305167,
			longitude: 31.246775,
		},
		{
			latitude: 42.86305667,
			longitude: 31.24678333,
		},
		{
			latitude: 42.86303667,
			longitude: 31.2468,
		},
		{
			latitude: 42.86305833,
			longitude: 31.24678,
		},
		{
			latitude: 42.86305167,
			longitude: 31.24681167,
		},
		{
			latitude: 42.86305333,
			longitude: 31.24679,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24690167,
		},
		{
			latitude: 42.86286833,
			longitude: 31.24696833,
		},
		{
			latitude: 42.86286667,
			longitude: 31.24695167,
		},
		{
			latitude: 42.86273167,
			longitude: 31.24707833,
		},
		{
			latitude: 42.86240667,
			longitude: 31.24742333,
		},
		{
			latitude: 42.86214,
			longitude: 31.24766833,
		},
		{
			latitude: 42.86212667,
			longitude: 31.24767167,
		},
		{
			latitude: 42.86211,
			longitude: 31.24763833,
		},
		{
			latitude: 42.86213333,
			longitude: 31.24766833,
		},
		{
			latitude: 42.86212667,
			longitude: 31.24767833,
		},
		{
			latitude: 42.862135,
			longitude: 31.24765667,
		},
		{
			latitude: 42.86213333,
			longitude: 31.24766333,
		},
		{
			latitude: 42.86212833,
			longitude: 31.24767833,
		},
		{
			latitude: 42.86213833,
			longitude: 31.24767333,
		},
		{
			latitude: 42.86212667,
			longitude: 31.24765333,
		},
		{
			latitude: 42.862135,
			longitude: 31.24765333,
		},
		{
			latitude: 42.86214,
			longitude: 31.24766167,
		},
		{
			latitude: 42.86212833,
			longitude: 31.24763667,
		},
		{
			latitude: 42.86214167,
			longitude: 31.247685,
		},
		{
			latitude: 42.86213167,
			longitude: 31.24768167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24753167,
		},
		{
			latitude: 42.86216,
			longitude: 31.247515,
		},
		{
			latitude: 42.86214167,
			longitude: 31.247555,
		},
		{
			latitude: 42.862125,
			longitude: 31.24751333,
		},
		{
			latitude: 42.862175,
			longitude: 31.247555,
		},
		{
			latitude: 42.862165,
			longitude: 31.24755,
		},
		{
			latitude: 42.86216667,
			longitude: 31.24755,
		},
		{
			latitude: 42.86215833,
			longitude: 31.247555,
		},
		{
			latitude: 42.862145,
			longitude: 31.247535,
		},
		{
			latitude: 42.86216333,
			longitude: 31.24754833,
		},
		{
			latitude: 42.86216,
			longitude: 31.247555,
		},
		{
			latitude: 42.86216833,
			longitude: 31.247555,
		},
		{
			latitude: 42.862155,
			longitude: 31.24753,
		},
		{
			latitude: 42.86216667,
			longitude: 31.24754,
		},
		{
			latitude: 42.86215333,
			longitude: 31.24753833,
		},
		{
			latitude: 42.862165,
			longitude: 31.24753333,
		},
		{
			latitude: 42.862165,
			longitude: 31.247565,
		},
		{
			latitude: 42.86215,
			longitude: 31.24754667,
		},
		{
			latitude: 42.86216833,
			longitude: 31.24754,
		},
		{
			latitude: 42.86216333,
			longitude: 31.24755833,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24754167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24754,
		},
		{
			latitude: 42.86216,
			longitude: 31.24755333,
		},
		{
			latitude: 42.862155,
			longitude: 31.24755667,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24755667,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24752,
		},
		{
			latitude: 42.86216333,
			longitude: 31.24756167,
		},
		{
			latitude: 42.862155,
			longitude: 31.247555,
		},
		{
			latitude: 42.862165,
			longitude: 31.24754333,
		},
		{
			latitude: 42.86216167,
			longitude: 31.24754667,
		},
		{
			latitude: 42.86214,
			longitude: 31.247555,
		},
		{
			latitude: 42.862165,
			longitude: 31.247545,
		},
		{
			latitude: 42.862165,
			longitude: 31.24755333,
		},
		{
			latitude: 42.86216167,
			longitude: 31.24754167,
		},
		{
			latitude: 42.862265,
			longitude: 31.24737833,
		},
		{
			latitude: 42.86244667,
			longitude: 31.24708,
		},
		{
			latitude: 42.86246167,
			longitude: 31.24708333,
		},
		{
			latitude: 42.86244833,
			longitude: 31.24709667,
		},
		{
			latitude: 42.86245333,
			longitude: 31.24709167,
		},
		{
			latitude: 42.86244,
			longitude: 31.247045,
		},
		{
			latitude: 42.86249333,
			longitude: 31.24706833,
		},
		{
			latitude: 42.86263667,
			longitude: 31.24678833,
		},
		{
			latitude: 42.86264,
			longitude: 31.246815,
		},
		{
			latitude: 42.86262167,
			longitude: 31.24686667,
		},
		{
			latitude: 42.862575,
			longitude: 31.24697333,
		},
		{
			latitude: 42.86258,
			longitude: 31.24696833,
		},
		{
			latitude: 42.86258667,
			longitude: 31.24699,
		},
		{
			latitude: 42.86258333,
			longitude: 31.24698,
		},
		{
			latitude: 42.86259167,
			longitude: 31.24698333,
		},
		{
			latitude: 42.86258667,
			longitude: 31.24696667,
		},
		{
			latitude: 42.86258333,
			longitude: 31.246985,
		},
		{
			latitude: 42.86258333,
			longitude: 31.24696667,
		},
		{
			latitude: 42.86258167,
			longitude: 31.24696833,
		},
		{
			latitude: 42.86258333,
			longitude: 31.24696333,
		},
		{
			latitude: 42.86259667,
			longitude: 31.24697333,
		},
		{
			latitude: 42.86259333,
			longitude: 31.24697667,
		},
		{
			latitude: 42.86258333,
			longitude: 31.24696,
		},
		{
			latitude: 42.862595,
			longitude: 31.24698333,
		},
		{
			latitude: 42.86258167,
			longitude: 31.24698,
		},
		{
			latitude: 42.86258833,
			longitude: 31.24696833,
		},
		{
			latitude: 42.86291333,
			longitude: 31.24681333,
		},
		{
			latitude: 42.86295667,
			longitude: 31.24681833,
		},
		{
			latitude: 42.862945,
			longitude: 31.24685333,
		},
		{
			latitude: 42.86293833,
			longitude: 31.246835,
		},
		{
			latitude: 42.86294,
			longitude: 31.246855,
		},
		{
			latitude: 42.86294167,
			longitude: 31.246855,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24686,
		},
		{
			latitude: 42.86294167,
			longitude: 31.24683333,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24685667,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24686167,
		},
		{
			latitude: 42.862945,
			longitude: 31.246855,
		},
		{
			latitude: 42.86293667,
			longitude: 31.24687,
		},
		{
			latitude: 42.86294167,
			longitude: 31.24686,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24688167,
		},
		{
			latitude: 42.86288,
			longitude: 31.24685,
		},
		{
			latitude: 42.86276667,
			longitude: 31.24685167,
		},
		{
			latitude: 42.86275,
			longitude: 31.24688667,
		},
		{
			latitude: 42.86276333,
			longitude: 31.24685167,
		},
		{
			latitude: 42.86276,
			longitude: 31.24685667,
		},
		{
			latitude: 42.86275667,
			longitude: 31.24687,
		},
		{
			latitude: 42.86275667,
			longitude: 31.24685833,
		},
		{
			latitude: 42.86276167,
			longitude: 31.24685333,
		},
		{
			latitude: 42.86275167,
			longitude: 31.24688,
		},
		{
			latitude: 42.86275833,
			longitude: 31.24687,
		},
		{
			latitude: 42.86275667,
			longitude: 31.24685833,
		},
		{
			latitude: 42.86275833,
			longitude: 31.24684667,
		},
		{
			latitude: 42.86276333,
			longitude: 31.24685167,
		},
		{
			latitude: 42.86275667,
			longitude: 31.246845,
		},
		{
			latitude: 42.86275833,
			longitude: 31.246865,
		},
		{
			latitude: 42.862795,
			longitude: 31.247245,
		},
		{
			latitude: 42.86237167,
			longitude: 31.24770333,
		},
		{
			latitude: 42.86236167,
			longitude: 31.2477,
		},
		{
			latitude: 42.86236,
			longitude: 31.247695,
		},
		{
			latitude: 42.86236667,
			longitude: 31.24769333,
		},
		{
			latitude: 42.86235667,
			longitude: 31.24770667,
		},
		{
			latitude: 42.862365,
			longitude: 31.24770333,
		},
		{
			latitude: 42.86235833,
			longitude: 31.24770333,
		},
		{
			latitude: 42.86236833,
			longitude: 31.24770167,
		},
		{
			latitude: 42.86236667,
			longitude: 31.24764667,
		},
		{
			latitude: 42.862425,
			longitude: 31.24723,
		},
		{
			latitude: 42.86242333,
			longitude: 31.247205,
		},
		{
			latitude: 42.86243,
			longitude: 31.24719833,
		},
		{
			latitude: 42.862425,
			longitude: 31.24721167,
		},
		{
			latitude: 42.86243167,
			longitude: 31.24722333,
		},
		{
			latitude: 42.86242,
			longitude: 31.24722333,
		},
		{
			latitude: 42.86243333,
			longitude: 31.24722,
		},
		{
			latitude: 42.86242167,
			longitude: 31.24721333,
		},
		{
			latitude: 42.86252333,
			longitude: 31.24711,
		},
		{
			latitude: 42.86272833,
			longitude: 31.24686333,
		},
		{
			latitude: 42.86280667,
			longitude: 31.24677833,
		},
		{
			latitude: 42.86279833,
			longitude: 31.24678167,
		},
		{
			latitude: 42.86280833,
			longitude: 31.246785,
		},
		{
			latitude: 42.86280667,
			longitude: 31.24678,
		},
		{
			latitude: 42.86280333,
			longitude: 31.24678833,
		},
		{
			latitude: 42.86282667,
			longitude: 31.24677833,
		},
		{
			latitude: 42.862825,
			longitude: 31.24677833,
		},
		{
			latitude: 42.862815,
			longitude: 31.246785,
		},
		{
			latitude: 42.86280833,
			longitude: 31.24678833,
		},
		{
			latitude: 42.86281,
			longitude: 31.24678,
		},
		{
			latitude: 42.86281333,
			longitude: 31.24677833,
		},
		{
			latitude: 42.86281833,
			longitude: 31.24676167,
		},
		{
			latitude: 42.86283167,
			longitude: 31.24674833,
		},
		{
			latitude: 42.86286833,
			longitude: 31.24671667,
		},
		{
			latitude: 42.86288167,
			longitude: 31.24669833,
		},
		{
			latitude: 42.86288,
			longitude: 31.24670667,
		},
		{
			latitude: 42.86289,
			longitude: 31.24671667,
		},
		{
			latitude: 42.862885,
			longitude: 31.246705,
		},
		{
			latitude: 42.86288333,
			longitude: 31.24672167,
		},
		{
			latitude: 42.86288667,
			longitude: 31.24672333,
		},
		{
			latitude: 42.86288667,
			longitude: 31.24671833,
		},
		{
			latitude: 42.86288167,
			longitude: 31.246715,
		},
		{
			latitude: 42.86289333,
			longitude: 31.24668833,
		},
		{
			latitude: 42.862905,
			longitude: 31.24656167,
		},
		{
			latitude: 42.86295,
			longitude: 31.24647833,
		},
		{
			latitude: 42.86294833,
			longitude: 31.24649333,
		},
		{
			latitude: 42.86294,
			longitude: 31.2465,
		},
		{
			latitude: 42.862945,
			longitude: 31.246485,
		},
		{
			latitude: 42.86293,
			longitude: 31.24649,
		},
		{
			latitude: 42.86295333,
			longitude: 31.24649167,
		},
		{
			latitude: 42.86295,
			longitude: 31.246505,
		},
		{
			latitude: 42.862945,
			longitude: 31.24648833,
		},
		{
			latitude: 42.862955,
			longitude: 31.24649167,
		},
		{
			latitude: 42.86295,
			longitude: 31.24649,
		},
		{
			latitude: 42.86295167,
			longitude: 31.24649,
		},
		{
			latitude: 42.862945,
			longitude: 31.24648833,
		},
		{
			latitude: 42.86295333,
			longitude: 31.24648833,
		},
		{
			latitude: 42.86295333,
			longitude: 31.24646667,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24648667,
		},
		{
			latitude: 42.86295167,
			longitude: 31.24648,
		},
		{
			latitude: 42.862945,
			longitude: 31.24649833,
		},
		{
			latitude: 42.86296167,
			longitude: 31.24649,
		},
		{
			latitude: 42.86295,
			longitude: 31.24648167,
		},
		{
			latitude: 42.862965,
			longitude: 31.24651,
		},
		{
			latitude: 42.86296,
			longitude: 31.246495,
		},
		{
			latitude: 42.862885,
			longitude: 31.24642333,
		},
		{
			latitude: 42.86288,
			longitude: 31.24643333,
		},
		{
			latitude: 42.86286833,
			longitude: 31.24644833,
		},
		{
			latitude: 42.86288,
			longitude: 31.24644,
		},
		{
			latitude: 42.86289333,
			longitude: 31.24643667,
		},
		{
			latitude: 42.86294333,
			longitude: 31.2462,
		},
		{
			latitude: 42.86295167,
			longitude: 31.246255,
		},
		{
			latitude: 42.862935,
			longitude: 31.24626,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24625,
		},
		{
			latitude: 42.86293167,
			longitude: 31.24624667,
		},
		{
			latitude: 42.86293167,
			longitude: 31.24625833,
		},
		{
			latitude: 42.86293,
			longitude: 31.24623833,
		},
		{
			latitude: 42.86294667,
			longitude: 31.24625,
		},
		{
			latitude: 42.86295167,
			longitude: 31.24625667,
		},
		{
			latitude: 42.86291667,
			longitude: 31.246265,
		},
		{
			latitude: 42.86294667,
			longitude: 31.24625,
		},
		{
			latitude: 42.86294833,
			longitude: 31.24624167,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24626333,
		},
		{
			latitude: 42.86293167,
			longitude: 31.246245,
		},
		{
			latitude: 42.86294167,
			longitude: 31.24624167,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24624167,
		},
		{
			latitude: 42.862935,
			longitude: 31.246245,
		},
		{
			latitude: 42.86293,
			longitude: 31.246265,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24625833,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24624833,
		},
		{
			latitude: 42.862945,
			longitude: 31.246245,
		},
		{
			latitude: 42.862935,
			longitude: 31.246255,
		},
		{
			latitude: 42.862945,
			longitude: 31.24626167,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24624333,
		},
		{
			latitude: 42.862925,
			longitude: 31.246235,
		},
		{
			latitude: 42.86294833,
			longitude: 31.24625667,
		},
		{
			latitude: 42.862925,
			longitude: 31.24626,
		},
		{
			latitude: 42.86293167,
			longitude: 31.24626,
		},
		{
			latitude: 42.86293667,
			longitude: 31.246255,
		},
		{
			latitude: 42.86293667,
			longitude: 31.24624833,
		},
		{
			latitude: 42.86294667,
			longitude: 31.24623,
		},
		{
			latitude: 42.86293167,
			longitude: 31.24626667,
		},
		{
			latitude: 42.862945,
			longitude: 31.246275,
		},
		{
			latitude: 42.86292,
			longitude: 31.24622,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24627667,
		},
		{
			latitude: 42.862935,
			longitude: 31.24626333,
		},
		{
			latitude: 42.86292,
			longitude: 31.24626667,
		},
		{
			latitude: 42.86293333,
			longitude: 31.246235,
		},
		{
			latitude: 42.86294167,
			longitude: 31.24625833,
		},
		{
			latitude: 42.86293167,
			longitude: 31.24622667,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24626167,
		},
		{
			latitude: 42.862945,
			longitude: 31.24626,
		},
		{
			latitude: 42.86293833,
			longitude: 31.246245,
		},
		{
			latitude: 42.86294167,
			longitude: 31.24623167,
		},
		{
			latitude: 42.86295333,
			longitude: 31.24624667,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24624833,
		},
		{
			latitude: 42.86294167,
			longitude: 31.24626167,
		},
		{
			latitude: 42.86295,
			longitude: 31.24624,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24624833,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24625333,
		},
		{
			latitude: 42.862945,
			longitude: 31.246245,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24624167,
		},
		{
			latitude: 42.86294,
			longitude: 31.246255,
		},
		{
			latitude: 42.862935,
			longitude: 31.24625167,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24627667,
		},
		{
			latitude: 42.862935,
			longitude: 31.24619167,
		},
		{
			latitude: 42.86294667,
			longitude: 31.24627167,
		},
		{
			latitude: 42.86294667,
			longitude: 31.24626667,
		},
		{
			latitude: 42.86295333,
			longitude: 31.24626333,
		},
		{
			latitude: 42.86293667,
			longitude: 31.24625833,
		},
		{
			latitude: 42.86294333,
			longitude: 31.246245,
		},
		{
			latitude: 42.86293667,
			longitude: 31.24623667,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24622333,
		},
		{
			latitude: 42.86294833,
			longitude: 31.24625833,
		},
		{
			latitude: 42.86294,
			longitude: 31.24626833,
		},
		{
			latitude: 42.86294167,
			longitude: 31.24621667,
		},
		{
			latitude: 42.86294667,
			longitude: 31.246255,
		},
		{
			latitude: 42.86294333,
			longitude: 31.246245,
		},
		{
			latitude: 42.86294167,
			longitude: 31.24626167,
		},
		{
			latitude: 42.86294167,
			longitude: 31.246245,
		},
		{
			latitude: 42.86294,
			longitude: 31.24626,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24622833,
		},
		{
			latitude: 42.86293667,
			longitude: 31.24625,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24624167,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24623833,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24625333,
		},
		{
			latitude: 42.86294333,
			longitude: 31.246225,
		},
		{
			latitude: 42.86294,
			longitude: 31.24624,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24626167,
		},
		{
			latitude: 42.862945,
			longitude: 31.24619667,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24627167,
		},
		{
			latitude: 42.86295167,
			longitude: 31.24624333,
		},
		{
			latitude: 42.86293667,
			longitude: 31.246245,
		},
		{
			latitude: 42.86295167,
			longitude: 31.24624,
		},
		{
			latitude: 42.86295833,
			longitude: 31.246235,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24626167,
		},
		{
			latitude: 42.86294333,
			longitude: 31.246255,
		},
		{
			latitude: 42.86294,
			longitude: 31.24624833,
		},
		{
			latitude: 42.86295167,
			longitude: 31.24623833,
		},
		{
			latitude: 42.86293667,
			longitude: 31.24626,
		},
		{
			latitude: 42.86295167,
			longitude: 31.24623333,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24624333,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24622833,
		},
		{
			latitude: 42.86293,
			longitude: 31.24621,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24627333,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24620333,
		},
		{
			latitude: 42.862945,
			longitude: 31.24626,
		},
		{
			latitude: 42.86294,
			longitude: 31.24628333,
		},
		{
			latitude: 42.86295,
			longitude: 31.24625667,
		},
		{
			latitude: 42.86293,
			longitude: 31.24624667,
		},
		{
			latitude: 42.86294833,
			longitude: 31.24623167,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24622667,
		},
		{
			latitude: 42.86295167,
			longitude: 31.24626,
		},
		{
			latitude: 42.86293,
			longitude: 31.24622667,
		},
		{
			latitude: 42.86293667,
			longitude: 31.24626,
		},
		{
			latitude: 42.86294667,
			longitude: 31.24625667,
		},
		{
			latitude: 42.86293,
			longitude: 31.24623333,
		},
		{
			latitude: 42.86293833,
			longitude: 31.24621167,
		},
		{
			latitude: 42.862945,
			longitude: 31.246265,
		},
		{
			latitude: 42.86294333,
			longitude: 31.24627333,
		},
		{
			latitude: 42.86293667,
			longitude: 31.24625333,
		},
		{
			latitude: 42.86288,
			longitude: 31.24645833,
		},
		{
			latitude: 42.86288,
			longitude: 31.24645,
		},
		{
			latitude: 42.86289,
			longitude: 31.24643333,
		},
		{
			latitude: 42.86288167,
			longitude: 31.24645,
		},
		{
			latitude: 42.862875,
			longitude: 31.246435,
		},
		{
			latitude: 42.86288667,
			longitude: 31.24646,
		},
		{
			latitude: 42.86289333,
			longitude: 31.24643,
		},
		{
			latitude: 42.86287,
			longitude: 31.246435,
		},
		{
			latitude: 42.86289,
			longitude: 31.24642833,
		},
		{
			latitude: 42.86287833,
			longitude: 31.24644833,
		},
		{
			latitude: 42.86288167,
			longitude: 31.246435,
		},
		{
			latitude: 42.86287667,
			longitude: 31.24641833,
		},
		{
			latitude: 42.86288333,
			longitude: 31.24643167,
		},
		{
			latitude: 42.86288833,
			longitude: 31.24643833,
		},
		{
			latitude: 42.86287333,
			longitude: 31.24645,
		},
		{
			latitude: 42.86289667,
			longitude: 31.24645167,
		},
		{
			latitude: 42.86289667,
			longitude: 31.24642167,
		},
		{
			latitude: 42.86289333,
			longitude: 31.24641667,
		},
		{
			latitude: 42.86288667,
			longitude: 31.24645,
		},
		{
			latitude: 42.86288667,
			longitude: 31.24645333,
		},
		{
			latitude: 42.86289333,
			longitude: 31.246445,
		},
		{
			latitude: 42.86288833,
			longitude: 31.24642667,
		},
		{
			latitude: 42.86288833,
			longitude: 31.24643333,
		},
		{
			latitude: 42.862875,
			longitude: 31.24641333,
		},
		{
			latitude: 42.862895,
			longitude: 31.246435,
		},
		{
			latitude: 42.86289333,
			longitude: 31.246415,
		},
		{
			latitude: 42.86289667,
			longitude: 31.24643,
		},
		{
			latitude: 42.86289167,
			longitude: 31.24645,
		},
		{
			latitude: 42.86288833,
			longitude: 31.24641333,
		},
		{
			latitude: 42.86289833,
			longitude: 31.24642833,
		},
		{
			latitude: 42.86287,
			longitude: 31.24645,
		},
		{
			latitude: 42.86289167,
			longitude: 31.24642667,
		},
		{
			latitude: 42.86289333,
			longitude: 31.24643,
		},
		{
			latitude: 42.862905,
			longitude: 31.24641,
		},
		{
			latitude: 42.862895,
			longitude: 31.246415,
		},
		{
			latitude: 42.86288833,
			longitude: 31.24642833,
		},
		{
			latitude: 42.86288833,
			longitude: 31.246405,
		},
		{
			latitude: 42.86289333,
			longitude: 31.24646,
		},
		{
			latitude: 42.86289,
			longitude: 31.246425,
		},
		{
			latitude: 42.86288667,
			longitude: 31.24643167,
		},
		{
			latitude: 42.86289167,
			longitude: 31.24643167,
		},
		{
			latitude: 42.86288833,
			longitude: 31.24643833,
		},
		{
			latitude: 42.86289,
			longitude: 31.24643667,
		},
		{
			latitude: 42.86289167,
			longitude: 31.24641167,
		},
		{
			latitude: 42.86288333,
			longitude: 31.24642,
		},
		{
			latitude: 42.86289667,
			longitude: 31.246425,
		},
		{
			latitude: 42.8629,
			longitude: 31.24641167,
		},
		{
			latitude: 42.86289833,
			longitude: 31.24642167,
		},
		{
			latitude: 42.862895,
			longitude: 31.24643667,
		},
		{
			latitude: 42.86289167,
			longitude: 31.24641833,
		},
		{
			latitude: 42.862895,
			longitude: 31.24643167,
		},
		{
			latitude: 42.86288833,
			longitude: 31.24641333,
		},
		{
			latitude: 42.862895,
			longitude: 31.24642,
		},
		{
			latitude: 42.86289667,
			longitude: 31.24641833,
		},
		{
			latitude: 42.86289,
			longitude: 31.24642,
		},
		{
			latitude: 42.86279833,
			longitude: 31.24642,
		},
		{
			latitude: 42.862795,
			longitude: 31.246395,
		},
		{
			latitude: 42.86280833,
			longitude: 31.24641333,
		},
		{
			latitude: 42.86280333,
			longitude: 31.24641667,
		},
		{
			latitude: 42.86279333,
			longitude: 31.24643333,
		},
		{
			latitude: 42.8628,
			longitude: 31.24643167,
		},
		{
			latitude: 42.8628,
			longitude: 31.24643833,
		},
		{
			latitude: 42.8628,
			longitude: 31.246405,
		},
		{
			latitude: 42.86281333,
			longitude: 31.24642833,
		},
		{
			latitude: 42.862805,
			longitude: 31.24642333,
		},
		{
			latitude: 42.86280167,
			longitude: 31.246425,
		},
		{
			latitude: 42.86280167,
			longitude: 31.24642167,
		},
		{
			latitude: 42.86278833,
			longitude: 31.246425,
		},
		{
			latitude: 42.86280667,
			longitude: 31.24642,
		},
		{
			latitude: 42.86273333,
			longitude: 31.24697333,
		},
		{
			latitude: 42.86270167,
			longitude: 31.247175,
		},
		{
			latitude: 42.86283333,
			longitude: 31.24704,
		},
		{
			latitude: 42.86292833,
			longitude: 31.246935,
		},
		{
			latitude: 42.86294,
			longitude: 31.24695667,
		},
		{
			latitude: 42.862935,
			longitude: 31.246955,
		},
		{
			latitude: 42.86293333,
			longitude: 31.24692667,
		},
		{
			latitude: 42.862825,
			longitude: 31.24705333,
		},
		{
			latitude: 42.86274,
			longitude: 31.24716333,
		},
		{
			latitude: 42.862745,
			longitude: 31.24715167,
		},
		{
			latitude: 42.862735,
			longitude: 31.24718167,
		},
		{
			latitude: 42.86272667,
			longitude: 31.24716833,
		},
		{
			latitude: 42.86271667,
			longitude: 31.24716167,
		},
		{
			latitude: 42.862345,
			longitude: 31.247355,
		},
		{
			latitude: 42.86188167,
			longitude: 31.24761167,
		},
		{
			latitude: 42.86186833,
			longitude: 31.24759333,
		},
		{
			latitude: 42.86187833,
			longitude: 31.247605,
		},
		{
			latitude: 42.86188167,
			longitude: 31.2476,
		},
		{
			latitude: 42.86188,
			longitude: 31.24759667,
		},
		{
			latitude: 42.86188167,
			longitude: 31.24761333,
		},
		{
			latitude: 42.86187167,
			longitude: 31.24763667,
		},
		{
			latitude: 42.861865,
			longitude: 31.24764,
		},
		{
			latitude: 42.86187167,
			longitude: 31.24760333,
		},
		{
			latitude: 42.86187833,
			longitude: 31.247595,
		},
		{
			latitude: 42.86188333,
			longitude: 31.24760833,
		},
		{
			latitude: 42.86188,
			longitude: 31.24761333,
		},
		{
			latitude: 42.86187833,
			longitude: 31.24759333,
		},
		{
			latitude: 42.86188,
			longitude: 31.24761167,
		},
		{
			latitude: 42.861875,
			longitude: 31.24761833,
		},
		{
			latitude: 42.86188,
			longitude: 31.24760667,
		},
		{
			latitude: 42.861885,
			longitude: 31.24761667,
		},
		{
			latitude: 42.86188167,
			longitude: 31.24760833,
		},
		{
			latitude: 42.861875,
			longitude: 31.24761667,
		},
		{
			latitude: 42.86186333,
			longitude: 31.24758667,
		},
		{
			latitude: 42.861875,
			longitude: 31.24763167,
		},
		{
			latitude: 42.86187833,
			longitude: 31.24763167,
		},
		{
			latitude: 42.86187,
			longitude: 31.24758833,
		},
		{
			latitude: 42.86187667,
			longitude: 31.24761667,
		},
		{
			latitude: 42.86187167,
			longitude: 31.24761833,
		},
		{
			latitude: 42.86188333,
			longitude: 31.24761,
		},
		{
			latitude: 42.86188,
			longitude: 31.24760833,
		},
		{
			latitude: 42.861885,
			longitude: 31.24760333,
		},
		{
			latitude: 42.861875,
			longitude: 31.24762,
		},
		{
			latitude: 42.86187667,
			longitude: 31.24759333,
		},
		{
			latitude: 42.86188333,
			longitude: 31.24760333,
		},
		{
			latitude: 42.86187833,
			longitude: 31.247605,
		},
		{
			latitude: 42.86188167,
			longitude: 31.24760333,
		},
		{
			latitude: 42.86187167,
			longitude: 31.24760167,
		},
		{
			latitude: 42.861875,
			longitude: 31.24760333,
		},
		{
			latitude: 42.86187833,
			longitude: 31.24760667,
		},
		{
			latitude: 42.86188333,
			longitude: 31.247615,
		},
		{
			latitude: 42.861875,
			longitude: 31.24761833,
		},
		{
			latitude: 42.86188,
			longitude: 31.24761833,
		},
		{
			latitude: 42.861875,
			longitude: 31.24761,
		},
		{
			latitude: 42.86187,
			longitude: 31.24761833,
		},
		{
			latitude: 42.86188167,
			longitude: 31.24760333,
		},
		{
			latitude: 42.86187167,
			longitude: 31.24762,
		},
		{
			latitude: 42.86187333,
			longitude: 31.24761833,
		},
		{
			latitude: 42.86187667,
			longitude: 31.24762333,
		},
		{
			latitude: 42.86188,
			longitude: 31.24761333,
		},
		{
			latitude: 42.86187833,
			longitude: 31.24760667,
		},
		{
			latitude: 42.86191833,
			longitude: 31.24746333,
		},
		{
			latitude: 42.86193167,
			longitude: 31.247345,
		},
		{
			latitude: 42.86193333,
			longitude: 31.247385,
		},
		{
			latitude: 42.86193167,
			longitude: 31.24739667,
		},
		{
			latitude: 42.86193,
			longitude: 31.24739833,
		},
		{
			latitude: 42.86192667,
			longitude: 31.24738,
		},
		{
			latitude: 42.86192167,
			longitude: 31.24738,
		},
		{
			latitude: 42.86193,
			longitude: 31.24739,
		},
		{
			latitude: 42.86193,
			longitude: 31.24736833,
		},
		{
			latitude: 42.86193667,
			longitude: 31.24739333,
		},
		{
			latitude: 42.861935,
			longitude: 31.24738833,
		},
		{
			latitude: 42.86192667,
			longitude: 31.2474,
		},
		{
			latitude: 42.861925,
			longitude: 31.247375,
		},
		{
			latitude: 42.861935,
			longitude: 31.24738833,
		},
		{
			latitude: 42.861935,
			longitude: 31.24738833,
		},
		{
			latitude: 42.86192667,
			longitude: 31.24737833,
		},
		{
			latitude: 42.86193333,
			longitude: 31.247385,
		},
		{
			latitude: 42.86193167,
			longitude: 31.247395,
		},
		{
			latitude: 42.86193,
			longitude: 31.24739667,
		},
		{
			latitude: 42.86193333,
			longitude: 31.24739167,
		},
		{
			latitude: 42.86193167,
			longitude: 31.24739833,
		},
		{
			latitude: 42.8618,
			longitude: 31.25132,
		},
		{
			latitude: 42.85246333,
			longitude: 31.25879833,
		},
		{
			latitude: 42.83732667,
			longitude: 31.268045,
		},
		{
			latitude: 42.822495,
			longitude: 31.27693667,
		},
		{
			latitude: 42.80726833,
			longitude: 31.28601167,
		},
		{
			latitude: 42.79177167,
			longitude: 31.29514167,
		},
		{
			latitude: 42.77631333,
			longitude: 31.304325,
		},
		{
			latitude: 42.76082833,
			longitude: 31.31337167,
		},
		{
			latitude: 42.74524,
			longitude: 31.322265,
		},
		{
			latitude: 42.72965667,
			longitude: 31.33140333,
		},
		{
			latitude: 42.72655,
			longitude: 31.33327667,
		},
		{
			latitude: 42.7137,
			longitude: 31.341075,
		},
		{
			latitude: 42.69884167,
			longitude: 31.349895,
		},
		{
			latitude: 42.68337833,
			longitude: 31.358945,
		},
		{
			latitude: 42.66803167,
			longitude: 31.36796333,
		},
		{
			latitude: 42.65264,
			longitude: 31.37695333,
		},
		{
			latitude: 42.63736667,
			longitude: 31.38655333,
		},
		{
			latitude: 42.62188833,
			longitude: 31.39710667,
		},
		{
			latitude: 42.60684833,
			longitude: 31.40739667,
		},
		{
			latitude: 42.58363167,
			longitude: 31.42298833,
		},
		{
			latitude: 42.577255,
			longitude: 31.42736333,
		},
		{
			latitude: 42.55333,
			longitude: 31.44347167,
		},
		{
			latitude: 42.54693667,
			longitude: 31.44776167,
		},
		{
			latitude: 42.44,
			longitude: 31.52,
		},
		{
			latitude: 42.41166667,
			longitude: 31.53666667,
		},
		{
			latitude: 41.945,
			longitude: 31.83833333,
		},
		{
			latitude: 41.78748667,
			longitude: 31.93047667,
		},
		{
			latitude: 41.74184167,
			longitude: 31.96049333,
		},
		{
			latitude: 41.72728667,
			longitude: 31.97030333,
		},
		{
			latitude: 41.713455,
			longitude: 31.97876,
		},
		{
			latitude: 41.69234,
			longitude: 31.990795,
		},
		{
			latitude: 41.62937667,
			longitude: 32.03063333,
		},
		{
			latitude: 41.58626,
			longitude: 32.06829833,
		},
		{
			latitude: 41.58666667,
			longitude: 32.06666667,
		},
		{
			latitude: 41.58666667,
			longitude: 32.06666667,
		},
		{
			latitude: 41.58666667,
			longitude: 32.06666667,
		},
		{
			latitude: 41.58666667,
			longitude: 32.06666667,
		},
		{
			latitude: 41.58751167,
			longitude: 32.06802333,
		},
		{
			latitude: 41.59033667,
			longitude: 32.07082667,
		},
		{
			latitude: 41.59147,
			longitude: 32.06704167,
		},
		{
			latitude: 41.59483333,
			longitude: 32.05673667,
		},
		{
			latitude: 41.63785167,
			longitude: 32.03015667,
		},
		{
			latitude: 41.64291167,
			longitude: 32.02740833,
		},
		{
			latitude: 41.68893167,
			longitude: 32.002905,
		},
		{
			latitude: 41.73171667,
			longitude: 31.97821167,
		},
		{
			latitude: 41.74185,
			longitude: 31.97217,
		},
		{
			latitude: 41.75833333,
			longitude: 31.96166667,
		},
		{
			latitude: 42.17449333,
			longitude: 31.687435,
		},
		{
			latitude: 42.20166667,
			longitude: 31.66833333,
		},
		{
			latitude: 42.26666667,
			longitude: 31.625,
		},
		{
			latitude: 42.47945833,
			longitude: 31.48935167,
		},
		{
			latitude: 42.51395667,
			longitude: 31.46820667,
		},
		{
			latitude: 42.52081667,
			longitude: 31.46400333,
		},
		{
			latitude: 42.53554,
			longitude: 31.45494833,
		},
		{
			latitude: 42.55130667,
			longitude: 31.44532,
		},
		{
			latitude: 42.56804167,
			longitude: 31.43503667,
		},
		{
			latitude: 42.58325833,
			longitude: 31.42578167,
		},
		{
			latitude: 42.59949667,
			longitude: 31.41596333,
		},
		{
			latitude: 42.614135,
			longitude: 31.40692,
		},
		{
			latitude: 42.63025667,
			longitude: 31.396855,
		},
		{
			latitude: 42.64650333,
			longitude: 31.386735,
		},
		{
			latitude: 42.66124167,
			longitude: 31.37745667,
		},
		{
			latitude: 42.67901,
			longitude: 31.36646,
		},
		{
			latitude: 42.69258,
			longitude: 31.35816333,
		},
		{
			latitude: 42.70830833,
			longitude: 31.34863667,
		},
		{
			latitude: 42.723745,
			longitude: 31.33858167,
		},
		{
			latitude: 42.73148167,
			longitude: 31.33361333,
		},
		{
			latitude: 42.74064667,
			longitude: 31.32731,
		},
		{
			latitude: 42.75428667,
			longitude: 31.31748333,
		},
		{
			latitude: 42.76927,
			longitude: 31.30657833,
		},
		{
			latitude: 42.78433667,
			longitude: 31.29566,
		},
		{
			latitude: 42.79951167,
			longitude: 31.28473167,
		},
		{
			latitude: 42.81524167,
			longitude: 31.27367,
		},
		{
			latitude: 42.83062,
			longitude: 31.26353833,
		},
		{
			latitude: 42.84631167,
			longitude: 31.25399,
		},
		{
			latitude: 42.85950833,
			longitude: 31.24718167,
		},
		{
			latitude: 42.862145,
			longitude: 31.24842,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24836167,
		},
		{
			latitude: 42.86157167,
			longitude: 31.24819333,
		},
		{
			latitude: 42.86113,
			longitude: 31.24800667,
		},
		{
			latitude: 42.860675,
			longitude: 31.24800167,
		},
		{
			latitude: 42.860675,
			longitude: 31.248005,
		},
		{
			latitude: 42.860675,
			longitude: 31.248005,
		},
		{
			latitude: 42.86064,
			longitude: 31.24798667,
		},
		{
			latitude: 42.86064333,
			longitude: 31.247985,
		},
		{
			latitude: 42.86064167,
			longitude: 31.247985,
		},
		{
			latitude: 42.86064167,
			longitude: 31.24798667,
		},
		{
			latitude: 42.86064,
			longitude: 31.24798667,
		},
		{
			latitude: 42.860635,
			longitude: 31.24798333,
		},
		{
			latitude: 42.86064167,
			longitude: 31.24798667,
		},
		{
			latitude: 42.86063667,
			longitude: 31.247985,
		},
		{
			latitude: 42.86064333,
			longitude: 31.24798333,
		},
		{
			latitude: 42.860635,
			longitude: 31.24798333,
		},
		{
			latitude: 42.86063667,
			longitude: 31.24798667,
		},
		{
			latitude: 42.86064,
			longitude: 31.24798333,
		},
		{
			latitude: 42.86064167,
			longitude: 31.24798667,
		},
		{
			latitude: 42.86088,
			longitude: 31.24783,
		},
		{
			latitude: 42.86135833,
			longitude: 31.24749,
		},
		{
			latitude: 42.86168333,
			longitude: 31.24725833,
		},
		{
			latitude: 42.86168167,
			longitude: 31.24726333,
		},
		{
			latitude: 42.86168333,
			longitude: 31.24726167,
		},
		{
			latitude: 42.86183333,
			longitude: 31.24719333,
		},
		{
			latitude: 42.86185333,
			longitude: 31.24717833,
		},
		{
			latitude: 42.86185,
			longitude: 31.24718,
		},
		{
			latitude: 42.86205333,
			longitude: 31.24661167,
		},
		{
			latitude: 42.86212,
			longitude: 31.2464,
		},
		{
			latitude: 42.86216667,
			longitude: 31.246295,
		},
		{
			latitude: 42.86216,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86216167,
			longitude: 31.24629667,
		},
		{
			latitude: 42.86216,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86216333,
			longitude: 31.24629667,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86216167,
			longitude: 31.24629667,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215833,
			longitude: 31.246295,
		},
		{
			latitude: 42.86216,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215833,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629667,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86216333,
			longitude: 31.24629667,
		},
		{
			latitude: 42.86216,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86216333,
			longitude: 31.24629833,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215833,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86216,
			longitude: 31.246295,
		},
		{
			latitude: 42.86216,
			longitude: 31.246295,
		},
		{
			latitude: 42.86216,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86216,
			longitude: 31.2463,
		},
		{
			latitude: 42.86216,
			longitude: 31.246295,
		},
		{
			latitude: 42.86216167,
			longitude: 31.24629667,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215667,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215667,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86216,
			longitude: 31.246295,
		},
		{
			latitude: 42.862155,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215833,
			longitude: 31.246295,
		},
		{
			latitude: 42.86216,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215667,
			longitude: 31.246295,
		},
		{
			latitude: 42.86216333,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215167,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86216,
			longitude: 31.24629667,
		},
		{
			latitude: 42.86216167,
			longitude: 31.246295,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86216,
			longitude: 31.24629167,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215333,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629,
		},
		{
			latitude: 42.86215333,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215167,
			longitude: 31.24629,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215167,
			longitude: 31.24628833,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629333,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.862155,
			longitude: 31.24628833,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215333,
			longitude: 31.24629,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629333,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629333,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.862155,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24628833,
		},
		{
			latitude: 42.862155,
			longitude: 31.24628833,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629,
		},
		{
			latitude: 42.86216,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86215833,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86216,
			longitude: 31.24629333,
		},
		{
			latitude: 42.86215833,
			longitude: 31.246295,
		},
		{
			latitude: 42.86215667,
			longitude: 31.24629167,
		},
		{
			latitude: 42.86213,
			longitude: 31.24640167,
		},
		{
			latitude: 42.86200667,
			longitude: 31.24683,
		},
		{
			latitude: 42.86200833,
			longitude: 31.24683167,
		},
		{
			latitude: 42.86200667,
			longitude: 31.24683167,
		},
		{
			latitude: 42.86196,
			longitude: 31.24682833,
		},
		{
			latitude: 42.86158167,
			longitude: 31.24718333,
		},
		{
			latitude: 42.86113667,
			longitude: 31.24758667,
		},
		{
			latitude: 42.86084,
			longitude: 31.24785667,
		},
		{
			latitude: 42.86084167,
			longitude: 31.24785333,
		},
		{
			latitude: 42.86084333,
			longitude: 31.247855,
		},
		{
			latitude: 42.86084333,
			longitude: 31.24785667,
		},
		{
			latitude: 42.86084,
			longitude: 31.247855,
		},
		{
			latitude: 42.86084167,
			longitude: 31.24785833,
		},
		{
			latitude: 42.860845,
			longitude: 31.24785833,
		},
		{
			latitude: 42.86084,
			longitude: 31.24785333,
		},
		{
			latitude: 42.860835,
			longitude: 31.24785,
		},
		{
			latitude: 42.86083667,
			longitude: 31.24785167,
		},
		{
			latitude: 42.86083667,
			longitude: 31.24785333,
		},
		{
			latitude: 42.86083833,
			longitude: 31.24785333,
		},
		{
			latitude: 42.86083833,
			longitude: 31.24785167,
		},
		{
			latitude: 42.86083833,
			longitude: 31.24785333,
		},
		{
			latitude: 42.861275,
			longitude: 31.247515,
		},
		{
			latitude: 42.861525,
			longitude: 31.24731667,
		},
		{
			latitude: 42.86174167,
			longitude: 31.247145,
		},
		{
			latitude: 42.86204833,
			longitude: 31.246905,
		},
		{
			latitude: 42.86204833,
			longitude: 31.246905,
		},
		{
			latitude: 42.86218,
			longitude: 31.24679833,
		},
		{
			latitude: 42.86255833,
			longitude: 31.24651,
		},
		{
			latitude: 42.862555,
			longitude: 31.246505,
		},
		{
			latitude: 42.86255833,
			longitude: 31.24651,
		},
		{
			latitude: 42.862555,
			longitude: 31.24650833,
		},
		{
			latitude: 42.86255333,
			longitude: 31.24650833,
		},
		{
			latitude: 42.862555,
			longitude: 31.24650833,
		},
		{
			latitude: 42.86255667,
			longitude: 31.24651,
		},
		{
			latitude: 42.86255667,
			longitude: 31.24650833,
		},
		{
			latitude: 42.862555,
			longitude: 31.24650833,
		},
		{
			latitude: 42.862555,
			longitude: 31.24650833,
		},
		{
			latitude: 42.862555,
			longitude: 31.24651,
		},
		{
			latitude: 42.86255667,
			longitude: 31.24651167,
		},
		{
			latitude: 42.86255667,
			longitude: 31.24651167,
		},
		{
			latitude: 42.862555,
			longitude: 31.24651167,
		},
		{
			latitude: 42.862555,
			longitude: 31.24651333,
		},
		{
			latitude: 42.86255667,
			longitude: 31.24651,
		},
		{
			latitude: 42.8622,
			longitude: 31.24679333,
		},
		{
			latitude: 42.862085,
			longitude: 31.246875,
		},
		{
			latitude: 42.86208667,
			longitude: 31.24687667,
		},
		{
			latitude: 42.86206,
			longitude: 31.246885,
		},
		{
			latitude: 42.86206333,
			longitude: 31.24688667,
		},
		{
			latitude: 42.86190667,
			longitude: 31.24701,
		},
		{
			latitude: 42.86175,
			longitude: 31.24713167,
		},
		{
			latitude: 42.86142167,
			longitude: 31.24739667,
		},
		{
			latitude: 42.860915,
			longitude: 31.24779667,
		},
		{
			latitude: 42.86089,
			longitude: 31.24780333,
		},
		{
			latitude: 42.86088833,
			longitude: 31.24780333,
		},
		{
			latitude: 42.86089333,
			longitude: 31.247805,
		},
		{
			latitude: 42.86089333,
			longitude: 31.247805,
		},
		{
			latitude: 42.86089333,
			longitude: 31.24780333,
		},
		{
			latitude: 42.860895,
			longitude: 31.24780667,
		},
		{
			latitude: 42.86089333,
			longitude: 31.24780333,
		},
		{
			latitude: 42.86089333,
			longitude: 31.24780333,
		},
		{
			latitude: 42.86089333,
			longitude: 31.24780333,
		},
		{
			latitude: 42.860895,
			longitude: 31.247805,
		},
		{
			latitude: 42.86089333,
			longitude: 31.24780333,
		},
		{
			latitude: 42.86089167,
			longitude: 31.24780167,
		},
		{
			latitude: 42.86089667,
			longitude: 31.24780667,
		},
		{
			latitude: 42.86089667,
			longitude: 31.24780667,
		},
		{
			latitude: 42.86089,
			longitude: 31.24780167,
		},
		{
			latitude: 42.86089167,
			longitude: 31.24780167,
		},
		{
			latitude: 42.86089167,
			longitude: 31.24780333,
		},
		{
			latitude: 42.86089167,
			longitude: 31.24780333,
		},
		{
			latitude: 42.860895,
			longitude: 31.247805,
		},
		{
			latitude: 42.86089,
			longitude: 31.24780167,
		},
		{
			latitude: 42.86089,
			longitude: 31.24780333,
		},
		{
			latitude: 42.86089,
			longitude: 31.24780167,
		},
		{
			latitude: 42.86089167,
			longitude: 31.24780167,
		},
		{
			latitude: 42.86089667,
			longitude: 31.24780667,
		},
		{
			latitude: 42.860895,
			longitude: 31.24780667,
		},
		{
			latitude: 42.86089333,
			longitude: 31.247805,
		},
		{
			latitude: 42.860895,
			longitude: 31.247805,
		},
		{
			latitude: 42.86088833,
			longitude: 31.24780167,
		},
		{
			latitude: 42.86089167,
			longitude: 31.247805,
		},
		{
			latitude: 42.860995,
			longitude: 31.24772667,
		},
		{
			latitude: 42.86123833,
			longitude: 31.24753833,
		},
		{
			latitude: 42.86146667,
			longitude: 31.24736,
		},
		{
			latitude: 42.861675,
			longitude: 31.24719333,
		},
		{
			latitude: 42.86167167,
			longitude: 31.24719167,
		},
		{
			latitude: 42.86167667,
			longitude: 31.247195,
		},
		{
			latitude: 42.86180833,
			longitude: 31.246795,
		},
		{
			latitude: 42.86186667,
			longitude: 31.24664,
		},
		{
			latitude: 42.861865,
			longitude: 31.24664,
		},
		{
			latitude: 42.861865,
			longitude: 31.24664167,
		},
		{
			latitude: 42.86201167,
			longitude: 31.24698667,
		},
		{
			latitude: 42.86199667,
			longitude: 31.24700167,
		},
		{
			latitude: 42.861995,
			longitude: 31.24700167,
		},
		{
			latitude: 42.861985,
			longitude: 31.246995,
		},
		{
			latitude: 42.86198333,
			longitude: 31.246995,
		},
		{
			latitude: 42.86198333,
			longitude: 31.246995,
		},
		{
			latitude: 42.861985,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86198333,
			longitude: 31.246995,
		},
		{
			latitude: 42.86198333,
			longitude: 31.246995,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699667,
		},
		{
			latitude: 42.861985,
			longitude: 31.24699333,
		},
		{
			latitude: 42.861985,
			longitude: 31.246995,
		},
		{
			latitude: 42.861985,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86198333,
			longitude: 31.246995,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86198667,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86198333,
			longitude: 31.246995,
		},
		{
			latitude: 42.86198333,
			longitude: 31.246995,
		},
		{
			latitude: 42.86198333,
			longitude: 31.246995,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86198333,
			longitude: 31.246995,
		},
		{
			latitude: 42.86198667,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24699667,
		},
		{
			latitude: 42.861985,
			longitude: 31.246995,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699333,
		},
		{
			latitude: 42.861985,
			longitude: 31.24674833,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198667,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24675,
		},
		{
			latitude: 42.861985,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24674667,
		},
		{
			latitude: 42.861985,
			longitude: 31.24674833,
		},
		{
			latitude: 42.861985,
			longitude: 31.24674667,
		},
		{
			latitude: 42.861985,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198667,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24674667,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24675333,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24675167,
		},
		{
			latitude: 42.86199,
			longitude: 31.24675,
		},
		{
			latitude: 42.86199333,
			longitude: 31.246755,
		},
		{
			latitude: 42.86199,
			longitude: 31.24675333,
		},
		{
			latitude: 42.86199,
			longitude: 31.24675333,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24675167,
		},
		{
			latitude: 42.86199,
			longitude: 31.24675333,
		},
		{
			latitude: 42.86198667,
			longitude: 31.24675333,
		},
		{
			latitude: 42.86199,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24675333,
		},
		{
			latitude: 42.86198667,
			longitude: 31.24675167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24674667,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24674833,
		},
		{
			latitude: 42.861985,
			longitude: 31.24674833,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24675167,
		},
		{
			latitude: 42.86198667,
			longitude: 31.24675167,
		},
		{
			latitude: 42.86198667,
			longitude: 31.24675333,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24675333,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24675167,
		},
		{
			latitude: 42.86199,
			longitude: 31.24675333,
		},
		{
			latitude: 42.861985,
			longitude: 31.24674833,
		},
		{
			latitude: 42.861985,
			longitude: 31.24675333,
		},
		{
			latitude: 42.86198833,
			longitude: 31.246755,
		},
		{
			latitude: 42.861985,
			longitude: 31.24674833,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24675,
		},
		{
			latitude: 42.861985,
			longitude: 31.24675,
		},
		{
			latitude: 42.861985,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24674333,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24674667,
		},
		{
			latitude: 42.86198,
			longitude: 31.24674667,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24674667,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24674833,
		},
		{
			latitude: 42.861985,
			longitude: 31.24674833,
		},
		{
			latitude: 42.86198667,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198,
			longitude: 31.24674333,
		},
		{
			latitude: 42.861985,
			longitude: 31.24675167,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24674667,
		},
		{
			latitude: 42.86198,
			longitude: 31.24674833,
		},
		{
			latitude: 42.861985,
			longitude: 31.24675,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24674833,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24674833,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24686833,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24699333,
		},
		{
			latitude: 42.861985,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86199333,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24699,
		},
		{
			latitude: 42.86199333,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86199,
			longitude: 31.24698833,
		},
		{
			latitude: 42.86199167,
			longitude: 31.24699,
		},
		{
			latitude: 42.86199167,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86199167,
			longitude: 31.24699,
		},
		{
			latitude: 42.86199,
			longitude: 31.24699,
		},
		{
			latitude: 42.86198833,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86199,
			longitude: 31.24698833,
		},
		{
			latitude: 42.86199167,
			longitude: 31.24699333,
		},
		{
			latitude: 42.86199167,
			longitude: 31.24699,
		},
		{
			latitude: 42.86199333,
			longitude: 31.246995,
		},
		{
			latitude: 42.86199167,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86199,
			longitude: 31.24699,
		},
		{
			latitude: 42.86193167,
			longitude: 31.246995,
		},
		{
			latitude: 42.86180833,
			longitude: 31.24698667,
		},
		{
			latitude: 42.86181333,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86181333,
			longitude: 31.24699167,
		},
		{
			latitude: 42.86148667,
			longitude: 31.24746,
		},
		{
			latitude: 42.86111833,
			longitude: 31.248,
		},
		{
			latitude: 42.861045,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104833,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86105,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24810833,
		},
		{
			latitude: 42.861045,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24810667,
		},
		{
			latitude: 42.86104833,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24810833,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811,
		},
		{
			latitude: 42.861045,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811333,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24810833,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24810833,
		},
		{
			latitude: 42.86104833,
			longitude: 31.24811333,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811167,
		},
		{
			latitude: 42.861045,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24810833,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104333,
			longitude: 31.248105,
		},
		{
			latitude: 42.861045,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811,
		},
		{
			latitude: 42.861045,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104167,
			longitude: 31.248105,
		},
		{
			latitude: 42.861045,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24810833,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24811,
		},
		{
			latitude: 42.861045,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24811,
		},
		{
			latitude: 42.861045,
			longitude: 31.24811,
		},
		{
			latitude: 42.861045,
			longitude: 31.24810833,
		},
		{
			latitude: 42.86104167,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104167,
			longitude: 31.24810667,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24810833,
		},
		{
			latitude: 42.86104167,
			longitude: 31.248105,
		},
		{
			latitude: 42.861045,
			longitude: 31.24811333,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811,
		},
		{
			latitude: 42.86104333,
			longitude: 31.24810833,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24811167,
		},
		{
			latitude: 42.86104667,
			longitude: 31.24810833,
		},
		{
			latitude: 42.86115,
			longitude: 31.248,
		},
		{
			latitude: 42.86146333,
			longitude: 31.24764,
		},
		{
			latitude: 42.86147667,
			longitude: 31.24761333,
		},
		{
			latitude: 42.86159667,
			longitude: 31.24748167,
		},
		{
			latitude: 42.86159667,
			longitude: 31.24748167,
		},
		{
			latitude: 42.86159667,
			longitude: 31.24748167,
		},
		{
			latitude: 42.861595,
			longitude: 31.24748,
		},
		{
			latitude: 42.861595,
			longitude: 31.24748167,
		},
		{
			latitude: 42.861615,
			longitude: 31.24746833,
		},
		{
			latitude: 42.861925,
			longitude: 31.24712,
		},
		{
			latitude: 42.862,
			longitude: 31.24702,
		},
		{
			latitude: 42.861985,
			longitude: 31.24700667,
		},
		{
			latitude: 42.86198,
			longitude: 31.24699667,
		},
		{
			latitude: 42.86198167,
			longitude: 31.247,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198167,
			longitude: 31.247,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86198333,
			longitude: 31.247,
		},
		{
			latitude: 42.86198333,
			longitude: 31.247,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198167,
			longitude: 31.247,
		},
		{
			latitude: 42.86198167,
			longitude: 31.247,
		},
		{
			latitude: 42.86198333,
			longitude: 31.247,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.247,
		},
		{
			latitude: 42.86198167,
			longitude: 31.247,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198167,
			longitude: 31.247,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198333,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86198167,
			longitude: 31.247,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86198167,
			longitude: 31.247,
		},
		{
			latitude: 42.86198333,
			longitude: 31.247,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198,
			longitude: 31.247,
		},
		{
			latitude: 42.86198167,
			longitude: 31.247,
		},
		{
			latitude: 42.86198,
			longitude: 31.247,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24700167,
		},
		{
			latitude: 42.86198167,
			longitude: 31.24700333,
		},
		{
			latitude: 42.86198,
			longitude: 31.24699833,
		},
		{
			latitude: 42.86182667,
			longitude: 31.24722833,
		},
		{
			latitude: 42.86180333,
			longitude: 31.24727167,
		},
		{
			latitude: 42.86181333,
			longitude: 31.24726667,
		},
		{
			latitude: 42.86161833,
			longitude: 31.247405,
		},
		{
			latitude: 42.86112667,
			longitude: 31.24772333,
		},
		{
			latitude: 42.860805,
			longitude: 31.24794333,
		},
		{
			latitude: 42.860805,
			longitude: 31.24794333,
		},
		{
			latitude: 42.86080667,
			longitude: 31.24794333,
		},
		{
			latitude: 42.860805,
			longitude: 31.24794167,
		},
		{
			latitude: 42.86081167,
			longitude: 31.24794167,
		},
		{
			latitude: 42.86080833,
			longitude: 31.24794167,
		},
		{
			latitude: 42.86080667,
			longitude: 31.24794,
		},
		{
			latitude: 42.86081167,
			longitude: 31.24794333,
		},
		{
			latitude: 42.86081,
			longitude: 31.24794167,
		},
		{
			latitude: 42.860805,
			longitude: 31.24793833,
		},
		{
			latitude: 42.86080833,
			longitude: 31.24794167,
		},
		{
			latitude: 42.860805,
			longitude: 31.24794,
		},
		{
			latitude: 42.860805,
			longitude: 31.24794333,
		},
		{
			latitude: 42.860805,
			longitude: 31.24793833,
		},
		{
			latitude: 42.86080167,
			longitude: 31.24793333,
		},
		{
			latitude: 42.86077833,
			longitude: 31.24792333,
		},
		{
			latitude: 42.86060833,
			longitude: 31.24804667,
		},
		{
			latitude: 42.856315,
			longitude: 31.25570833,
		},
		{
			latitude: 42.85056833,
			longitude: 31.26552833,
		},
		{
			latitude: 42.84566333,
			longitude: 31.27385833,
		},
		{
			latitude: 42.840365,
			longitude: 31.28275667,
		},
		{
			latitude: 42.834755,
			longitude: 31.291295,
		},
		{
			latitude: 42.82908167,
			longitude: 31.29972833,
		},
		{
			latitude: 42.82335,
			longitude: 31.30821167,
		},
		{
			latitude: 42.81725167,
			longitude: 31.31708167,
		},
		{
			latitude: 42.81162167,
			longitude: 31.32527833,
		},
		{
			latitude: 42.805495,
			longitude: 31.33334,
		},
		{
			latitude: 42.79980833,
			longitude: 31.34064833,
		},
		{
			latitude: 42.794645,
			longitude: 31.34723167,
		},
		{
			latitude: 42.79261833,
			longitude: 31.34964333,
		},
		{
			latitude: 42.79274167,
			longitude: 31.34975333,
		},
		{
			latitude: 42.79245333,
			longitude: 31.34941833,
		},
		{
			latitude: 42.79204333,
			longitude: 31.34896333,
		},
		{
			latitude: 42.79205333,
			longitude: 31.34896667,
		},
		{
			latitude: 42.79205167,
			longitude: 31.34896667,
		},
		{
			latitude: 42.79204667,
			longitude: 31.34896333,
		},
		{
			latitude: 42.79205167,
			longitude: 31.34896667,
		},
		{
			latitude: 42.79205,
			longitude: 31.34896333,
		},
		{
			latitude: 42.79205167,
			longitude: 31.34896333,
		},
		{
			latitude: 42.79205333,
			longitude: 31.34896833,
		},
		{
			latitude: 42.79205167,
			longitude: 31.34896833,
		},
		{
			latitude: 42.79205167,
			longitude: 31.348965,
		},
		{
			latitude: 42.79205167,
			longitude: 31.348965,
		},
		{
			latitude: 42.79205167,
			longitude: 31.348965,
		},
		{
			latitude: 42.79205333,
			longitude: 31.34896833,
		},
		{
			latitude: 42.79205833,
			longitude: 31.34897167,
		},
		{
			latitude: 42.79200333,
			longitude: 31.348905,
		},
		{
			latitude: 42.79158333,
			longitude: 31.34842667,
		},
		{
			latitude: 42.79116833,
			longitude: 31.34795833,
		},
		{
			latitude: 42.79075333,
			longitude: 31.34748667,
		},
		{
			latitude: 42.79034167,
			longitude: 31.347015,
		},
		{
			latitude: 42.78992833,
			longitude: 31.34654167,
		},
		{
			latitude: 42.78951167,
			longitude: 31.34607,
		},
		{
			latitude: 42.789075,
			longitude: 31.34557333,
		},
		{
			latitude: 42.78866,
			longitude: 31.3451,
		},
		{
			latitude: 42.78827167,
			longitude: 31.34465667,
		},
		{
			latitude: 42.78786167,
			longitude: 31.34418833,
		},
		{
			latitude: 42.78781667,
			longitude: 31.34413833,
		},
		{
			latitude: 42.787815,
			longitude: 31.34413667,
		},
		{
			latitude: 42.787815,
			longitude: 31.34413667,
		},
		{
			latitude: 42.78781667,
			longitude: 31.34414167,
		},
		{
			latitude: 42.78781667,
			longitude: 31.34413833,
		},
		{
			latitude: 42.78781833,
			longitude: 31.34414,
		},
		{
			latitude: 42.787815,
			longitude: 31.34413833,
		},
		{
			latitude: 42.787815,
			longitude: 31.34413833,
		},
		{
			latitude: 42.787815,
			longitude: 31.344135,
		},
		{
			latitude: 42.787815,
			longitude: 31.34413667,
		},
		{
			latitude: 42.787815,
			longitude: 31.34413667,
		},
		{
			latitude: 42.78781667,
			longitude: 31.34413833,
		},
		{
			latitude: 42.78781333,
			longitude: 31.34414,
		},
		{
			latitude: 42.787865,
			longitude: 31.34407,
		},
		{
			latitude: 42.78795667,
			longitude: 31.34394167,
		},
		{
			latitude: 42.78804833,
			longitude: 31.34381,
		},
		{
			latitude: 42.78821667,
			longitude: 31.34357333,
		},
		{
			latitude: 42.788405,
			longitude: 31.34331167,
		},
		{
			latitude: 42.788425,
			longitude: 31.34328667,
		},
		{
			latitude: 42.78842333,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842333,
			longitude: 31.34328667,
		},
		{
			latitude: 42.78842167,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842167,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842333,
			longitude: 31.34328667,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842333,
			longitude: 31.34328667,
		},
		{
			latitude: 42.78842,
			longitude: 31.34327833,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328667,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842333,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842333,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842333,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842333,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842333,
			longitude: 31.343285,
		},
		{
			latitude: 42.788425,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842667,
			longitude: 31.343285,
		},
		{
			latitude: 42.788425,
			longitude: 31.34328333,
		},
		{
			latitude: 42.788425,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842333,
			longitude: 31.343285,
		},
		{
			latitude: 42.788425,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842333,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.788425,
			longitude: 31.34328667,
		},
		{
			latitude: 42.78842333,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842333,
			longitude: 31.34328667,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.788425,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328,
		},
		{
			latitude: 42.78842333,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328,
		},
		{
			latitude: 42.78842167,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842167,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328,
		},
		{
			latitude: 42.78842,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842167,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328,
		},
		{
			latitude: 42.78841333,
			longitude: 31.34327833,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78841833,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78841667,
			longitude: 31.34327833,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328667,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842667,
			longitude: 31.34328667,
		},
		{
			latitude: 42.78842667,
			longitude: 31.34328833,
		},
		{
			latitude: 42.78842667,
			longitude: 31.34329,
		},
		{
			latitude: 42.78842667,
			longitude: 31.34328833,
		},
		{
			latitude: 42.78842667,
			longitude: 31.34329,
		},
		{
			latitude: 42.788425,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842667,
			longitude: 31.34329,
		},
		{
			latitude: 42.78842833,
			longitude: 31.34328833,
		},
		{
			latitude: 42.78842167,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.343285,
		},
		{
			latitude: 42.78841833,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328667,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78841833,
			longitude: 31.34328,
		},
		{
			latitude: 42.78842333,
			longitude: 31.343285,
		},
		{
			latitude: 42.78841833,
			longitude: 31.34327833,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842333,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842333,
			longitude: 31.343285,
		},
		{
			latitude: 42.78842,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78841667,
			longitude: 31.34327667,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328333,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328167,
		},
		{
			latitude: 42.78842167,
			longitude: 31.34328167,
		},
	]
}
